import React, { useEffect, useRef, useState } from "react";
import redtick from "./redtick.png";
import wrong from "./wrong.png";
import DescriptionIcon from "@mui/icons-material/Description";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { FiArrowLeft } from "react-icons/fi";
import api from "../../api/api";
import ToastMessage from "../../utils/muitoast";
import { Backdrop, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { TimePicker } from "rsuite";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "rsuite/dist/rsuite.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faUpload } from "@fortawesome/free-solid-svg-icons";
import ConfirmModal from "./SubmitAlert";
import { v4 as uuidv4 } from "uuid";
import { useSearchParams } from "react-router-dom";
import { draftToFormRow } from "../draftTransformers";
import { isUploadedRef, fileToDataUri, dataUriToFile } from "../draftImageUtils";
import { useFormDraft } from "../useFormDraft";
import SignatureModal from "../Signaturemodal";
import { set } from "date-fns";
import moment from "moment";
const AccidentAndInvesticationForm = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [severity, setSeverity] = useState("success");
  const [open, setOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [showEmpSuggestions, setShowEmpSuggestions] = useState(false);
  const [employeeId, setEmployeeId] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [employeeSuggestions, setEmployeeSuggestions] = useState([]);
  const [selectedempobj, setselectedempobj] = useState({});
  const [suggestions, setSuggestions] = useState([]);
  const [jobCode, setJobCode] = useState("");
  const [selectedJobName, setSelectedJobName] = useState("");
  const [companyTabs, setCompanyTabs] = useState([]); // Replaces 'Tabs'
  const [selectedCompanyId, setSelectedCompanyId] = useState(null); // To store selected company ID
  const jobInputRef = useRef(null);
  const empInputRef = useRef(null);
  const [hoveredJobIndex, setHoveredJobIndex] = useState(null);
  const [hoveredEmpIndex, setHoveredEmpIndex] = useState(null);
  const [ConfirmModalOpen, setConfirmModalOpen] = useState(false);
  const [skipModalOpen, setSkipModalOpen] = useState(false);
  const [signaturemodal, setSignatureModal] = useState(false);
  const [uploadedDiagram, setUploadedDiagram] = useState([]);
  const [employeeStatementImgs, setEmployeeStatementImgs] = useState({});
  const [attachmentFiles, setAttachmentFiles] = useState({});
  // Mobile-app's separate "Attach Relevant Documents" bucket. Local File
  // objects pending upload live in `relevantDocsLocal`; previously-uploaded
  // server records (loaded in edit mode) live in `relevantDocsServer`.
  const [relevantDocsLocal, setRelevantDocsLocal] = useState([]);
  const [relevantDocsServer, setRelevantDocsServer] = useState([]);
  const [searchParams] = useSearchParams();
  const mode = searchParams.get("mode"); // null if not sent
  const id = searchParams.get("id"); // null if not sent
  const [employeeStatementsigns, setemployeestatementssigns] = useState({});
  const [witnessStatementImgs, setWitnessStatementImgs] = useState({});
  const [witnessStatementsigns, setwitnesstatementsigns] = useState({});
  const [supervisorStatementImgs, setSupervisorStatementImgs] = useState({});
  const [supervisorStatementsigns, setsupervisorstatementsigns] = useState({});
  const [photoStatementImgs, setPhotoStatementImgs] = useState({});
  const [employeesignimg, setEmployeeSignImg] = useState(null);
  const [supervisorsignimg, setSupervisorSignImg] = useState(null);
  const type = useRef(""); //tpyes or supervisor,employee,witness,
  const [logEntries, setLogEntries] = useState([
    {
      dateoflog: "",
      start: "",
      end: "",
      job: "",
      location: "",
      gallons: "",
      amount: "",
      milege: "",
    },
  ]);
  const { t, i18n } = useTranslation(["AIF"]);
  const [selectedLanguage, setSelectedLanguage] = useState("en");

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setSelectedLanguage(lang);
  };
  const handleMotorReportChange = (path, value) => {
    setFormData((prev) => {
      const updated = { ...prev.motorVehicleReport };
      const keys = path.split(".");
      let target = updated;

      for (let i = 0; i < keys.length - 1; i++) {
        target = target[keys[i]];
      }
      target[keys[keys.length - 1]] = value;

      return { ...prev, motorVehicleReport: updated };
    });
  };

  const [formData, setFormData] = useState({
    companyId: null,
    emp_Id: null,
    method: "",
    jobNumber: "",
    empname: "",
    date: "",
    imgfiles: [],
    //step-2
    employeename: "",
    employeebadge: "",
    job_description: "",
    phonenumber: "",
    address: "",
    city: "",
    state: "",
    zipcode: "",
    incidentdate: "",
    timeNotified: "",
    department: {
      type: "radio",
      values: ["I&E", "Constructors"],
      selectedValue: "",
    },
    jobtitle: "",
    projectlocation: "",
    directsupervisor: "",
    client: "",
    wheathercondition: "",
    clientbeennotified: {
      type: "radio",
      values: ["Yes", "No"],
      selectedValue: "",
    },
    // Step 3:
    damages: {
      type: "checkbox",
      // Aligned to the mobile app's `damagesOptionMap` (9 values, in the
      // app's display order). Older records may carry legacy labels like
      // "Motor Vechile Accident" or "Environmental Release" — keep
      // backend-side mapping if you need to migrate them.
      options: [
        "Report Only",
        "Medical Treatment",
        "First Aid",
        "Recordable",
        "Lost Time",
        "Property Damage",
        "Near Miss",
        "Motor Vehicle Accident",
        "Environmental Incident",
      ],
      selectedValues: [],
    },
    injuredside: {
      type: "radio",
      // App-aligned: Left, Right, Bilateral, N/A (replaces the old
      // Right/Left/Both/Internal set).
      options: ["Left", "Right", "Bilateral", "N/A"],
      selectedValue: "",
    },
    bodypartsinjuried: {
      type: "checkbox",
      // App-aligned (19 values in the app's order). Dropped from the
      // legacy list: Chin, Ear, Buttocks, Nose, Mouth, Side, Calf, Scalp,
      // Groin, Thigh. Renamed: "Eye" → "Eyes", "Chest/Trunk" → "Chest".
      options: [
        "Head",
        "Face",
        "Eyes",
        "Neck",
        "Shoulder",
        "Arm",
        "Elbow",
        "Wrist",
        "Hand",
        "Finger",
        "Chest",
        "Back",
        "Abdomen",
        "Hip",
        "Leg",
        "Knee",
        "Ankle",
        "Foot",
        "Toe",
        "N/A",
      ],
      selectedValues: [],
    },
    injurytype: {
      type: "dropdown",
      options: [
        "Abrasion",
        "Allergic Reaction",
        "Break/Fracture",
        "Sprain/Strain",
        "Bruise/Contusion",
        "Heat Stress",
        "Chemical Burn",
        "Elec. Burn",
        "Laceration",
        "Heat Burn",
        "Broken Tooth",
        "Head Trauma",
        "Electric Shock",
        "Flash Burn",
        "Insect Bite",
        "Hearing Loss",
        "Eye Irritation",
        "Puncture Wound",
        "Toxic Inhalation/Ingestion",
      ],
      selectedvalue: "",
    },
    enterManually: false,
    incidentDescription: "",
    incidentcause: {
      type: "dropdown",
      options: [
        "Caught Between",
        "Caught In / On",
        "Heat Stress",
        "Exhaustion",
        "Contact With",
        "Chemicals",
        "Overexertion (Lifting or carrying)",
        "Overexertion (Pushing/ pulling)",
        "Repetitive Motion",
        "Struck Against / By",
        "Foreign Body",
        "Welding Flash",
        "Slips/Trips/Falls",
        "Falling Object",
        "High Noise",
        "Equipment/Tool Malfunction",
        "Air borne Contaminants",
        "Mobile Equipment/Fleet Vehicles",
      ],
      selectedvalue: "",
    },
    descriptionofincident: "",
    witnessstatement: "",
    // Default to "Yes" so a Witness 1 card is visible on first render
    // (mirrors the mobile app). Picking "No" hides the witness cards and
    // the "+" add button entirely.
    anyWitness: "Yes",
    witnessCards: [{ name: "", phone: "" }],
    witnessSummary: "",
    postaccidentua: {
      type: "checkbox",
      // "N/A" is mutually exclusive with the "required" option. The default
      // selection mirrors the app's behavior: testing is required unless
      // the user explicitly toggles N/A.
      options: ["Post-accident drug/alcohol test required", "N/A"],
      selectedValues: ["Post-accident drug/alcohol test required"],
    },
    testtype: {
      type: "Checkbox",
      options: ["Non-Dot", "Dot"],
      selectedValue: "Non-Dot",
    },
    facility: "",
    collector: "",
    // Repeatable Testing Information entries (mirrors the mobile app's
    // `testingInformationList`). Each entry captures facility / collector /
    // testType. Legacy single facility/collector/testtype above are kept only
    // for backward-compatible hydration.
    testingInformationList: [
      { facility: "", collector: "", testType: "Non-Dot" },
    ],
    employeeInformationList: [
      { employeeName: "", employeePhoneNumber: "" },
    ],
    attachments: {
      type: "checkbox",
      // Mirrors the mobile app's four named attachment categories.
      // The mobile's separate "Attach Relevant Documents" upload section
      // (with its own `uploadedDocs` state) is rendered below the checkbox
      // list as an always-visible section — not as a fifth checkbox.
      options: [
        "Pictures",
        "Additional Drawing/Diagrams",
        "JSA",
        "Incident Pictures (Re-enactment if possible)",
      ],
      selectedvalues: [],
      Files: {
        Pictures: [],
        "Additional Drawing/Diagrams": [],
        JSA: [],
        "Incident Pictures (Re-enactment if possible)": [],
      },
    },
    incidentsummary: "",
    employeenameprint: "",
    employeenameprintsignature: "",
    employeenameprintsignaturedate: "",
    supervisornameprint: "",
    supervisorprintsignature: "",
    supervisorprintsignaturedate: "",
    employeeStatementImgs: {},
    witnessStatementImgs: {},
    supervisorStatementImgs: {},
    employeeStatementSigs: {},
    witnessStatementSigs: {},
    supervisorStatementSigs: {},
    photoStatementImgs: {},
    employeeStatements: [
      {
        id: uuidv4(),
        jobTitle: "",
        timeInCraft: "",
        timeOnJobsite: "",
        description: "",
        name: "",
        signature: "",
        date: "",
      },
    ],
    witnessStatements: [
      {
        id: uuidv4(),
        jobTitle: "",
        timeInCraft: "",
        timeOnJobsite: "",
        description: "",
        name: "",
        signature: "",
        date: "",
      },
    ],
    // Supervisor Statement — its own repeatable section (mirrors mobile's
    // `supervisorStatements`). Same shape as a witness statement.
    supervisorStatements: [
      {
        id: uuidv4(),
        jobTitle: "",
        timeInCraft: "",
        timeOnJobsite: "",
        description: "",
        name: "",
        signature: "",
        date: "",
      },
    ],
    photoStatements: [
      {
        id: uuidv4(),
        photoNo: "",
        photoDate: "",
        timeOfDay: "",
        location: "",
        description: "",
        notes: "",
        photographer: "",
      },
    ],
    isSkipVechileAccident: false,
    additionalNote: "",
    motorVehicleReport: {
      driverName: "",
      isDriverApproved: "", // "YES" or "NO"
      diagramimg: "",
      licenseNumber: "",
      issuingState: "",
      licenseExpiration: "",
      vehicleType: {
        ntactVehicle: false,
        ntactLeased: false,
        mobileEquipment: false,
      },
      vehicleDetails: {
        make: "",
        model: "",
        unitNumber: "",
        serialNumber: "",
        damageEstimate: "",
      },
      incidentDetails: {
        weatherConditions: "",
        speed: {
          employee: "",
          other: "",
          posted: "",
        },
        nonEmployeeInjuries: "",
        propertyDamage: "",
        incidentDescription: "",
      },
    },
    causalFactorsForm: {
      proceduresProgramsManagement: {
        type: "checkbox",
        options: [
          "Lack of / Inadequate procedures",
          "Lack of training related to modification changes",
          "Lack of skill demonstration / competency",
          "Extended periods between knowledge use",
          "Improper decision-making or lack of judgment",
          "Lack of / Inadequate labeling",
          "Lack of / Inadequate displays",
          "Lack of / Inadequate controls",
          "Incorrect installation",
          "Not fit for duty (impaired or fatigued)",
          "Not fit for duty (distracted / mind off task)",
          "Stress / frustration / complacency",
          "Intentional violation",
          "Pace of work",
          "PPE used or worn incorrectly",
          "Required PPE not used",
          "Lack of / Inadequate care or Inspection of PPE",
          "Overexertion / improper posture / repetitive motion / contact stress",
          "Lack of specifications or standards",
          "Failure to follow manufacturer recommendations",
          "Lack of / Inadequate MOC",
          "Lack of / Inadequate hazard analysis",
          "Lack of / Inadequate PSSR",
          "Lack of / Inadequate program",
          "Program misunderstood or not followed",
          "Lack of / Inadequate critical information",
        ],
        selectedValues: [],
      },
      humanFactors: {
        type: "checkbox",
        options: [
          "Lack of / Inadequate experience",
          "Procedure available but not used",
          "Procedure difficult to use",
          "Procedure not required but should be",
          "Procedure misunderstood or followed incorrectly",
          "Training not available",
          "Training misunderstood or not followed",
          "Lack of / Inadequate training materials",
        ],
        selectedValues: [],
      },
      workDirectionCommunication: {
        type: "checkbox",
        options: [
          "Lack of / Inadequate work control or permitting",
          "Lack of / Inadequate pre-job JSA",
          "Lack of proper PPE demonstration / competency",
          "Lack of / Inadequate work instructions",
          "Lack of / Inadequate job preparation",
          "Lack of / Inadequate SIMOPS",
          "Noise interference",
          "Improper loading or lifting (instability / miscalculation)",
          "Improper positioning (line of fire)",
          "Improper use of tools, equipment, or materials",
          "Inadequate energy isolation (LOTO)",
          "Lack of / Inadequate inspection, sampling, or monitoring",
          "Improperly secured load",
          "Language barrier",
          "Ineffective control of tools/equipment at heights",
          "Lack of / Inadequate supervision",
          "Failure to report or learn from events",
          "Leadership culture",
          "Standard terminology not used",
          "Lack of / Inadequate verbal or signal confirmation",
          "Late or conflicting communication",
        ],
        selectedValues: [],
      },
      workEnvironment: {
        type: "checkbox",
        options: [
          "Inadequate lighting",
          "Weather / acts of nature",
          "Equipment or materials unsecured",
          "Congestion or restricted movement",
          "Lack of / Inadequate guards",
          "Defective or inadequate tools/equipment",
          "Inadequate surfaces, floors, walkways, or roads",
          "Disorderly work area",
          "Scrap, debris, or loose materials",
          "Hazardous atmosphere or substance",
          "Temperature exposure",
          "Prior soil contamination",
        ],
        selectedValues: [],
      },
      transportation: {
        type: "checkbox",
        options: [
          "Improper speed",
          "Misuse of vehicle",
          "Driver error",
          "Lack of maintenance or inspection",
          "Mobile phone use",
          "Failure to follow laws or postings",
          "Failure to conduct a 360° walk-around",
          "Lack of / Inadequate cargo securement or distribution",
          "Road conditions or hazards",
          "Backing incident",
          "Faulty or defective equipment",
          "Unsuitable equipment",
        ],
        selectedValues: [],
      },
      lessonsLearned: {
        key_lessons: "",
      },
      correctiveActions: {
        immediate_action_details: "",
        target_completion_date: "",
      },
    },
  });

  const handleDiagramUpload = (e) => {
    const file = e.target.files[0]; // Only handle single image
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setUploadedDiagram([{ file, previewUrl }]);
    }
  };

  const removeUploadedDiagram = () => {
    setUploadedDiagram([]);
  };

  const handleDeletePhotoStatement = (indexToDelete) => {
    if (formData.photoStatements.length === 1) return;
    const updated = formData.photoStatements.filter(
      (_, i) => i !== indexToDelete,
    );
    setFormData({ ...formData, photoStatements: updated });
  };
  const handleWitnessImageUpload = (e, index) => {
    const files = Array.from(e.target.files);
    setWitnessStatementImgs((prev) => ({
      ...prev,
      [index]: [...(prev[index] || []), ...files],
    }));
  };

  const updatePhotoField = (index, field, value) => {
    const updated = [...formData.photoStatements];
    updated[index][field] = value;
    setFormData({ ...formData, photoStatements: updated });
  };
  const handleAddPhotoStatement = () => {
    const newId = uuidv4();

    // Update formData
    setFormData((prev) => ({
      ...prev,
      photoStatements: [
        ...prev.photoStatements,
        {
          id: newId, // <== Make sure you add this!
          photoNo: "",
          photoDate: "",
          timeOfDay: "",
          location: "",
          description: "",
          notes: "",
          photographer: "",
        },
      ],
    }));

    // Initialize empty image array for new statement ID
    setPhotoStatementImgs((prevImgs) => ({
      ...prevImgs,
      [newId]: [],
    }));
  };

  const handleDeleteUploadedImage = (index, uniqueKey) => {
    setEmployeeStatementImgs((prev) => {
      const updated = { ...prev };
      updated[index] = updated[index].filter(
        (img) => img.uniqueKey !== uniqueKey,
      );
      return updated;
    });
  };

  const handleAddEmployeeStatement = () => {
    const newId = uuidv4();
    setFormData((prev) => ({
      ...prev,
      employeeStatements: [
        ...prev.employeeStatements,
        {
          id: newId,
          jobTitle: "",
          timeInCraft: "",
          timeOnJobsite: "",
          description: "",
          name: "",
          signature: "",
          date: "",
        },
      ],
    }));
  };
  const handleAddWitnessStatement = () => {
    const newId = uuidv4();
    setFormData((prev) => ({
      ...prev,
      witnessStatements: [
        ...prev.witnessStatements,
        {
          id: newId,
          jobTitle: "",
          timeInCraft: "",
          timeOnJobsite: "",
          description: "",
          name: "",
          signature: "",
          date: "",
        },
      ],
    }));
  };

  // --- Testing Information (repeatable) -------------------------------------
  const handleAddTestingInfo = () => {
    setFormData((prev) => ({
      ...prev,
      testingInformationList: [
        ...(prev.testingInformationList || []),
        { facility: "", collector: "", testType: "Non-Dot" },
      ],
    }));
  };
  const handleRemoveTestingInfo = (index) => {
    setFormData((prev) => {
      const list = prev.testingInformationList || [];
      if (list.length <= 1) return prev; // keep at least one
      return {
        ...prev,
        testingInformationList: list.filter((_, i) => i !== index),
      };
    });
  };
  const handleTestingInfoChange = (index, field, value) => {
    setFormData((prev) => {
      const list = [...(prev.testingInformationList || [])];
      list[index] = { ...list[index], [field]: value };
      return { ...prev, testingInformationList: list };
    });
  };

  // --- Employee Information (repeatable) ------------------------------------
  const handleAddEmployeeInfo = () => {
    setFormData((prev) => ({
      ...prev,
      employeeInformationList: [
        ...(prev.employeeInformationList || []),
        { employeeName: "", employeePhoneNumber: "" },
      ],
    }));
  };
  const handleRemoveEmployeeInfo = (index) => {
    setFormData((prev) => {
      const list = prev.employeeInformationList || [];
      if (list.length <= 1) return prev; // keep at least one
      return {
        ...prev,
        employeeInformationList: list.filter((_, i) => i !== index),
      };
    });
  };
  const handleEmployeeInfoChange = (index, field, value) => {
    setFormData((prev) => {
      const list = [...(prev.employeeInformationList || [])];
      list[index] = { ...list[index], [field]: value };
      return { ...prev, employeeInformationList: list };
    });
  };

  const checkLastStatementFilled = () => {
    const lastIndex = formData.employeeStatements.length - 1;
    const last = formData.employeeStatements[lastIndex];

    const hasSignatureFile =
      (employeeStatementsigns[lastIndex] &&
        employeeStatementsigns[lastIndex].length > 0) ||
      !!formData?.employeeStatementSigs?.[lastIndex]?.file_name;

    return (
      last.jobTitle?.trim() &&
      last.timeInCraft?.trim() &&
      last.timeOnJobsite?.trim() &&
      last.description?.trim() &&
      last.name?.trim() &&
      hasSignatureFile &&
      last.date?.trim()
    );
  };
  const checkwitnessLastStatementFilled = () => {
    const lastIndex = formData.witnessStatements.length - 1;
    const last = formData.witnessStatements[lastIndex];

    // ✅ Check if a witness signature file exists for this index (either a
    // freshly-picked file, or one already saved on the record in edit mode)
    const hasSignatureFile =
      (witnessStatementsigns[lastIndex] &&
        witnessStatementsigns[lastIndex].length > 0) ||
      !!formData?.witnessStatementSigs?.[lastIndex]?.file_name;

    return (
      last.jobTitle?.trim() &&
      last.timeInCraft?.trim() &&
      last.timeOnJobsite?.trim() &&
      last.description?.trim() &&
      last.name?.trim() &&
      hasSignatureFile &&
      last.date?.trim()
    );
  };

  const handleRemoveStatement = (indexToDelete) => {
    if (formData.employeeStatements.length === 1) return;
    const updated = formData.employeeStatements.filter(
      (_, i) => i !== indexToDelete,
    );
    setFormData({ ...formData, employeeStatements: updated });
  };
  const handlewitnessRemoveStatement = (indexToDelete) => {
    if (formData.witnessStatements.length === 1) return;
    const updated = formData.witnessStatements.filter(
      (_, i) => i !== indexToDelete,
    );
    setFormData({ ...formData, witnessStatements: updated });
  };

  const handleStatementChange = (index, field, value) => {
    const updated = [...formData.employeeStatements];
    updated[index][field] = value;
    setFormData({ ...formData, employeeStatements: updated });
  };
  const handlewitnessStatementChange = (index, field, value) => {
    const updated = [...formData.witnessStatements];
    updated[index][field] = value;
    setFormData({ ...formData, witnessStatements: updated });
  };

  const handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const handleDeleteImage = (statementId, imgIndex) => {
    setPhotoStatementImgs((prevImgs) => {
      const updatedImgs = [...(prevImgs[statementId] || [])];
      updatedImgs.splice(imgIndex, 1);
      return {
        ...prevImgs,
        [statementId]: updatedImgs,
      };
    });
  };
  const handleWitnessImageRemove = (index, fileIndex) => {
    setWitnessStatementImgs((prev) => {
      const updated = [...(prev[index] || [])];
      updated.splice(fileIndex, 1);
      return { ...prev, [index]: updated };
    });
  };

  // --- Supervisor Statement handlers (mirror the witness ones) -------------
  const handleAddSupervisorStatement = () => {
    setFormData((prev) => ({
      ...prev,
      supervisorStatements: [
        ...prev.supervisorStatements,
        {
          id: uuidv4(),
          jobTitle: "",
          timeInCraft: "",
          timeOnJobsite: "",
          description: "",
          name: "",
          signature: "",
          date: "",
        },
      ],
    }));
  };
  const handlesupervisorRemoveStatement = (indexToDelete) => {
    if (formData.supervisorStatements.length === 1) return;
    const updated = formData.supervisorStatements.filter(
      (_, i) => i !== indexToDelete,
    );
    setFormData({ ...formData, supervisorStatements: updated });
  };
  const handlesupervisorStatementChange = (index, field, value) => {
    const updated = [...formData.supervisorStatements];
    updated[index][field] = value;
    setFormData({ ...formData, supervisorStatements: updated });
  };
  const handleSupervisorImageUpload = (e, index) => {
    const files = Array.from(e.target.files);
    setSupervisorStatementImgs((prev) => ({
      ...prev,
      [index]: [...(prev[index] || []), ...files],
    }));
  };
  const handleSupervisorImageRemove = (index, fileIndex) => {
    setSupervisorStatementImgs((prev) => {
      const updated = [...(prev[index] || [])];
      updated.splice(fileIndex, 1);
      return { ...prev, [index]: updated };
    });
  };
  const checksupervisorLastStatementFilled = () => {
    const lastIndex = formData.supervisorStatements.length - 1;
    const last = formData.supervisorStatements[lastIndex];
    const hasSignatureFile =
      (supervisorStatementsigns[lastIndex] &&
        supervisorStatementsigns[lastIndex].length > 0) ||
      !!formData?.supervisorStatementSigs?.[lastIndex]?.file_name;
    return (
      last.jobTitle?.trim() &&
      last.timeInCraft?.trim() &&
      last.timeOnJobsite?.trim() &&
      last.description?.trim() &&
      last.name?.trim() &&
      hasSignatureFile &&
      last.date?.trim()
    );
  };

  const HandleSignature = (x) => {
    if (type.current === "employee") {
      setEmployeeSignImg(x);
    } else if (type.current === "supervisor") {
      setSupervisorSignImg(x);
    }
    if (type.current.startsWith("employeeStatement")) {
      const index = parseInt(type.current.replace("employeeStatement", ""), 10);

      const newImage = {
        file: x,
        preview: URL.createObjectURL(x),
        uniqueKey: `${index}-${Date.now()}-${Math.random()}`,
      };

      setemployeestatementssigns((prev) => ({
        ...prev,
        [index]: [newImage], // replace old entry instead of appending
      }));
    } else if (type.current.startsWith("witnessStatement")) {
      const index = parseInt(type.current.replace("witnessStatement", ""), 10);

      const newImage = {
        file: x,
        preview: URL.createObjectURL(x),
        uniqueKey: `${index}-${Date.now()}-${Math.random()}`,
      };

      setwitnesstatementsigns((prev) => ({
        ...prev,
        [index]: [newImage], // replace old entry instead of appending
      }));
    } else if (type.current.startsWith("supervisorStatement")) {
      const index = parseInt(
        type.current.replace("supervisorStatement", ""),
        10,
      );

      const newImage = {
        file: x,
        preview: URL.createObjectURL(x),
        uniqueKey: `${index}-${Date.now()}-${Math.random()}`,
      };

      setsupervisorstatementsigns((prev) => ({
        ...prev,
        [index]: [newImage],
      }));
    }
  };
  const isNewFile = (file) => {
    return file instanceof File; // Local file uploads ALWAYS File object
  };

  //   const handleSubmit = async () => {

  //     try {
  //       setLoader(true);
  // const formDataa = new FormData();

  // const allUploads = [];

  // const appendStatementImages = (imgsObj, type) => {
  //   Object.entries(imgsObj).forEach(([id, files]) => {
  //     files.forEach((item) => {
  //       // Accept both: { file: File } OR File directly
  //       const file = item instanceof File ? item : item?.file;
  //       if (file instanceof File) {
  //         formDataa.append('files', file);
  //         allUploads.push({ type, id });
  //       } else {
  //         console.warn(`Invalid file skipped for ${type} statement ${id}`, item);
  //       }
  //     });
  //   });
  // };

  // // Append all employee statement images to FormData
  // appendStatementImages(employeeStatementImgs, 'employee');

  // // Append all witness statement images to FormData
  // appendStatementImages(witnessStatementImgs, 'witness');

  // // Append all photo statement images to FormData
  // appendStatementImages(photoStatementImgs, 'photo');
  // appendStatementImages(attachmentFiles, "attachment");

  // // Append diagram image if available (only 1 expected)
  // if (uploadedDiagram.length > 0) {
  //   formDataa.append('files', uploadedDiagram[0].file); // Add diagram image
  //   allUploads.push({ type: 'diagram' });               // Track diagram separately
  // }
  // // Append employee sign image (single)
  // if (employeesignimg instanceof File) {
  //   formDataa.append('files', employeesignimg);
  //   allUploads.push({ type: 'employeesign' }); // track its type
  // }

  // // Append supervisor sign image (single)
  // if (supervisorsignimg instanceof File) {
  //   formDataa.append('files', supervisorsignimg);
  //   allUploads.push({ type: 'supervisorsign' }); // track its type
  // }
  // //NEW: Append all signature categories
  // appendStatementImages(employeeStatementsigns, 'employeeSig');
  // appendStatementImages(witnessStatementsigns, 'witnessSig');
  // // Debug: check what's in the FormData (dev-only)
  // console.log(formDataa, 'fm');

  // // Proceed only if there's at least one file to upload
  // const hasFilesToUpload = allUploads.length > 0;

  // if (hasFilesToUpload) {
  //   const imgresponse = await api.post('/v1/forms/upload-files', formDataa, {
  //     headers: {
  //       'Content-Type': 'multipart/form-data',
  //     },
  //   });

  //   if (imgresponse.status === 200 && Array.isArray(imgresponse.files)) {
  //     const uploadedFiles = imgresponse.files;

  //     // Prepare image mapping
  //     const employeeImgsResp = {};
  //     const witnessImgsResp = {};
  //     const photoImgsResp = {};
  //     const employeeSigsResp = {};
  //     const witnessSigsResp = {};
  //     // Map flat response to structured by tracking index
  //     let responseIndex = 0;
  //     allUploads.forEach((uploadMeta) => {
  //       const uploaded = uploadedFiles[responseIndex];
  //       responseIndex++;

  //       switch (uploadMeta.type) {
  //         case 'employee':
  //           if (!employeeImgsResp[uploadMeta.id]) employeeImgsResp[uploadMeta.id] = [];
  //           employeeImgsResp[uploadMeta.id].push(uploaded);
  //           break;

  //         case 'witness':
  //           if (!witnessImgsResp[uploadMeta.id]) witnessImgsResp[uploadMeta.id] = [];
  //           witnessImgsResp[uploadMeta.id].push(uploaded);
  //           break;

  //         case 'photo':
  //     if (!photoImgsResp[uploadMeta.id]) { photoImgsResp[uploadMeta.id] = []; }
  //     photoImgsResp[uploadMeta.id][uploadMeta.index] = uploaded

  //           break;
  //         case 'diagram':
  //           formData.motorVehicleReport.diagramimg = uploaded;
  //           break;
  //      case 'employeeSig':
  //   employeeSigsResp[uploadMeta.id] = uploaded;
  //   break;

  // case 'witnessSig':
  //   witnessSigsResp[uploadMeta.id] = uploaded;
  //   break;
  //   case 'employeesign':
  //   formData.employeeSignImg = uploaded;
  //   break;
  //   case 'attachment':
  //   if (!formData.attachments.Files[uploadMeta.id]) {
  //     formData.attachments.Files[uploadMeta.id] = [];
  //   }
  //   formData.attachments.Files[uploadMeta.id].push(uploaded);
  //   break;

  // case 'supervisorsign':
  //   formData.supervisorSignImg = uploaded;
  //   break;

  //       }
  //     });

  //     // Attach to formData
  //     formData.employeeStatementImgs = employeeImgsResp;
  //     formData.witnessStatementImgs = witnessImgsResp;
  //     formData.photoStatementImgs = photoImgsResp;
  //    formData.employeeStatementSigs = employeeSigsResp;
  //     formData.witnessStatementSigs = witnessSigsResp;

  //   }}
  //   console.log('Final formData to submit:', formData);
  //   let obj={
  //         emp_id: formData.emp_Id,
  //         emp_name: formData.empname,
  //         companyid: formData.companyId,
  //         form_type: "AIF",
  //         job_id: formData.jobNumber,
  //         job_description: `${selectedJobName}-(${jobCode})`,
  //         observer_name: formData.empname,
  //         filled_date: formData.date,
  //         json_data:[formData],
  //         documents: "",
  //         method: formData.method,
  //   }
  //   let response;
  //  if(mode==="edit"&&id){
  //         obj.row_id=id
  //   response = await api.post('/v1/forms/create-update-form',obj );
  //       }else{

  //         response = await api.post('/v1/forms/create-form', obj);
  //       }

  //       if (response.status === 200) {
  //         setOpen(true);
  //         setSeverity("success");

  //         setAlertMessage("Submitted Successfully");
  //         setConfirmModalOpen(false)
  //           setEmployeeStatementImgs({});
  //             setemployeestatementssigns({})
  //   setWitnessStatementImgs({});
  //   setPhotoStatementImgs({});
  //         setSkipModalOpen(false)
  //         setTimeout(() => {
  //           setOpen(false);
  //           navigate(-1);
  //         }, 2000);
  //       }
  //     } catch (error) {
  //       setSeverity("error");
  //       setAlertMessage("Something went wrong");
  //       setOpen(true);
  //       console.log("Submission error:", error);
  //     } finally {
  //       setLoader(false);
  //     }
  //   };
  const handleSubmit = async () => {
    try {
      setLoader(true);

      const formDataa = new FormData();
      const uploadQueue = []; // <-- holds EXACT upload meta

      const isNewFile = (f) => f instanceof File;

      // ---------------------------------------------
      // 1️⃣ PROCESS EMPLOYEE STATEMENT IMAGES (multi – append)
      // ---------------------------------------------
      Object.entries(employeeStatementImgs).forEach(([idx, arr]) => {
        arr.forEach((obj) => {
          const file = obj.file || obj;
          if (isNewFile(file)) {
            formDataa.append("files", file);
            uploadQueue.push({
              type: "employeeImgs",
              statementIndex: idx,
            });
          }
        });
      });

      // ---------------------------------------------
      // 2️⃣ WITNESS STATEMENT IMAGES (multi – append)
      // ---------------------------------------------
      Object.entries(witnessStatementImgs).forEach(([idx, arr]) => {
        arr.forEach((file) => {
          if (isNewFile(file)) {
            formDataa.append("files", file);
            uploadQueue.push({
              type: "witnessImgs",
              statementIndex: idx,
            });
          }
        });
      });

      // ---------------------------------------------
      // 2b️⃣ SUPERVISOR STATEMENT IMAGES (multi – append)
      // ---------------------------------------------
      Object.entries(supervisorStatementImgs).forEach(([idx, arr]) => {
        arr.forEach((file) => {
          if (isNewFile(file)) {
            formDataa.append("files", file);
            uploadQueue.push({
              type: "supervisorImgs",
              statementIndex: idx,
            });
          }
        });
      });

      // ---------------------------------------------
      // 3️⃣ PHOTO STATEMENT IMAGES (REPLACE EXACT INDEX)
      // ---------------------------------------------
      Object.entries(photoStatementImgs).forEach(([statementId, arr]) => {
        arr.forEach((photoObj, index) => {
          const file = photoObj.file || photoObj;
          if (isNewFile(file)) {
            formDataa.append("files", file);
            uploadQueue.push({
              type: "photoImgs",
              statementId,
              index, // IMPORTANT
            });
          }
        });
      });

      // ---------------------------------------------
      // 4️⃣ ATTACHMENTS (multi – append)
      // ---------------------------------------------
      Object.entries(attachmentFiles).forEach(([option, files]) => {
        files.forEach((file) => {
          if (isNewFile(file)) {
            formDataa.append("files", file);
            uploadQueue.push({
              type: "attachment",
              option,
            });
          }
        });
      });

      // 4b. "Attach Relevant Documents" — mobile parity. Goes through the
      // same upload endpoint but its own resolver branch so the result
      // lands in `formData.attachRelevantDocs` instead of the keyed
      // attachments.Files map.
      relevantDocsLocal.forEach((file) => {
        if (isNewFile(file)) {
          formDataa.append("files", file);
          uploadQueue.push({ type: "relevantDoc" });
        }
      });

      // ---------------------------------------------
      // 5️⃣ DIAGRAM (single replace)
      // ---------------------------------------------
      if (uploadedDiagram.length > 0 && isNewFile(uploadedDiagram[0].file)) {
        formDataa.append("files", uploadedDiagram[0].file);
        uploadQueue.push({ type: "diagram" });
      }

      // ---------------------------------------------
      // 6️⃣ MASTER SIGNATURES (single replace)
      // ---------------------------------------------
      if (isNewFile(employeesignimg)) {
        formDataa.append("files", employeesignimg);
        uploadQueue.push({ type: "employeeSign" });
      }
      if (isNewFile(supervisorsignimg)) {
        formDataa.append("files", supervisorsignimg);
        uploadQueue.push({ type: "supervisorSign" });
      }

      // ---------------------------------------------
      // 7️⃣ EMPLOYEE STATEMENT SIGNATURES (replace index 0)
      // ---------------------------------------------
      Object.entries(employeeStatementsigns).forEach(([idx, arr]) => {
        const sig = arr[0]?.file;
        if (isNewFile(sig)) {
          formDataa.append("files", sig);
          uploadQueue.push({
            type: "employeeSig",
            statementIndex: idx,
          });
        }
      });

      // ---------------------------------------------
      // 8️⃣ WITNESS STATEMENT SIGNATURES (replace index 0)
      // ---------------------------------------------
      Object.entries(witnessStatementsigns).forEach(([idx, arr]) => {
        const sig = arr[0]?.file;
        if (isNewFile(sig)) {
          formDataa.append("files", sig);
          uploadQueue.push({
            type: "witnessSig",
            statementIndex: idx,
          });
        }
      });

      // ---------------------------------------------
      // 8b️⃣ SUPERVISOR STATEMENT SIGNATURES (replace index 0)
      // ---------------------------------------------
      Object.entries(supervisorStatementsigns).forEach(([idx, arr]) => {
        const sig = arr[0]?.file;
        if (isNewFile(sig)) {
          formDataa.append("files", sig);
          uploadQueue.push({
            type: "supervisorSig",
            statementIndex: idx,
          });
        }
      });

      // ----------------------------------------------------
      // 🚀 UPLOAD ONLY IF ANY NEW FILES EXIST
      // ----------------------------------------------------
      if (uploadQueue.length > 0) {
        const uploadResp = await api.post("/v1/forms/upload-files", formDataa, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        const uploadedFiles = uploadResp.files;
        let fileIndex = 0;

        const employeeImgsResp = {};
        const witnessImgsResp = {};
        const supervisorImgsResp = {};
        const photoImgsResp = {};
        const employeeSigsResp = {};
        const witnessSigsResp = {};
        const supervisorSigsResp = {};

        // ----------------------------------------------------
        // 🔄 MAP UPLOADED FILES BACK TO THEIR EXACT LOCATION
        // ----------------------------------------------------
        uploadQueue.forEach((meta) => {
          const uploaded = uploadedFiles[fileIndex++];

          switch (meta.type) {
            case "employeeImgs":
              if (!employeeImgsResp[meta.statementIndex])
                employeeImgsResp[meta.statementIndex] = [];
              employeeImgsResp[meta.statementIndex].push(uploaded);
              break;

            case "witnessImgs":
              if (!witnessImgsResp[meta.statementIndex])
                witnessImgsResp[meta.statementIndex] = [];
              witnessImgsResp[meta.statementIndex].push(uploaded);
              break;

            case "supervisorImgs":
              if (!supervisorImgsResp[meta.statementIndex])
                supervisorImgsResp[meta.statementIndex] = [];
              supervisorImgsResp[meta.statementIndex].push(uploaded);
              break;

            case "photoImgs":
              if (!photoImgsResp[meta.statementId])
                photoImgsResp[meta.statementId] = [];
              photoImgsResp[meta.statementId][meta.index] = uploaded; // INDEX SAFE
              break;

            case "attachment":
              if (!formData.attachments.Files[meta.option])
                formData.attachments.Files[meta.option] = [];
              formData.attachments.Files[meta.option].push(uploaded);
              break;

            case "relevantDoc":
              // Mirrors mobile's `uploadedDocs`. Appended at the end of the
              // resolver so previously-saved server records are preserved
              // alongside any new uploads.
              if (!Array.isArray(formData.attachRelevantDocs))
                formData.attachRelevantDocs = [...relevantDocsServer];
              formData.attachRelevantDocs.push(uploaded);
              break;

            case "diagram":
              formData.motorVehicleReport.diagramimg = uploaded;
              break;

            case "employeeSign":
              formData.employeeSignImg = uploaded;
              break;

            case "supervisorSign":
              formData.supervisorSignImg = uploaded;
              break;

            case "employeeSig":
              employeeSigsResp[meta.statementIndex] = uploaded;
              break;

            case "witnessSig":
              witnessSigsResp[meta.statementIndex] = uploaded;
              break;

            case "supervisorSig":
              supervisorSigsResp[meta.statementIndex] = uploaded;
              break;
          }
        });
        // Preserve old + add new uploads (non-destructive)
        // formData.employeeStatementImgs = {
        //   ...formData.employeeStatementImgs,
        //   ...employeeImgsResp
        // };

        // formData.witnessStatementImgs = {
        //   ...formData.witnessStatementImgs,
        //   ...witnessImgsResp
        // };

        // formData.photoStatementImgs = {
        //   ...formData.photoStatementImgs,
        //   ...photoImgsResp
        // };

        // // Signature merge
        // formData.employeeStatementSigs = {
        //   ...formData.employeeStatementSigs,
        //   ...employeeSigsResp
        // };

        // formData.witnessStatementSigs = {
        //   ...formData.witnessStatementSigs,
        //   ...witnessSigsResp
        // };
        //------------------------------------------------------
        // ✅ FINAL IMAGE MERGE LOGIC (FULL + CORRECT)
        //------------------------------------------------------

        // 1️⃣ Employee Statement Images (multi-image)
        formData.employeeStatementImgs = {
          ...formData.employeeStatementImgs,
          ...Object.fromEntries(
            Object.entries(employeeImgsResp).map(([idx, newArr]) => [
              idx,
              [
                ...(formData.employeeStatementImgs?.[idx] || []), // OLD
                ...newArr, // NEW
              ],
            ]),
          ),
        };

        // 2️⃣ Witness Statement Images (multi-image)
        formData.witnessStatementImgs = {
          ...formData.witnessStatementImgs,
          ...Object.fromEntries(
            Object.entries(witnessImgsResp).map(([idx, newArr]) => [
              idx,
              [
                ...(formData.witnessStatementImgs?.[idx] || []), // OLD
                ...newArr, // NEW
              ],
            ]),
          ),
        };

        // 3️⃣ Photo Statement Images (index-safe merge)
        formData.photoStatementImgs = {
          ...formData.photoStatementImgs,
          ...Object.fromEntries(
            Object.entries(photoImgsResp).map(
              ([statementId, newIndexedArr]) => [
                statementId,
                Object.assign(
                  [...(formData.photoStatementImgs?.[statementId] || [])],
                  newIndexedArr, // only replaces edited positions
                ),
              ],
            ),
          ),
        };

        // 4️⃣ Employee Statement Signatures (single file, replace)
        formData.employeeStatementSigs = {
          ...formData.employeeStatementSigs,
          ...employeeSigsResp,
        };

        // 5️⃣ Witness Statement Signatures (single file, replace)
        formData.witnessStatementSigs = {
          ...formData.witnessStatementSigs,
          ...witnessSigsResp,
        };

        // 6️⃣ Supervisor Statement Images (multi-image)
        formData.supervisorStatementImgs = {
          ...formData.supervisorStatementImgs,
          ...Object.fromEntries(
            Object.entries(supervisorImgsResp).map(([idx, newArr]) => [
              idx,
              [...(formData.supervisorStatementImgs?.[idx] || []), ...newArr],
            ]),
          ),
        };

        // 7️⃣ Supervisor Statement Signatures (single file, replace)
        formData.supervisorStatementSigs = {
          ...formData.supervisorStatementSigs,
          ...supervisorSigsResp,
        };
      }

      // ----------------------------------------------------
      // Make sure attachRelevantDocs is set even when there were no new
      // uploads this round (so previously-saved server records aren't
      // dropped on a no-op re-save).
      if (!Array.isArray(formData.attachRelevantDocs)) {
        formData.attachRelevantDocs = [...relevantDocsServer];
      }

      // 🚀 FINAL SUBMIT (create or edit)
      // ----------------------------------------------------
      // Payload shaped to match the mobile app's `createFastForm` request:
      //   - `method` hard-coded to "Filled Out" (we dropped the dropdown).
      //   - `filled_date` defaults to today (`moment().format('YYYY-MM-DD')`).
      //   - `job_description` is just the job name (no "-(code)" suffix).
      //   - `emp_name` / `observer_name` use the full name from
      //     `formData.employeename` (since `empname` now holds the ID).
      const fullName = formData.employeename || formData.empname || "";
      let submitObj = {
        emp_id: formData.emp_Id,
        emp_name: fullName,
        companyid: formData.companyId
          ? parseInt(formData.companyId, 10)
          : formData.companyId,
        form_type: "AIF",
        job_id: formData.jobNumber,
        job_description: selectedJobName || formData.job_description || "",
        observer_name: fullName,
        filled_date: moment().format("YYYY-MM-DD"),
        json_data: [formData],
        documents: "",
        method: "Filled Out",
      };

      let response;

      if (mode === "edit" && id) {
        submitObj.row_id = id;
        response = await api.post("/v1/forms/create-update-form", submitObj);
      } else {
        response = await api.post("/v1/forms/create-form", submitObj);
      }

      if (response.status === 200) {
        clearDraft();
        setOpen(true);
        setSeverity("success");
        setAlertMessage("Submitted Successfully");

        // Reset image states
        setEmployeeStatementImgs({});
        setemployeestatementssigns({});
        setWitnessStatementImgs({});
        setPhotoStatementImgs({});
        setSkipModalOpen(false);

        setTimeout(() => {
          navigate(-1);
        }, 1500);
      }
    } catch (error) {
      setSeverity("error");
      setAlertMessage("Something went wrong");
      setOpen(true);
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const nextStep = () => {
    //   switch (currentStep) {
    //     case 1:
    //       if (!formData.method) return showError("Please select Method");
    //       if (!formData.companyId) return showError("Please select Company ID");
    //       if (!formData.jobNumber) return showError("Please enter Job ID");
    //   if (!formData.job_description) return showError("Please enter Job Description")
    //       if (!formData.empname) return showError("Please enter employee Name");
    //       if (!formData.emp_Id) return showError("Please select driver name from suggestions only");
    //       if (!formData.date) return showError("Please select a Date");
    //       break;

    //     case 2:
    //       if (!formData.employeename) return showError("Please enter employee name");
    //       if (!formData.employeebadge) return showError("Please enter employee badge");
    //       if (!formData.phonenumber) return showError("Please enter phone number");
    //       if (!formData.address) return showError("Please enter address");
    //       if (!formData.city) return showError("Please enter city");
    //       if (!formData.state) return showError("Please enter state");
    //       if (!formData.zipcode) return showError("Please enter zipcode");
    //       if (!formData.incidentdate) return showError("Please enter incident date");
    //       if (!formData.department?.selectedValue) return showError("Please select Department");
    //       if (!formData.jobtitle) return showError("Please enter job title");
    //       if (!formData.projectnumber) return showError("Please enter project number");
    //       if (!formData.projectlocation) return showError("Please enter project location");
    //       if (!formData.client) return showError("Please enter client");
    //       if (!formData.wheathercondition) return showError("Please enter weather condition");
    //       if (!formData.directsupervisor) return showError("Please enter direct supervisor");
    //       if (!formData.clientbeennotified?.selectedValue) return showError("Please select if client has been notified");
    //       break;

    //     case 3:
    //       if (!formData.damages.selectedValues.length) return showError("Please select at least one classification option");
    //       if (!formData.injuredside.selectedValue) return showError("Please select the injured side");
    //       if (!formData.bodypartsinjuried.selectedValues.length) return showError("Please select at least one body part injured");

    //        if (!formData.facility.trim()) return showError("Please enter the facility name");
    //           if (!formData.collector.trim()) return showError("Please enter the collector name");
    //       if (!formData.testtype?.options?.length || !formData.testtype.options.includes(formData.testtype.selectedValue))
    //         return showError("Please select at least one test type")

    //       if (!formData.employeenameprint.trim()) return showError("Please enter employee name");
    //      if (!employeesignimg || !(employeesignimg instanceof File) && !employeesignimg.file) {
    //   return showError("Please upload employee signature image");
    // }

    //       if (!formData.employeenameprintsignaturedate.trim()) return showError("Please enter date for employee signature");
    //       if (!formData.supervisornameprint.trim()) return showError("Please enter supervisor name");
    //      if (
    //   !employeesignimg ||
    //   (!(employeesignimg instanceof File) && !employeesignimg.file)
    // ) {
    //   return showError("Please upload employee signature image");
    // }
    //       if (!formData.supervisorprintsignaturedate.trim()) return showError("Please enter date for supervisor signature");
    //       break;
    //     case 4:
    //        if (!formData.descriptionofincident.trim()) return showError("Please provide a Accident Description");
    //    if (!formData. incidentDescription.trim()) return showError("Please enter the Incident Causes");
    //  if (!formData.incidentsummary.trim()) return showError("Please enter the incident summary");
    //  if (!formData.anyWitness.trim()) return showError("Please Select Witness Information");
    // if (
    //   formData.witnessCards?.length > 0 &&
    //   formData.witnessCards.some(
    //     (card) => !card.name.trim() || !card.phone.trim()
    //   )
    // ) {
    //   return showError("Please fill both Name and Phone Number for all Witnesses");
    // }
    //     if (!formData.attachments.selectedvalues?.length) return showError("Please select at least one attachment");

    // if (!formData.witnessSummary.trim()) return showError("Please provide a Incident summary");
    //         // if (!formData.injurytype.selectedvalue) return showError("Please select the type of injury");
    //       //  if (!formData.incidentcause.selectedvalue) return showError("Please select the cause of the incident");

    //       // if (!formData.witnessstatement.trim()) return showError("Please provide a witness statement");

    //       break
    //     case 5:
    //       for (let i = 0; i < formData.employeeStatements.length; i++) {
    //         const entry = formData.employeeStatements[i];
    //         const label = `Employee Statement ${i + 1}`;
    //         if (!entry.jobTitle?.trim()) return showError(`${label}: Please enter Job Title`);
    //         if (!entry.timeInCraft?.trim()) return showError(`${label}: Please enter Time in Craft`);
    //         if (!entry.timeOnJobsite?.trim()) return showError(`${label}: Please enter Time on Jobsite`);
    //         if (!entry.description?.trim()) return showError(`${label}: Please enter Description of Accident/Incident`);
    //         if (!entry.name?.trim()) return showError(`${label}: Please enter Name`);
    //         // if (!entry.signature?.trim()) return showError(`${label}: Please enter Signature`);
    //         if (!entry.date?.trim()) return showError(`${label}: Please select Date`);
    //       }
    //       for (let i = 0; i < formData.witnessStatements.length; i++) {
    //         const entry = formData.witnessStatements[i];
    //         const label = `witness Statements ${i + 1}`;
    //         if (!entry.jobTitle?.trim()) return showError(`${label}: Please enter Job Title`);
    //         if (!entry.timeInCraft?.trim()) return showError(`${label}: Please enter Time in Craft`);
    //         if (!entry.timeOnJobsite?.trim()) return showError(`${label}: Please enter Time on Jobsite`);
    //         if (!entry.description?.trim()) return showError(`${label}: Please enter Description of Accident/Incident`);
    //         if (!entry.name?.trim()) return showError(`${label}: Please enter Name`);

    //         if (!entry.date?.trim()) return showError(`${label}: Please select Date`);
    //       }
    //       break;

    //     case 6:
    //       for (let i = 0; i < formData.photoStatements.length; i++) {
    //         const photo = formData.photoStatements[i];
    //         const label = `Photo ${i + 1}`;
    //         if (!photo.photoNo?.trim()) return showError(`${label}: Please enter Photo No`);
    //         if (!photo.photoDate?.trim()) return showError(`${label}: Please select Photo Date`);
    //         if (!photo.timeOfDay?.trim()) return showError(`${label}: Please enter Time of Day`);
    //         if (!photo.location?.trim()) return showError(`${label}: Please enter Location`);
    //         if (!photo.description?.trim()) return showError(`${label}: Please enter Description`);
    //         if (!photo.notes?.trim()) return showError(`${label}: Please enter Notes`);
    //         if (!photo.photographer?.trim()) return showError(`${label}: Please enter Photographer`);
    //       }
    //       break;

    //     default:
    //       break;
    //   }

    // Required-field validation per step. Matches the mobile app's
    // `validateCurrentPage` exactly so the web form gates the same way.
    switch (currentStep) {
      case 1: {
        // Job Information block
        if (!formData.companyId) return showError("Please select a Company");
        if (!formData.jobtitle?.trim())
          return showError("Please enter Job Title");
        if (!formData.jobNumber?.toString().trim())
          return showError("Please enter Job Number");
        if (!formData.job_description?.trim())
          return showError("Please enter a valid Job Number");
        if (!formData.client?.trim()) return showError("Please enter Client");
        if (!formData.projectlocation?.trim())
          return showError("Please enter Project Location");
        if (!formData.directsupervisor?.trim())
          return showError("Please enter Direct Supervisor");
        if (!formData.clientbeennotified?.selectedValue)
          return showError("Please select if Client has been notified");
        // Personal Information block
        if (!formData.emp_Id)
          return showError("Please select an Employee from the suggestions");
        if (!formData.employeename?.trim())
          return showError("Please enter Name of Employee");
        if (!formData.phonenumber?.trim())
          return showError("Please enter Phone Number");
        if (!formData.address?.trim()) return showError("Please enter Address");
        if (!formData.city?.trim()) return showError("Please enter City");
        if (!formData.state?.trim()) return showError("Please enter State");
        if (!formData.zipcode?.trim())
          return showError("Please enter Zip Code");
        break;
      }
      case 2: {
        if (!formData.damages?.selectedValues?.length) {
          return showError("Please select at least one Classification");
        }
        if (!formData.injuredside?.selectedValue) {
          return showError("Please select the Injured Side");
        }
        // Testing Information is only required when the "test required"
        // option is selected. Picking N/A skips this validation block.
        const testRequired = (
          formData.postaccidentua?.selectedValues || []
        ).includes("Post-accident drug/alcohol test required");
        if (testRequired) {
          const list = formData.testingInformationList || [];
          if (list.length === 0) {
            return showError("Please add Testing Information");
          }
          for (let i = 0; i < list.length; i++) {
            const info = list[i];
            if (!info.facility?.trim())
              return showError(`Please enter Facility for Testing Information ${i + 1}`);
            if (!info.collector?.trim())
              return showError(`Please enter Collector for Testing Information ${i + 1}`);
            if (!info.testType)
              return showError(`Please select Test Type for Testing Information ${i + 1}`);
          }
          // Employee Information validation
          const empList = formData.employeeInformationList || [];
          if (empList.length === 0) {
            return showError("Please add Employee Information");
          }
          for (let i = 0; i < empList.length; i++) {
            const emp = empList[i];
            if (!emp.employeeName?.trim())
              return showError(`Please enter Employee Name for Employee Information ${i + 1}`);
            if (!emp.employeePhoneNumber?.trim())
              return showError(`Please enter Employee Phone Number for Employee Information ${i + 1}`);
          }
        }
        break;
      }
      case 3: {
        if (!formData.descriptionofincident?.trim()) {
          return showError("Please enter Accident Description");
        }
        if (!formData.incidentcause?.selectedvalue) {
          return showError("Please select Incident Cause");
        }
        break;
      }
      case 10: {
        // Step 10: Witness/Statements (was step 4)
        if (!formData.anyWitness?.trim()) {
          return showError("Please answer the Witness Information question");
        }
        const firstEmp = formData.employeeStatements?.[0];
        if (!firstEmp?.jobTitle?.trim())
          return showError("Please enter Employee Job Title");
        if (!firstEmp?.name?.trim())
          return showError("Please enter Employee Name");
        if (!firstEmp?.description?.trim())
          return showError("Please enter Employee Description");
        // Witness statements: only validate fully-filled rows (the app only
        // gates when `name` is filled but other fields are missing).
        for (let i = 0; i < (formData.witnessStatements?.length || 0); i += 1) {
          const w = formData.witnessStatements[i];
          if (
            w?.name?.trim() &&
            (!w?.jobTitle?.trim() || !w?.description?.trim())
          ) {
            return showError(`Please complete Witness Statement ${i + 1}`);
          }
        }
        // Supervisor statements: same partial-fill gate as witnesses.
        for (
          let i = 0;
          i < (formData.supervisorStatements?.length || 0);
          i += 1
        ) {
          const s = formData.supervisorStatements[i];
          if (
            s?.name?.trim() &&
            (!s?.jobTitle?.trim() || !s?.description?.trim())
          ) {
            return showError(`Please complete Supervisor Statement ${i + 1}`);
          }
        }
        break;
      }
      case 11: {
        // Step 11: Photos (was step 5)
        const photos = formData.photoStatements || [];
        for (let i = 0; i < photos.length; i += 1) {
          const p = photos[i];
          const label = `Photo ${i + 1}`;
          if (!p?.photoNo?.trim())
            return showError(`${label}: Please enter Photo Number`);
          if (!p?.location?.trim())
            return showError(`${label}: Please enter Location`);
          if (!p?.description?.trim())
            return showError(`${label}: Please enter Description`);
          if (!p?.photographer?.trim())
            return showError(`${label}: Please enter Photographer Name`);
        }
        break;
      }
      case 12: {
        // Step 12: Motor Vehicle Accident Report (was step 6) — last step, submit after.
        if (!formData.isSkipVechileAccident) {
          const mvr = formData.motorVehicleReport || {};
          const vt = mvr.vehicleType || {};
          const vehicleSelected =
            vt.ntactVehicle || vt.ntactLeased || vt.mobileEquipment;
          if (!vehicleSelected) return showError("Please select a Vehicle Type");
          if (!mvr.vehicleDetails?.make?.trim())
            return showError("Please enter Vehicle Make");
          if (!mvr.vehicleDetails?.model?.trim())
            return showError("Please enter Vehicle Model");
          if (!mvr.driverName?.trim())
            return showError("Please enter Driver Name");
          if (!mvr.isDriverApproved)
            return showError("Please select if Driver is on approved list");
          if (!mvr.licenseNumber?.trim())
            return showError("Please enter Driver License Number");
          if (!mvr.issuingState?.trim())
            return showError("Please enter Issuing State");
          const speed = mvr.incidentDetails?.speed || {};
          if (!speed.employee?.toString().trim())
            return showError("Please enter Employee Vehicle Speed");
          if (!speed.other?.toString().trim())
            return showError("Please enter Other Vehicle Speed");
          if (!speed.posted?.toString().trim())
            return showError("Please enter Posted Speed Limit");
          if (!mvr.incidentDetails?.incidentDescription?.trim()) {
            return showError("Please enter Incident Description");
          }
        }
        return setConfirmModalOpen(true);
      }
      default:
        break;
    }

    // ✅ Move to next step
    if (currentStep < 12) {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const showError = (msg) => {
    setSeverity("error");
    setAlertMessage(msg);
    setOpen(true);
    return false;
  };

  // 6-step layout that mirrors the mobile app (NewAccidentIncidentFormUI.js).
  // Step 1 (Employee) merges the old Audit Information + General Information
  // pages. Steps 5/6/7 from the previous layout become 4/5/6.
  const steps = [
    "Employee",                        // step 1 (unchanged)
    "Classify",                        // step 2 (unchanged)
    "Details",                         // step 3 (unchanged)
    "Procedures & Management",         // step 4 (was 7)
    "Human Factors",                   // step 5 (was 8)
    "Work Direction & Communication",  // step 6 (was 9)
    "Work Environment",                // step 7 (was 10)
    "Transportation",                  // step 8 (was 11)
    "Results",                         // step 9 (was 12)
    "Witness/Statements",              // step 10 (was 4)
    "Photos",                          // step 11 (was 5)
    "Motor Vehicle Accident Report",   // step 12 (was 6)
  ];

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  const fetchEmployeeSuggestions = async (query) => {
    try {
      if (!query) {
        setEmployeeSuggestions([]);
        setShowEmpSuggestions(false);
        return;
      }

      const obj = {
        params: {
          company_id: selectedCompanyId,
          empid: query,
        },
      };

      const response = await api.get("/v1/timesheets/get-employee", obj);
      if (response.status === 200 && Array.isArray(response.data)) {
        setEmployeeSuggestions(response.data);
        setShowEmpSuggestions(true);
      } else {
        setEmployeeSuggestions([]);
        setShowEmpSuggestions(false);
        setEmployeeId("");
        setFormData((prev) => ({
          ...prev,
          empname: "",
        }));
      }
    } catch (error) {
      console.error("Error fetching employee suggestions:", error);
    }
  };
  const handlePhotoStatementImageUpload = (e, index) => {
    const files = Array.from(e.target.files);

    const newImages = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
      uniqueKey: `${index}-${Date.now()}-${Math.random()}`,
    }));

    setPhotoStatementImgs((prev) => ({
      ...prev,
      [index]: [...(prev[index] || []), ...newImages],
    }));
  };
  const handleMultipleImageUpload = (e, index) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const newImages = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
      uniqueKey: `${index}-${Date.now()}-${Math.random()}`,
    }));

    setEmployeeStatementImgs((prev) => ({
      ...prev,
      [index]: [...(prev[index] || []), ...newImages],
    }));
  };

  const handleMultipleemployeestatementsignUpload = (e, index) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const newImages = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
      uniqueKey: `${index}-${Date.now()}-${Math.random()}`,
    }));

    setemployeestatementssigns((prev) => ({
      ...prev,
      [index]: [...(prev[index] || []), ...newImages],
    }));
  };
  const mapJsonToForm = (apiData) => {
    if (!apiData || !apiData.json_data) return { ...formData };

    const saved = apiData.json_data[0]; // Your saved form object

    // Deep clone defaults to prevent mutation
    let mapped = JSON.parse(JSON.stringify(formData));

    const merge = (defaultObj, savedObj) => {
      if (!savedObj) return defaultObj;
      let output = { ...defaultObj };

      Object.keys(defaultObj).forEach((key) => {
        if (savedObj[key] !== undefined) {
          if (Array.isArray(defaultObj[key])) {
            output[key] = savedObj[key] || [];
          } else if (
            typeof defaultObj[key] === "object" &&
            defaultObj[key] !== null
          ) {
            output[key] = merge(defaultObj[key], savedObj[key]);
          } else {
            output[key] = savedObj[key];
          }
        }
      });

      // Add extra keys API may have but default does not
      Object.keys(savedObj).forEach((key) => {
        if (output[key] === undefined) output[key] = savedObj[key];
      });

      return output;
    };

    mapped = merge(mapped, saved);

    // ---------- SPECIAL CASES FOR FILE ARRAYS ----------
    mapped.employeeStatementImgs = saved.employeeStatementImgs || {};
    mapped.witnessStatementImgs = saved.witnessStatementImgs || {};
    mapped.supervisorStatementImgs = saved.supervisorStatementImgs || {};
    mapped.photoStatementImgs = saved.photoStatementImgs || {};

    mapped.employeeStatementSigs = saved.employeeStatementSigs || {};
    mapped.witnessStatementSigs = saved.witnessStatementSigs || {};
    mapped.supervisorStatementSigs = saved.supervisorStatementSigs || {};

    mapped.employeesignimg = saved.employeeSignImg || null;
    mapped.supervisorsignimg = saved.supervisorSignImg || null;

    // Mobile-app "Attach Relevant Documents" bucket (uploadedDocs). Hydrate
    // the server-records state so the previews render in edit mode.
    const savedRelevantDocs = Array.isArray(saved.attachRelevantDocs)
      ? saved.attachRelevantDocs
      : Array.isArray(saved.uploadedDocs)
      ? saved.uploadedDocs
      : [];
    mapped.attachRelevantDocs = savedRelevantDocs;
    setRelevantDocsServer(savedRelevantDocs);
    setRelevantDocsLocal([]);

    mapped.uploadedDiagram = saved.motorVehicleReport?.diagramimg
      ? [{ file: null, previewUrl: saved.motorVehicleReport.diagramimg }]
      : [];

    // Attachments
    if (saved.attachments) {
      mapped.attachments.selectedvalues =
        saved.attachments.selectedvalues || [];

      mapped.attachments.Files = saved.attachments.Files || {
        Pictures: [],
        "Additional Drawing/Diagrams": [],
        JSA: [],
        "Incident Pictures (Re-enactment if possible)": [],
        "Attach Relevant Documents": [],
      };
      // Make sure legacy records still expose the new bucket key so the
      // checkbox can be ticked + files uploaded after opening in edit mode.
      if (
        mapped.attachments.Files &&
        mapped.attachments.Files["Attach Relevant Documents"] === undefined
      ) {
        mapped.attachments.Files["Attach Relevant Documents"] = [];
      }
    }

    // ---------- Dynamic Arrays Rebuild ----------
    mapped.employeeStatements = saved.employeeStatements?.length
      ? saved.employeeStatements
      : mapped.employeeStatements;

    mapped.witnessStatements = saved.witnessStatements?.length
      ? saved.witnessStatements
      : mapped.witnessStatements;

    mapped.supervisorStatements = saved.supervisorStatements?.length
      ? saved.supervisorStatements
      : mapped.supervisorStatements;

    mapped.photoStatements = saved.photoStatements?.length
      ? saved.photoStatements
      : mapped.photoStatements;

    // ---------- EMPLOYEE FIELD RESHAPE ----------
    // The Step-1 "Employee" search input is bound to `formData.empname` and
    // expects to show the employee ID (post-split). The "Name of Employee"
    // input is bound to `formData.employeename`. The merge above pulls
    // whatever was in json_data[0].empname, which for legacy records is the
    // full name — that's why the Employee field appears as a name in edit
    // mode. Override here with the reliable top-level columns the backend
    // always writes: `apiData.emp_id` and `apiData.emp_name`.
    if (apiData.emp_id !== undefined && apiData.emp_id !== null && apiData.emp_id !== "") {
      mapped.empname = String(apiData.emp_id);
      mapped.emp_Id = apiData.emp_id;
    }
    if (typeof apiData.emp_name === "string" && apiData.emp_name.trim()) {
      mapped.employeename = apiData.emp_name;
    }

    return mapped;
  };

  const fetchcurrentformdata = async () => {
    try {
      setLoader(true);
      const res = await api.get(`/v1/forms/get_by_id`, {
        params: {
          rowid: id,
        },
      });
      if (res.status === 200) {
        const apiData = res.data[0];

        let mapped = mapJsonToForm(apiData);

        setFormData(mapped);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };
  const draftId = searchParams.get("draft_id");
  const loadDraftData = async (dId) => {
    try {
      setLoader(true);
      const resp = await api.get('/v1/forms/drafts/get', { params: { draft_id: dId } });
      const draft = resp?.draft || null;
      if (draft) {
        notifyLoaded();
        let mapped = mapJsonToForm(draftToFormRow(draft));
        setFormData(mapped);
        const savedStep = draft?.form_data?._step;
        if (savedStep) setCurrentStep(savedStep);

        const pending = draft?.form_data?._pendingImages;
        if (pending) {
          if (pending.employeeStatementImgs) setEmployeeStatementImgs(base64ToStatementFiles(pending.employeeStatementImgs));
          if (pending.witnessStatementImgs) setWitnessStatementImgs(base64ToStatementFiles(pending.witnessStatementImgs));
          if (pending.supervisorStatementImgs) setSupervisorStatementImgs(base64ToStatementFiles(pending.supervisorStatementImgs));
          if (pending.photoStatementImgs) setPhotoStatementImgs(base64ToStatementFiles(pending.photoStatementImgs));
          if (pending.employeeStatementsigns) setemployeestatementssigns(base64ToStatementFiles(pending.employeeStatementsigns));
          if (pending.witnessStatementsigns) setwitnesstatementsigns(base64ToStatementFiles(pending.witnessStatementsigns));
          if (pending.supervisorStatementsigns) setsupervisorstatementsigns(base64ToStatementFiles(pending.supervisorStatementsigns));
          if (pending.attachmentFiles) setAttachmentFiles(base64ToFileDict(pending.attachmentFiles));
          if (pending.relevantDocsLocal) setRelevantDocsLocal(base64ToPlainFiles(pending.relevantDocsLocal));
          if (pending.employeesignimg) setEmployeeSignImg(dataUriToFile(pending.employeesignimg, 'employee_signature.jpg'));
          if (pending.supervisorsignimg) setSupervisorSignImg(dataUriToFile(pending.supervisorsignimg, 'supervisor_signature.jpg'));
          if (pending.diagram) {
            const diagramFile = dataUriToFile(pending.diagram, 'diagram.jpg');
            setUploadedDiagram([{ file: diagramFile, previewUrl: URL.createObjectURL(diagramFile) }]);
          }
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    if (mode === "edit" && id) {
      fetchcurrentformdata();
    } else if (mode === "draft" && draftId) {
      loadDraftData(draftId);
    }
  }, [mode, id, draftId]);

  // ─── Pending-image base64 helpers for drafts ───
  // AIF keeps signatures/photos in separate component state (not `formData`)
  // until actual submit, when they're uploaded and merged in. Drafts can't
  // upload on every autosave (would repeatedly re-upload unchanged files), so
  // instead we embed any still-local File as a base64 data URI directly in
  // the draft JSON — the same approach the mobile app already uses for
  // offline drafts. All the statement/photo/signature dicts share the same
  // `{ [key]: [{ file, preview, uniqueKey }] }` shape.
  const statementFilesToBase64 = async (dict) => {
    const out = {};
    await Promise.all(
      Object.entries(dict || {}).map(async ([key, arr]) => {
        const items = (
          await Promise.all(
            (arr || []).map(async (item) => {
              // witnessStatementImgs/supervisorStatementImgs store raw File
              // objects directly; employeeStatementImgs/photoStatementImgs
              // and the signature dicts wrap them as { file, preview,
              // uniqueKey }. Handle both.
              const file = item instanceof File ? item : item?.file;
              if (!(file instanceof File)) return null;
              return { dataUri: await fileToDataUri(file), uniqueKey: item?.uniqueKey };
            })
          )
        ).filter(Boolean);
        if (items.length) out[key] = items;
      })
    );
    return out;
  };

  const base64ToStatementFiles = (saved) => {
    const out = {};
    Object.entries(saved || {}).forEach(([key, arr]) => {
      out[key] = (arr || []).map((item) => {
        const file = dataUriToFile(item.dataUri, `restored_${item.uniqueKey || Date.now()}.jpg`);
        return { file, preview: URL.createObjectURL(file), uniqueKey: item.uniqueKey };
      });
    });
    return out;
  };

  const plainFilesToBase64 = async (files) =>
    Promise.all((files || []).filter((f) => f instanceof File).map((f) => fileToDataUri(f)));

  const base64ToPlainFiles = (dataUris) =>
    (dataUris || []).map((uri, i) => dataUriToFile(uri, `restored_${Date.now()}_${i}.jpg`));

  const fileDictToBase64 = async (dict) => {
    const out = {};
    await Promise.all(
      Object.entries(dict || {}).map(async ([key, files]) => {
        const converted = await plainFilesToBase64(files);
        if (converted.length) out[key] = converted;
      })
    );
    return out;
  };

  const base64ToFileDict = (saved) => {
    const out = {};
    Object.entries(saved || {}).forEach(([key, dataUris]) => {
      out[key] = base64ToPlainFiles(dataUris);
    });
    return out;
  };

  // ─── Step-wise draft autosave ───
  const { clearDraft, notifyLoaded } = useFormDraft({
    formName: "Accident Incident Investigation Form",
    mode,
    step: currentStep,
    watch: [
      formData,
      employeeStatementImgs,
      witnessStatementImgs,
      supervisorStatementImgs,
      photoStatementImgs,
      employeeStatementsigns,
      witnessStatementsigns,
      supervisorStatementsigns,
      attachmentFiles,
      relevantDocsLocal,
      employeesignimg,
      supervisorsignimg,
      uploadedDiagram,
    ],
    buildSnapshot: async () => {
      const [
        employeeStatementImgsB64,
        witnessStatementImgsB64,
        supervisorStatementImgsB64,
        photoStatementImgsB64,
        employeeStatementsignsB64,
        witnessStatementsignsB64,
        supervisorStatementsignsB64,
        attachmentFilesB64,
        relevantDocsB64,
        employeeSignB64,
        supervisorSignB64,
        diagramB64,
      ] = await Promise.all([
        statementFilesToBase64(employeeStatementImgs),
        statementFilesToBase64(witnessStatementImgs),
        statementFilesToBase64(supervisorStatementImgs),
        statementFilesToBase64(photoStatementImgs),
        statementFilesToBase64(employeeStatementsigns),
        statementFilesToBase64(witnessStatementsigns),
        statementFilesToBase64(supervisorStatementsigns),
        fileDictToBase64(attachmentFiles),
        plainFilesToBase64(relevantDocsLocal),
        employeesignimg instanceof File ? fileToDataUri(employeesignimg) : null,
        supervisorsignimg instanceof File ? fileToDataUri(supervisorsignimg) : null,
        uploadedDiagram?.[0]?.file instanceof File ? fileToDataUri(uploadedDiagram[0].file) : null,
      ]);

      return {
        json_data: [formData],
        _step: currentStep,
        companyid: formData.companyId,
        emp_id: formData.emp_Id,
        emp_name: formData.employeename || formData.empname,
        job_id: formData.jobNumber,
        job_description: selectedJobName || formData.job_description,
        observer_name: formData.employeename || formData.empname,
        date: formData.incidentdate,
        method: 'Filled Out',
        _pendingImages: {
          employeeStatementImgs: employeeStatementImgsB64,
          witnessStatementImgs: witnessStatementImgsB64,
          supervisorStatementImgs: supervisorStatementImgsB64,
          photoStatementImgs: photoStatementImgsB64,
          employeeStatementsigns: employeeStatementsignsB64,
          witnessStatementsigns: witnessStatementsignsB64,
          supervisorStatementsigns: supervisorStatementsignsB64,
          attachmentFiles: attachmentFilesB64,
          relevantDocsLocal: relevantDocsB64,
          employeesignimg: employeeSignB64,
          supervisorsignimg: supervisorSignB64,
          diagram: diagramB64,
        },
      };
    },
  });
  const fetchJobSuggestions = async (query) => {
    try {
      if (!query) {
        setSuggestions([]);
        setShowSuggestions(false);
        setSelectedJobName("");
        return;
      }
      const response = await api.get(`/v1/timesheets/get-jobs`, {
        params: {
          company_id: selectedCompanyId,
          job_num: query,
        },
      });
      if (response.status === 200) {
        setSuggestions(response.data || []);
        setShowSuggestions(true);
      } else {
        setSuggestions([]);
        setShowSuggestions(false);
        setJobCode();
        setFormData((prev) => ({
          ...prev,
          jobNumber: "",
        }));
      }
    } catch (error) {
      console.error("Error fetching jobcodes:", error);
    }
  };

  const handleEmployeeSelect = (emp) => {
    // The "Employee" search input shows the ID after selection (matches
    // the mobile app); the full name flows into "Name of Employee" below.
    const fullName = `${emp.firstname || ""} ${emp.lastname || ""}`.trim();
    setFormData((prev) => ({
      ...prev,
      empname: emp.empid, // search field → show ID
      employeename: fullName, // Name of Employee → auto-fill name
      emp_Id: emp.empid,
    }));
    setEmployeeId(emp.empid);
    setselectedempobj(emp);
    setShowEmpSuggestions(false);
    setEmployeeSuggestions([]);
  };

  const handleJobCodeSelect = (code) => {
    setJobCode(code.job_num);
    setSelectedJobName(code.job_name);
    setSuggestions([]);
    setShowSuggestions(false);

    // Also update formData.jobNumber and auto-fill job_description with the
    // job name from the selected suggestion.
    setFormData((prev) => ({
      ...prev,
      jobNumber: code.job_num,
      job_description: code.job_name || "",
    }));
  };

  const fetchTabsData = async () => {
    try {
      const response = await api.get(`/v1/timesheets/company-details`);

      if (response.status === 200) {
        setCompanyTabs(response.data);
        setSelectedCompanyId(response.data[0]?.id);
      } else {
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
    }
  };

  useEffect(() => {
    fetchTabsData();
  }, []);

  // Prefill the first Statement of Employee "Name" with the step-1 employee
  // name (mirrors mobile). Only seeds when the field is still blank so the
  // user's own edits are never overwritten.
  useEffect(() => {
    const empName = (formData.employeename || "").trim();
    if (!empName) return;
    setFormData((prev) => {
      const stmts = prev.employeeStatements || [];
      if (!stmts.length || (stmts[0].name || "").trim()) return prev;
      const updated = [...stmts];
      updated[0] = { ...updated[0], name: empName };
      return { ...prev, employeeStatements: updated };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.employeename]);

  const handleInputChange = (e, section, field) => {
    const { value } = e.target;
    if (section) {
      setFormData((prev) => ({
        ...prev,
        [section]: {
          ...prev[section],
          [field]: value,
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [field]: value,
      }));
    }
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (jobInputRef.current && !jobInputRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }

      if (empInputRef.current && !empInputRef.current.contains(event.target)) {
        setShowEmpSuggestions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleDeleteEntry = (index) => {
    const updatedEntries = logEntries.filter((_, i) => i !== index);
    setLogEntries(updatedEntries);
    setFormData((prev) => ({
      ...prev,
      step2Data: updatedEntries,
    }));
  };

  console.log("FormAdat", formData.date);

  // Attachments section — rendered on Step 5 (mobile parity). Contains the
  // four-attachment checkbox group (Pictures / Drawings / JSA / Incident
  // Pictures) plus the "Attach Relevant Documents" uploader.
  const renderAttachmentsSection = () => (
    <>
      <div className="flex flex-col gap-2 px-4 py-3">
        <div className="font-bold text-left">
          {t("Attachments: Check all that apply")}
        </div>

        <div className="flex flex-wrap gap-6">
          {formData.attachments.options.map((option) => {
            const isChecked =
              formData.attachments.selectedvalues.includes(option);

            return (
              <div key={option} className="flex flex-col gap-2 w-full">
                {/* Checkbox */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    value={option}
                    checked={isChecked}
                    onChange={(e) => {
                      const updated = e.target.checked
                        ? [...formData.attachments.selectedvalues, option]
                        : formData.attachments.selectedvalues.filter(
                            (v) => v !== option,
                          );
                      if (!e.target.checked) {
                        setAttachmentFiles((prev) => {
                          const copy = { ...prev };
                          delete copy[option];
                          return copy;
                        });
                      }
                      setFormData({
                        ...formData,
                        attachments: {
                          ...formData.attachments,
                          selectedvalues: updated,
                        },
                      });
                    }}
                    className="accent-[rgba(24,24,27,1)] w-4 h-4"
                  />
                  <span className="text-[15px] font-inter text-gray-900">
                    {t(option)}
                  </span>
                </label>

                {/* Upload area + previews (only when checked) */}
                {isChecked && (
                  <div className="ml-6 flex flex-col gap-3">
                    <label className="inline-flex items-center justify-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md cursor-pointer w-max text-sm font-medium">
                      Upload Files
                      <input
                        type="file"
                        accept="*"
                        multiple
                        className="hidden"
                        onChange={(e) => {
                          const uploaded = Array.from(e.target.files);
                          setAttachmentFiles((prev) => ({
                            ...prev,
                            [option]: prev[option]
                              ? [...prev[option], ...uploaded]
                              : [...uploaded],
                          }));
                        }}
                      />
                    </label>

                    <div className="flex flex-wrap gap-3">
                      {/* LOCAL FILES */}
                      {(attachmentFiles[option] || []).map((file, idx) => {
                        const isImage = file.type?.startsWith("image/");
                        const isPDF = file.type === "application/pdf";
                        return (
                          <div
                            key={`local-${idx}`}
                            className="relative w-24 h-24 rounded-md overflow-hidden border shadow-sm flex items-center justify-center bg-gray-50"
                          >
                            <button
                              type="button"
                              onClick={() => {
                                setAttachmentFiles((prev) => {
                                  const updated = [...prev[option]];
                                  updated.splice(idx, 1);
                                  return { ...prev, [option]: updated };
                                });
                              }}
                              className="absolute top-1 right-1 bg-black bg-opacity-60 text-white w-5 h-5 flex items-center justify-center rounded-full text-xs hover:bg-opacity-80"
                            >
                              ×
                            </button>
                            {isImage && (
                              <img
                                src={URL.createObjectURL(file)}
                                className="w-full h-full object-cover"
                                onLoad={(e) => URL.revokeObjectURL(e.target.src)}
                              />
                            )}
                            {isPDF && (
                              <div className="flex flex-col items-center text-xs text-gray-700 px-1">
                                <span className="text-red-600 text-xl">📄</span>
                                <span className="text-center truncate w-full">
                                  {file.name}
                                </span>
                              </div>
                            )}
                            {!isImage && !isPDF && (
                              <div className="flex flex-col items-center text-xs text-gray-700 px-1">
                                <span className="text-blue-600 text-xl">📁</span>
                                <span className="text-center truncate w-full">
                                  {file.name}
                                </span>
                              </div>
                            )}
                          </div>
                        );
                      })}

                      {/* SERVER FILES (edit mode) */}
                      {(formData.attachments?.Files?.[option] || []).map(
                        (serverFile, sIdx) => {
                          const fileName = serverFile.file_name || "";
                          const lower = fileName.toLowerCase();
                          const isImage =
                            lower.endsWith(".jpg") ||
                            lower.endsWith(".jpeg") ||
                            lower.endsWith(".png");
                          const isPDF = lower.endsWith(".pdf");
                          return (
                            <div
                              key={`server-${sIdx}`}
                              className="relative w-24 h-24 rounded-md overflow-hidden border shadow-sm flex items-center justify-center bg-gray-50"
                            >
                              {isImage ? (
                                <img
                                  src={`https://hub2.ntactops.com/ntact/files/forms_files/${fileName}`}
                                  className="w-full h-full object-cover"
                                />
                              ) : isPDF ? (
                                <div className="flex flex-col items-center text-xs text-gray-700 px-1">
                                  <span className="text-red-600 text-xl">📄</span>
                                  <span className="text-center truncate w-full">
                                    {fileName}
                                  </span>
                                </div>
                              ) : (
                                <div className="flex flex-col items-center text-xs text-gray-700 px-1">
                                  <span className="text-blue-600 text-xl">📁</span>
                                  <span className="text-center truncate w-full">
                                    {fileName}
                                  </span>
                                </div>
                              )}
                              <button
                                type="button"
                                onClick={() => {
                                  setFormData((prev) => {
                                    const updatedList =
                                      prev.attachments.Files?.[option]?.filter(
                                        (f) =>
                                          f.file_name !== serverFile.file_name,
                                      ) || [];
                                    return {
                                      ...prev,
                                      attachments: {
                                        ...prev.attachments,
                                        Files: {
                                          ...prev.attachments.Files,
                                          [option]: updatedList,
                                        },
                                      },
                                    };
                                  });
                                }}
                                className="absolute top-1 right-1 bg-black bg-opacity-60 text-white w-5 h-5 flex items-center justify-center rounded-full text-xs hover:bg-opacity-80"
                              >
                                ×
                              </button>
                            </div>
                          );
                        },
                      )}

                      {/* Placeholder if no files exist */}
                      {(!attachmentFiles[option] ||
                        attachmentFiles[option].length === 0) &&
                        (!formData.attachments?.Files?.[option] ||
                          formData.attachments.Files[option].length === 0) && (
                          <div className="w-24 h-24 flex items-center justify-center border border-gray-200 rounded-md bg-gray-100 text-gray-400 text-xs">
                            No Files
                          </div>
                        )}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* Attach Relevant Documents — always-visible uploader. */}
      <div className="flex flex-col gap-3 px-4 py-3 border border-gray-200 rounded-lg mt-4">
        <div className="font-bold text-left">{t("Attachment")}</div>
        <div className="text-sm text-gray-700 text-left">
          {t("Attach Relevant Documents")}
        </div>

        <div className="flex flex-wrap items-center gap-3">
          <label className="inline-flex items-center justify-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md cursor-pointer w-max text-sm font-medium">
            Upload Files
            <input
              type="file"
              accept="*"
              multiple
              className="hidden"
              onChange={(e) => {
                const uploaded = Array.from(e.target.files || []);
                if (uploaded.length === 0) return;
                setRelevantDocsLocal((prev) => [...prev, ...uploaded]);
                e.target.value = "";
              }}
            />
          </label>
        </div>

        <div className="flex flex-wrap gap-3">
          {relevantDocsServer.map((doc, idx) => (
            <div
              key={`server-${idx}`}
              className="relative w-24 h-24 rounded-md overflow-hidden border shadow-sm flex items-center justify-center bg-gray-50"
              title={doc?.file_name || `Document ${idx + 1}`}
            >
              {doc?.file_name &&
              /\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(doc.file_name) ? (
                <img
                  src={`https://hub2.ntactops.com/ntact/files/forms_files/${doc.file_name}`}
                  alt={doc.file_name}
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="flex flex-col items-center justify-center text-[10px] text-gray-600 px-1 text-center">
                  <FontAwesomeIcon
                    icon={faUpload}
                    style={{ fontSize: 14, marginBottom: 4 }}
                  />
                  <span className="break-all line-clamp-2">
                    {doc?.file_name || "File"}
                  </span>
                </div>
              )}
              <button
                type="button"
                onClick={() => {
                  setRelevantDocsServer((prev) =>
                    prev.filter((_, i) => i !== idx),
                  );
                }}
                className="absolute top-1 right-1 bg-black bg-opacity-60 text-white w-5 h-5 flex items-center justify-center rounded-full text-xs hover:bg-opacity-80"
              >
                ×
              </button>
            </div>
          ))}

          {relevantDocsLocal.map((file, idx) => {
            const isImage = file.type?.startsWith("image/");
            return (
              <div
                key={`local-${idx}`}
                className="relative w-24 h-24 rounded-md overflow-hidden border shadow-sm flex items-center justify-center bg-gray-50"
                title={file.name}
              >
                {isImage ? (
                  <img
                    src={URL.createObjectURL(file)}
                    alt={file.name}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="flex flex-col items-center justify-center text-[10px] text-gray-600 px-1 text-center">
                    <FontAwesomeIcon
                      icon={faUpload}
                      style={{ fontSize: 14, marginBottom: 4 }}
                    />
                    <span className="break-all line-clamp-2">{file.name}</span>
                  </div>
                )}
                <button
                  type="button"
                  onClick={() => {
                    setRelevantDocsLocal((prev) =>
                      prev.filter((_, i) => i !== idx),
                    );
                  }}
                  className="absolute top-1 right-1 bg-black bg-opacity-60 text-white w-5 h-5 flex items-center justify-center rounded-full text-xs hover:bg-opacity-80"
                >
                  ×
                </button>
              </div>
            );
          })}

          {relevantDocsServer.length === 0 &&
            relevantDocsLocal.length === 0 && (
              <div className="w-24 h-24 flex items-center justify-center border border-gray-200 rounded-md bg-gray-100 text-gray-400 text-xs">
                No Files
              </div>
            )}
        </div>
      </div>
    </>
  );

  return (
    <div className="p-5">
      {/* Top Step Indicator */}
      <div className="flex items-center justify-between w-full mb-6 relative">
        <div className="absolute mb-[75px] left-1 flex items-center">
          <div className="flex items-center">
            <FiArrowLeft
              onClick={() => navigate(-1)}
              className="text-xl mt-2 mr-4 cursor-pointer"
            />
          </div>
          {currentStep !== 2 && (
            <div className=" font-inter text-sm mt-2 text-gray-600">
              Page {currentStep} of {steps.length}
            </div>
          )}
          <div className="mt-2 ml-6">
            <h2 className="text-lg font-inter  font-semibold">
              {t("Accident/Incident Investigation Form")}
            </h2>
          </div>
        </div>

        {/* Step indicators — full width, each step takes equal space */}
        <div className="w-full mt-5 pt-10 pb-2">
          <div className="flex items-start w-full">
            {steps.map((step, index) => {
              const isActive = currentStep === index + 1;
              const isPast = currentStep > index + 1;
              return (
                <div
                  key={index}
                  className="flex-1 flex flex-col items-center text-center"
                >
                  <div
                    className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold shrink-0 ${
                      isActive
                        ? "bg-black text-white ring-2 ring-black ring-offset-2"
                        : isPast
                        ? "bg-green-600 text-white"
                        : "bg-gray-200 text-gray-600"
                    }`}
                  >
                    {isPast ? "✓" : index + 1}
                  </div>
                  <div
                    className={`text-[10px] leading-tight font-inter mt-1 px-0.5 ${
                      isActive ? "font-semibold text-black" : "text-gray-500"
                    }`}
                  >
                    {t(step)}
                  </div>
                  {index === 11 && (
                    <div className="text-[9px] text-red-600 leading-tight">*Optional</div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {currentStep === 1 && (
        <>
          {/* Progress strip — kept on the merged Step 1 (Employee) page so
              users see overall completion before diving into the form. */}
          <div className="flex w-full justify-between mb-2 px-20">
            <div className="font-inter text-sm text-gray-600">
              Step {currentStep} of {steps.length}
            </div>
            <p className="font-inter text-sm">
              {Math.round((currentStep / steps.length) * 100)}%
            </p>
          </div>
          {/* Progress Bar */}
          <div className="w-full mb-4 px-20">
            <div className="bg-gray-200 h-2 rounded-full">
              <div
                className="bg-black h-2 rounded-full transition-all duration-300"
                style={{ width: `${(currentStep / steps.length) * 100}%` }}
              ></div>
            </div>
          </div>
        </>
      )}
      <div className="m-2 flex justify-end w-full px-20">
        <button
          onClick={() => changeLanguage("en")}
          className={`px-3 py-1 rounded ${
            selectedLanguage === "en"
              ? "bg-black text-white"
              : "bg-white text-black border border-gray-300"
          }`}
        >
          English
        </button>
        <button
          onClick={() => changeLanguage("es")}
          className={`px-3 py-1 rounded ${
            selectedLanguage === "es"
              ? "bg-black text-white"
              : "bg-white text-black border border-gray-300"
          }`}
        >
          Español
        </button>
      </div>

      {/* Form Content */}
      <div className="w-full flex items-center justify-center">
        <div className="bg-white rounded-lg shadow-md overflow-hidden w-[90%]">
          {/* Step Title — 6-step layout matches the mobile app */}
          <div className="flex bg-black text-white font-semibold font-inter p-4">
            {t("Step")}
            {currentStep}:&nbsp;{t(steps[currentStep - 1])}
          </div>

          {/* Step Content */}
          <div className="p-6">
            {currentStep === 1 && (
              <div className="flex flex-col lg:flex-row gap-6">
                {/* Left side: Form fields */}
                <div className="flex-1">
                  <h3 className="font-bold mb-6 text-lg text-left">
                    {t("Job Information")}
                  </h3>

                  {/* Method dropdown removed — not present in the mobile
                      app's 6-step layout. `formData.method` still exists in
                      state in case existing records carry it. */}
                  <div className="mb-4">
                    {/* Company ID */}
                    <div>
                      <label className="block font-bold text-sm text-left">
                        {t("Select Company")}
                      </label>
                      <select
                        className="w-full border rounded px-3 py-[10px] text-sm font-inter mt-1"
                        value={formData.companyId || ""}
                        onChange={(e) => {
                          const selectedId = e.target.value
                            ? parseInt(e.target.value, 10)
                            : null;
                          setSelectedCompanyId(selectedId);
                          setFormData((prev) => ({
                            ...prev,
                            companyId: selectedId,
                          }));
                        }}
                      >
                        <option className="font-inter text-xs" value="">
                          {t("Select a Company")}
                        </option>
                        {companyTabs.map((company) => (
                          <option
                            className="font-inter text-xs"
                            key={company.id}
                            value={company.id}
                          >
                            {t(company.name)}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Job Title — moved up to sit before JOB # so the
                      Job-Information group order matches the mobile app:
                      Company → Job Title → JOB # → Job Description. */}
                  <div className="mb-4">
                    <label className="block font-bold text-sm mb-1 text-left">
                      {t("Job Title")}
                    </label>
                    <input
                      type="text"
                      placeholder="Job Title"
                      value={formData.jobtitle}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          jobtitle: e.target.value,
                        }))
                      }
                      className="w-full p-2 border border-gray-300 rounded-md"
                    />
                  </div>

                  {/* Job Number */}
                  <div className="mb-4 relative" ref={jobInputRef}>
                    <label className="block font-bold text-sm mb-1 text-left">
                      {t("Job Number")}
                    </label>
                    <input
                      placeholder="Enter job Id"
                      type="text"
                      className="w-full border border-gray-300 rounded p-2 text-sm"
                      value={formData.jobNumber}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (!/^\d*$/.test(val)) {
                          return; // Prevent input if invalid character is detected
                        }

                        handleInputChange(
                          { target: { value: val } },
                          null,
                          "jobNumber",
                        );

                        if (!val.trim()) {
                          setSuggestions([]);
                          setShowSuggestions(false);
                        } else {
                          fetchJobSuggestions(val);
                          setShowSuggestions(true);
                        }
                      }}
                      onBlur={() => {
                        const isValid = suggestions.some(
                          (s) => s.job_num === formData.jobNumber,
                        );
                        if (!isValid) {
                          setFormData((prev) => ({
                            ...prev,
                            jobNumber: "",
                          }));
                          setJobCode("");
                          setSelectedJobName("");
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Tab" && suggestions?.length) {
                          handleJobCodeSelect(suggestions[0]);
                          e.preventDefault();
                        }
                        if (e.key === "ArrowDown") {
                          setHoveredJobIndex((prev) =>
                            prev === null || prev === suggestions.length - 1
                              ? 0
                              : prev + 1,
                          );
                        }
                        if (e.key === "ArrowUp") {
                          setHoveredJobIndex((prev) =>
                            prev === null || prev === 0
                              ? suggestions.length - 1
                              : prev - 1,
                          );
                        }
                      }}
                    />
                    {showSuggestions && suggestions.length > 0 && (
                      <ul className="absolute z-10 mt-1 left-0 text-start bg-white border border-gray-200 rounded-md shadow-lg max-h-[400px] overflow-y-auto text-sm w-full whitespace-nowrap">
                        {suggestions.map((code, index) => (
                          <li
                            key={index}
                            onClick={() => handleJobCodeSelect(code)}
                            onMouseEnter={() => setHoveredJobIndex(index)}
                            className={`px-2 py-1 cursor-pointer hover:bg-gray-100 ${
                              index === hoveredJobIndex ? "bg-gray-100" : ""
                            }`}
                          >
                            {code.job_num} - {code.job_name}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                  <div className="flex-1 mb-2">
                    <label className="block font-bold mb-2 text-left">
                      {t("Job Description")}
                    </label>
                    <input
                      type="text"
                      placeholder="Enter Job Description"
                      value={formData.job_description}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          job_description: e.target.value,
                        }))
                      }
                      className="w-full p-2 border border-gray-300 rounded-md"
                    />
                  </div>
                  <div className="flex-1 mb-2">
                    <div className="flex flex-col">
                      <label className="block font-bold mb-2 text-left">
                        {t("Time of Incident")}:
                      </label>
                      <DatePicker
                        selected={
                          formData.incidentdate
                            ? new Date(formData.incidentdate)
                            : null
                        }
                        onChange={(date) =>
                          setFormData((prev) => ({
                            ...prev,
                            incidentdate: date ? date.toISOString() : "",
                          }))
                        }
                        className="w-full p-2 border border-gray-300 rounded-md box-border"
                        showTimeSelect
                        timeFormat="hh:mm aa"
                        timeIntervals={15}
                        dateFormat="MM-dd-yyyy h:mm aa"
                        maxDate={new Date()}
                        placeholderText="MM-DD-YYYY HH:MM AM/PM"
                      />
                    </div>
                  </div>
                  <div className="flex gap-6 mb-6">
                    <div className="flex-1">
                      <label className="block font-bold mb-2 text-left">
                        {t("client")}
                      </label>
                      <input
                        type="text"
                        placeholder="client"
                        value={formData.client}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            client: e.target.value,
                          }))
                        }
                        className="w-full p-2 border border-gray-300 rounded-md"
                      />
                    </div>
                    <div className="flex-1">
                      <label className="block font-bold mb-2 text-left">
                        {t("Weather Condition")}
                      </label>
                      <input
                        type="text"
                        placeholder="Weather Condition"
                        value={formData.wheathercondition}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            wheathercondition: e.target.value,
                          }))
                        }
                        className="w-full p-2 border border-gray-300 rounded-md"
                      />
                    </div>
                  </div>
                  <div className="flex gap-6 mb-6">
                    <div className="flex-1">
                      <label className="block font-bold mb-2 text-left">
                        {t("Project Location")}
                      </label>
                      <input
                        type="text"
                        placeholder="Project Location"
                        value={formData.projectlocation}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            projectlocation: e.target.value,
                          }))
                        }
                        className="w-full p-2 border border-gray-300 rounded-md"
                      />
                    </div>
                    <div className="flex-1">
                      <label className="block font-bold mb-2 text-left">
                        {t("Direct Supervisor")}
                      </label>
                      <input
                        type="text"
                        placeholder="Direct Supervisor"
                        value={formData.directsupervisor}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            directsupervisor: e.target.value,
                          }))
                        }
                        className="w-full p-2 border border-gray-300 rounded-md"
                      />
                    </div>
                  </div>
                  {/* Driver */}
                  <div className="mb-4">
                    <label className="block font-bold text-md mb-2 text-left">
                      {t("Employee ID")}
                    </label>
                    <div className="relative" ref={empInputRef}>
                      <input
                        type="text"
                        placeholder="Enter Employee id"
                        className="w-full border border-gray-300 rounded p-2 py-2.5 text-sm"
                        value={formData.empname}
                        onChange={(e) => {
                          const val = e.target.value;
                          handleInputChange(e, null, "empname");
                          if (!val.trim()) {
                            setselectedempobj({});
                            setEmployeeSuggestions([]);
                            setShowEmpSuggestions(false);
                          } else {
                            fetchEmployeeSuggestions(val);
                          }
                        }}
                        onBlur={() => {
                          // Don't wipe a value that was hydrated in edit mode:
                          // selectedempobj is empty until the user picks from
                          // the autocomplete, so without this guard the loaded
                          // ID would get cleared the moment the input blurs.
                          if (
                            formData.emp_Id &&
                            String(formData.emp_Id) === String(formData.empname)
                          ) {
                            return;
                          }
                          if (
                            !selectedempobj ||
                            Object.keys(selectedempobj).length === 0
                          ) {
                            // No selection — clear both the search input and
                            // the auto-filled name so we don't ship stale data.
                            setFormData((prev) => ({
                              ...prev,
                              empname: "",
                              employeename: "",
                              emp_Id: null,
                            }));
                          }
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Tab" && employeeSuggestions?.length) {
                            handleEmployeeSelect(employeeSuggestions[0]);
                            e.preventDefault();
                          }
                          if (e.key === "ArrowDown") {
                            setHoveredEmpIndex((prev) =>
                              prev === null ||
                              prev === employeeSuggestions.length - 1
                                ? 0
                                : prev + 1,
                            );
                          }
                          if (e.key === "ArrowUp") {
                            setHoveredEmpIndex((prev) =>
                              prev === null || prev === 0
                                ? employeeSuggestions.length - 1
                                : prev - 1,
                            );
                          }
                        }}
                      />
                      {showEmpSuggestions && employeeSuggestions.length > 0 && (
                        <ul className="absolute z-10 mt-1 left-0 text-start bg-white border border-gray-200 rounded-md shadow-lg max-h-[300px] overflow-y-auto text-sm w-full">
                          {employeeSuggestions.map((emp, index) => (
                            <li
                              key={index}
                              onClick={() => handleEmployeeSelect(emp)}
                              onMouseEnter={() => setHoveredEmpIndex(index)}
                              className={`px-2 py-1 cursor-pointer hover:bg-gray-100 ${
                                index === hoveredEmpIndex ? "bg-gray-100" : ""
                              }`}
                            >
                              {`${emp.firstname} ${emp.lastname}`} - {emp.empid}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>

                  {/* DATE picker removed — the mobile app derives the filled
                      date from "Time of Incident" entered on the General-
                      Information block below. `formData.date` is kept in
                      state for backend compatibility. */}
                </div>

                {/* HEALTH SAFETY & ENVIRONMENTAL sidebar removed — the
                    mobile app doesn't show this document-header box on the
                    Employee step. */}
              </div>
            )}

            {/* Old "Step 2 — General Information" content is now part of the
                new Step 1 (Employee) — renders right after the Audit
                Information fields on the same page. */}
            {currentStep === 1 && (
              <>
                {/* <h3 className="font-inter mb-6 text-left">{t("Driver Log Entries")}</h3> */}
                <div className="overflow-x-auto">
                  <div className="flex gap-6 mb-6">
                    <div className="flex-1">
                      <label className="block font-bold mb-2 text-left">
                        {t("Name of Employee")}
                      </label>
                      <input
                        type="text"
                        placeholder="Name of Employee"
                        value={formData.employeename}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            employeename: e.target.value,
                          }))
                        }
                        className="w-full p-2 border border-gray-300 rounded-md"
                      />
                    </div>
                    {/* <div className="flex-1">
                      <label className="block font-bold mb-2 text-left">
                        {t("Employee/Badge #")}
                      </label>
                      <input
                        type="text"
                        placeholder="Employee/Badge #"
                        value={formData.employeebadge}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            employeebadge: e.target.value,
                          }))
                        }
                        className="w-full p-2 border border-gray-300 rounded-md"
                      />
                    </div> */}
                    <div className="flex-1">
                      <label className="block font-bold mb-2 text-left">
                        {t("Phone Number")}
                      </label>
                      <input
                        type="text"
                        placeholder="phonenumber"
                        value={formData.phonenumber}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d*$/.test(value)) {
                            setFormData((prev) => ({
                              ...prev,
                              phonenumber: value,
                            }));
                          }
                        }}
                        className="w-full p-2 border border-gray-300 rounded-md"
                      />
                    </div>
                  </div>
                  <div className="flex gap-6 mb-6">
                    <div className="flex-1">
                      <label className="block font-bold mb-2 text-left">
                        {t("Address")}
                      </label>
                      <input
                        type="text"
                        placeholder="Address"
                        value={formData.address}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            address: e.target.value,
                          }))
                        }
                        className="w-full p-2 border border-gray-300 rounded-md"
                      />
                    </div>
                    <div className="flex-1">
                      <label className="block font-bold mb-2 text-left">
                        {t("City")}
                      </label>
                      <input
                        type="text"
                        placeholder="City"
                        value={formData.city}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            city: e.target.value,
                          }))
                        }
                        className="w-full p-2 border border-gray-300 rounded-md"
                      />
                    </div>
                    <div className="flex-1">
                      <label className="block font-bold mb-2 text-left">
                        {t("State")}
                      </label>
                      <input
                        type="text"
                        placeholder="State"
                        value={formData.state}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            state: e.target.value,
                          }))
                        }
                        className="w-full p-2 border border-gray-300 rounded-md"
                      />
                    </div>
                  </div>
                  <div className="flex gap-6 mb-6">
                    <div className="flex-1">
                      <label className="block font-bold mb-2 text-left">
                        {t("Zip")}
                      </label>
                      <input
                        type="text"
                        placeholder="Zip"
                        value={formData.zipcode}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            zipcode: e.target.value,
                          }))
                        }
                        className="w-full p-2 border border-gray-300 rounded-md"
                      />
                    </div>

                  </div>

                  {/* Department — restored. Present in the mobile app's
                      Employee step as a "Select Department" dropdown. */}
                  {/* <div className="mb-6">
                    <label className="block font-bold mb-2 text-left">
                      {t("Department")}
                    </label>
                    <select
                      className="w-full border border-gray-300 rounded p-2 text-sm"
                      value={formData.department.selectedValue || ""}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          department: {
                            ...prev.department,
                            selectedValue: e.target.value,
                          },
                        }))
                      }
                    >
                      <option value="">{t("Select Department")}</option>
                      {formData.department.values.map((dep) => (
                        <option key={dep} value={dep}>
                          {t(dep)}
                        </option>
                      ))}
                    </select>
                  </div> */}

                  <div className="flex gap-6 mb-6">
                    <div className="flex-1">
                      <div className="flex flex-col gap-2 border-t border-gray-200 px-4 py-3">
                        <div className="block font-bold mb-2 text-left">
                          {t("Client Been Notified")}
                        </div>
                        <div className="flex flex-col items-start gap-3">
                          {formData.clientbeennotified.values.map((option) => (
                            <label
                              key={option}
                              className="flex items-center gap-2 cursor-pointer"
                            >
                              <input
                                type="radio"
                                name="client"
                                value={option}
                                checked={
                                  formData.clientbeennotified.selectedValue ===
                                  option
                                }
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    clientbeennotified: {
                                      ...formData.clientbeennotified,
                                      selectedValue: e.target.value,
                                    },
                                  })
                                }
                                className="accent-[rgba(24,24,27,1)] w-4 h-4"
                              />
                              <span className="text-[15px] font-inter text-gray-900">
                                {t(option)}
                              </span>
                            </label>
                          ))}
                        </div>
                      </div>
                    </div>

                    {/* Time Notified — only shown when Client Been Notified
                        is "Yes" (mirrors the mobile app). Hidden for "No". */}
                    {formData.clientbeennotified.selectedValue === "Yes" && (
                      <div className="flex-1">
                        <div className="flex flex-col border-t border-gray-200 px-4 py-3">
                          <label className="block font-bold mb-2 text-left">
                            {t("Time Notified")}:
                          </label>
                          <DatePicker
                            selected={
                              formData.timeNotified
                                ? new Date(formData.timeNotified)
                                : null
                            }
                            onChange={(date) =>
                              setFormData((prev) => ({
                                ...prev,
                                timeNotified: date ? date.toISOString() : "",
                              }))
                            }
                            className="w-full p-2 border border-gray-300 rounded-md box-border"
                            showTimeSelect
                            timeFormat="hh:mm aa"
                            timeIntervals={15}
                            dateFormat="MM-dd-yyyy h:mm aa"
                            maxDate={new Date()}
                            placeholderText="MM-DD-YYYY HH:MM AM/PM"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}

            {/* Step 2 — Classify (was Step 3 / Classification & Body Parts).
                Holds Classification, Injured Side, Body Parts, Injury Type
                and Post-Accident Drug & Alcohol Test sections. */}
            {currentStep === 2 && (
              <>
                <div className="flex-1">
                  <div className="flex flex-col gap-2 border-t border-gray-200 px-4 py-3">
                    <div className="block font-bold mb-2 text-left">
                      {t("Incident Classification")}
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 items-start">
                      {formData.damages.options.map((option) => (
                        <label
                          key={option}
                          className="flex items-center gap-2 cursor-pointer"
                        >
                          <input
                            type="checkbox"
                            value={option}
                            checked={formData.damages.selectedValues.includes(
                              option,
                            )}
                            onChange={(e) => {
                              const updatedSelections = e.target.checked
                                ? [...formData.damages.selectedValues, option]
                                : formData.damages.selectedValues.filter(
                                    (val) => val !== option,
                                  );
                              setFormData({
                                ...formData,
                                damages: {
                                  ...formData.damages,
                                  selectedValues: updatedSelections,
                                },
                              });
                            }}
                            className="accent-[rgba(24,24,27,1)] w-4 h-4"
                          />
                          <span className="text-[15px] font-inter text-gray-900">
                            {t(option)}
                          </span>
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="flex-1">
                  <div className="flex-1">
                    <div className="flex flex-col gap-2 border-t border-gray-200 px-4 py-3">
                      <div className="block font-bold mb-2 text-left">
                        {t("Injured Side")}
                      </div>
                      <div className="flex flex-col flex-wrap gap-4">
                        {formData.injuredside.options.map((option) => (
                          <label
                            key={option}
                            className="flex items-center gap-2 cursor-pointer"
                          >
                            <input
                              type="radio"
                              name="injuredside"
                              value={option}
                              checked={
                                formData.injuredside.selectedValue === option
                              }
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  injuredside: {
                                    ...formData.injuredside,
                                    selectedValue: e.target.value,
                                  },
                                });
                              }}
                              className="accent-[rgba(24,24,27,1)] w-4 h-4"
                            />
                            <span className="text-[15px] font-inter text-gray-900">
                              {t(option)}
                            </span>
                          </label>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="flex-1">
                    <div className="flex flex-col gap-2 border-t border-gray-200 px-4 py-3">
                      <div className="block font-bold mb-2 text-left">
                        {t("Body Parts Injured (Check all that apply)")}
                      </div>
                      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 items-start">
                        {formData.bodypartsinjuried.options.map((option) => (
                          <label
                            key={option}
                            className="flex items-center gap-2 cursor-pointer"
                          >
                            <input
                              type="checkbox"
                              value={option}
                              checked={formData.bodypartsinjuried.selectedValues.includes(
                                option,
                              )}
                              onChange={(e) => {
                                const updatedSelections = e.target.checked
                                  ? [
                                      ...formData.bodypartsinjuried
                                        .selectedValues,
                                      option,
                                    ]
                                  : formData.bodypartsinjuried.selectedValues.filter(
                                      (val) => val !== option,
                                    );
                                setFormData({
                                  ...formData,
                                  bodypartsinjuried: {
                                    ...formData.bodypartsinjuried,
                                    selectedValues: updatedSelections,
                                  },
                                });
                              }}
                              className="accent-[rgba(24,24,27,1)] w-4 h-4"
                            />
                            <span className="text-[15px] font-inter text-gray-900">
                              {t(option)}
                            </span>
                          </label>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Injury Type — added to mirror the mobile app's Classify
                    page. Stores the picked option on formData.injurytype.
                    `enterManually` lets the user override the dropdown with
                    a free-text description, matching the app's behaviour. */}
                <div className="flex flex-col gap-2 border-t border-gray-200 px-4 py-3">
                  <div className="flex items-center justify-between flex-wrap gap-2">
                    <label className="block font-bold text-left">
                      {t("Injury Type")}
                    </label>
                    <label className="flex items-center gap-2 text-sm cursor-pointer text-gray-700">
                      <input
                        type="checkbox"
                        checked={!!formData.enterManually}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            enterManually: e.target.checked,
                          }))
                        }
                        className="accent-[rgba(24,24,27,1)] w-4 h-4"
                      />
                      {t("Describe Injury Type manually")}
                    </label>
                  </div>
                  {formData.enterManually ? (
                    <textarea
                      placeholder={t("Describe the type of injury")}
                      value={formData.incidentDescription || ""}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          incidentDescription: e.target.value,
                        }))
                      }
                      className="w-full p-2 border border-gray-300 rounded-md min-h-[80px] text-sm"
                    />
                  ) : (
                    <select
                      value={formData.injurytype.selectedvalue || ""}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          injurytype: {
                            ...prev.injurytype,
                            selectedvalue: e.target.value,
                          },
                        }))
                      }
                      className="w-full bg-[#F3F3F5] border rounded px-3 py-[10px] text-sm font-inter"
                    >
                      <option value="">{t("Select Injury Type")}</option>
                      {formData.injurytype.options.map((opt) => (
                        <option key={opt} value={opt}>
                          {t(opt)}
                        </option>
                      ))}
                    </select>
                  )}
                </div>

                {/* <div className="flex gap-12 border-t border-gray-200 px-4 py-3">

                  <div className="flex flex-col gap-2">
                    <div className="font-bold text-left">
                      {t("Post-Accident UA")}
                    </div>
                    <div className="flex gap-6">
                      {formData.postaccidentua.options.map((option) => (
                        <label
                          key={option}
                          className="flex items-center gap-2 cursor-pointer"
                        >
                          <input
                            type="checkbox"
                            value={option}
                            checked={formData.postaccidentua.selectedValues?.includes(
                              option
                            )}
                            onChange={(e) => {
                              const updated = e.target.checked
                                ? [
                                    ...(formData.postaccidentua
                                      .selectedValues || []),
                                    option,
                                  ]
                                : (
                                    formData.postaccidentua.selectedValues || []
                                  ).filter((v) => v !== option);
                              setFormData({
                                ...formData,
                                postaccidentua: {
                                  ...formData.postaccidentua,
                                  selectedValues: updated,
                                },
                              });
                            }}
                            className="accent-[rgba(24,24,27,1)] w-4 h-4"
                          />
                          <span className="text-[15px] font-inter text-gray-900">
                            {t(option)}
                          </span>
                        </label>
                      ))}
                    </div>
                  </div>

       
                  <div className="flex flex-col gap-2">
                    <div className="font-bold text-left">{t("Test Type")}</div>
                    <div className="flex gap-6">
                      {formData.testtype.options.map((option) => (
                        <label
                          key={option}
                          className="flex items-center gap-2 cursor-pointer"
                        >
                          <input
                            type="checkbox"
                            value={option}
                            checked={formData.testtype.selectedValues?.includes(
                              option
                            )}
                            onChange={(e) => {
                              const updated = e.target.checked
                                ? [
                                    ...(formData.testtype.selectedValues || []),
                                    option,
                                  ]
                                : (
                                    formData.testtype.selectedValues || []
                                  ).filter((v) => v !== option);
                              setFormData({
                                ...formData,
                                testtype: {
                                  ...formData.testtype,
                                  selectedValues: updated,
                                },
                              });
                            }}
                            className="accent-[rgba(24,24,27,1)] w-4 h-4"
                          />
                          <span className="text-[15px] font-inter text-gray-900">
                            {t(option)}
                          </span>
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="flex gap-6 mb-6">
                  <div className="flex-1">
                    <label className="block font-bold mb-2 text-left">
                      {t("facility")}
                    </label>
                    <input
                      type="text"
                      placeholder="facility"
                      value={formData.facility}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          facility: e.target.value,
                        }))
                      }
                      className="w-full p-2 border border-gray-300 rounded-md"
                    />
                  </div>
                  <div className="flex-1">
                    <label className="block font-bold mb-2 text-left">
                      {t("collector")}
                    </label>
                    <input
                      type="text"
                      placeholder="collector"
                      value={formData.collector}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          collector: e.target.value,
                        }))
                      }
                      className="w-full p-2 border border-gray-300 rounded-md"
                    />
                  </div>
                </div> */}
                <div className="bg-white rounded-xl shadow-sm border mb-2 border-gray-200 p-6 w-full">
                  <div className="text-[15px] text-start font-semibold mb-4">
                    {t("Post-Accident Drug & Alcohol Testing")}
                  </div>

                  <div className="flex gap-12  pt-4">
                    <div className="flex flex-col gap-2">
                      <div className="flex gap-6">
                        {formData.postaccidentua.options.map((option) => (
                          <label
                            key={option}
                            className="flex items-center gap-2 cursor-pointer"
                          >
                            <input
                              type="checkbox"
                              value={option}
                              checked={formData.postaccidentua.selectedValues?.includes(
                                option,
                              )}
                              onChange={(e) => {
                                // "Post-accident drug/alcohol test required"
                                // and "N/A" are mutually exclusive — picking
                                // one clears the other. Picking N/A also
                                // clears Facility/Collector/Test Type since
                                // the Testing Information section disappears.
                                const isNA = option === "N/A";
                                let updated;
                                if (e.target.checked) {
                                  updated = [option];
                                } else {
                                  updated = (
                                    formData.postaccidentua.selectedValues || []
                                  ).filter((v) => v !== option);
                                }
                                setFormData((prev) => ({
                                  ...prev,
                                  postaccidentua: {
                                    ...prev.postaccidentua,
                                    selectedValues: updated,
                                  },
                                  ...(isNA && e.target.checked
                                    ? {
                                        facility: "",
                                        collector: "",
                                        testtype: {
                                          ...prev.testtype,
                                          selectedValue: "",
                                        },
                                      }
                                    : {}),
                                }));
                              }}
                              className="accent-[rgba(24,24,27,1)] w-4 h-4"
                            />
                            <span className="text-[15px] font-inter text-gray-900">
                              {t(option)}
                            </span>
                          </label>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                {/* Testing Information is only relevant when the "test
                    required" option is selected. Picking N/A (or
                    de-selecting both) hides this section. */}
                {(formData.postaccidentua.selectedValues || []).includes(
                  "Post-accident drug/alcohol test required",
                ) && (
                  <div className="flex flex-col gap-4 w-full">
                    {(formData.testingInformationList || []).map((info, tIndex) => (
                      <div
                        key={tIndex}
                        className="bg-[#E4E4E7] flex flex-col gap-4 rounded-xl shadow-sm border mb-2 border-gray-200 p-6 w-full"
                      >
                        <div className="flex items-center justify-between">
                          <div className="text-[15px] text-start font-semibold">
                            {t("Testing Information")} {tIndex + 1}
                          </div>
                          {(formData.testingInformationList || []).length > 1 && (
                            <button
                              type="button"
                              onClick={() => handleRemoveTestingInfo(tIndex)}
                              className="text-sm font-medium text-red-600 hover:text-red-700"
                            >
                              {t("Remove")}
                            </button>
                          )}
                        </div>

                        <div className="flex-1">
                          <label className="block font-bold mb-2 text-left">
                            {t("facility")}
                          </label>
                          <input
                            type="text"
                            placeholder="Enter facility name"
                            value={info.facility}
                            onChange={(e) =>
                              handleTestingInfoChange(tIndex, "facility", e.target.value)
                            }
                            className="w-full p-2 bg-[#F3F3F5] border border-gray-300 rounded-md placeholder-gray-400"
                          />
                        </div>
                        <div className="flex-1">
                          <label className="block font-bold mb-2 text-left">
                            {t("collector")}
                          </label>
                          <input
                            type="text"
                            placeholder="Enter collector name"
                            value={info.collector}
                            onChange={(e) =>
                              handleTestingInfoChange(tIndex, "collector", e.target.value)
                            }
                            className="w-full p-2 border bg-[#F3F3F5] border-gray-300 rounded-md placeholder-gray-400"
                          />
                        </div>

                        <div className="flex flex-col gap-2 mt-2">
                          <div className="font-bold text-left">
                            {t("Test Type")}
                          </div>
                          <select
                            value={info.testType || ""}
                            onChange={(e) =>
                              handleTestingInfoChange(tIndex, "testType", e.target.value)
                            }
                            className="w-full bg-[#F3F3F5] border rounded px-3 py-[10px] text-sm font-inter mt-1"
                          >
                            <option value="" disabled>
                              {t("Select a Test Type")}
                            </option>
                            {formData.testtype.options.map((option) => (
                              <option key={option} value={option}>
                                {t(option)}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    ))}

                  </div>
                )}

                {/* Employee Information — only shows when post-accident test
                    is required (same gate as Testing Information). */}
                {(formData.postaccidentua.selectedValues || []).includes(
                  "Post-accident drug/alcohol test required",
                ) && (
                  <div className="flex flex-col gap-4 w-full mt-4">
                    <div className="flex items-center justify-between">
                      <div className="text-[15px] text-start font-semibold">
                        {t("Employee Information")}
                      </div>
                      <button
                        type="button"
                        onClick={handleAddEmployeeInfo}
                        className="flex items-center gap-2 px-4 py-2 text-sm font-medium rounded bg-gray-800 text-white transition duration-200 hover:bg-gray-700 cursor-pointer"
                      >
                        <span className="text-lg font-bold">+</span>
                      </button>
                    </div>
                    {(formData.employeeInformationList || []).map((info, eIndex) => (
                      <div
                        key={eIndex}
                        className="bg-[#E4E4E7] flex flex-col gap-4 rounded-xl shadow-sm border mb-2 border-gray-200 p-6 w-full"
                      >
                        <div className="flex items-center justify-between">
                          <div className="text-[15px] text-start font-semibold">
                            {t("Employee Information")} {eIndex + 1}
                          </div>
                          {(formData.employeeInformationList || []).length > 1 && (
                            <button
                              type="button"
                              onClick={() => handleRemoveEmployeeInfo(eIndex)}
                              className="text-red-600 font-medium text-sm hover:underline"
                            >
                              {t("Remove")}
                            </button>
                          )}
                        </div>
                        <div className="flex-1">
                          <label className="block font-bold mb-2 text-left">
                            {t("Employee Name")} <span className="text-red-600">*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="Enter employee name"
                            value={info.employeeName}
                            onChange={(e) =>
                              handleEmployeeInfoChange(eIndex, "employeeName", e.target.value)
                            }
                            className="w-full p-2 bg-[#F3F3F5] border border-gray-300 rounded-md placeholder-gray-400"
                          />
                        </div>
                        <div className="flex-1">
                          <label className="block font-bold mb-2 text-left">
                            {t("Employee Phone Number")} <span className="text-red-600">*</span>
                          </label>
                          <input
                            type="tel"
                            placeholder="Enter employee phone number"
                            value={info.employeePhoneNumber}
                            onChange={(e) =>
                              handleEmployeeInfoChange(eIndex, "employeePhoneNumber", e.target.value)
                            }
                            className="w-full p-2 bg-[#F3F3F5] border border-gray-300 rounded-md placeholder-gray-400"
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {/* Employee/Supervisor Sign-off block (previously the bottom of Step 3)
      is suppressed in the 6-step app-aligned layout. Wrapped in
      `{false && <>...</>}` (fragment) because the section is multiple
      sibling rows — without a fragment Babel rejects adjacent JSX. */}
                {false && (
                  <>
                    <div className="flex gap-6 mb-6">
                      <div className="flex-1">
                        <label className="block font-bold mb-2 text-left">
                          {t("Employee Name (Print)")}
                        </label>
                        <input
                          type="text"
                          placeholder="Employee Name"
                          value={formData.employeenameprint}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              employeenameprint: e.target.value,
                            }))
                          }
                          className="w-full p-2 border border-gray-300 rounded-md"
                        />
                      </div>
                      <div className="flex-1">
                        <label className="block font-bold mb-2 text-left">
                          {t("Signature")}
                        </label>
                        <input
                          type="text"
                          placeholder="Signature"
                          value={formData.employeenameprintsignature}
                          // onChange={(e) =>
                          //   setFormData((prev) => ({
                          //     ...prev,
                          //  employeenameprintsignature: e.target.value,
                          //   }))
                          // }
                          onClick={() => {
                            type.current = "employee";
                            setSignatureModal(true);
                          }}
                          className="w-full p-2 border border-gray-300 rounded-md"
                        />
                      </div>

                      <div className="flex-1">
                        <label className="block font-bold mb-2 text-left">
                          {t("Date")}:
                        </label>
                        <DatePicker
                          selected={
                            formData.employeenameprintsignaturedate
                              ? new Date(
                                  formData.employeenameprintsignaturedate +
                                    "T00:00:00",
                                )
                              : null
                          } // Ensure local date parsing
                          onChange={(date) =>
                            setFormData((prev) => {
                              const formattedDate = date
                                ? `${date.getFullYear()}-${String(
                                    date.getMonth() + 1,
                                  ).padStart(2, "0")}-${String(
                                    date.getDate(),
                                  ).padStart(2, "0")}`
                                : "";

                              return {
                                ...prev,
                                employeenameprintsignaturedate: formattedDate, // Store as yyyy-MM-dd in local time
                              };
                            })
                          }
                          className="w-full p-2 border border-gray-300 rounded-md"
                          wrapperClassName="w-full"
                          dateFormat="MM-dd-yyyy" // Display format as MM-dd-yyyy
                          maxDate={new Date()} // Disables future dates
                          placeholderText="MM-DD-YYYY" // Improves UX
                        />
                      </div>
                    </div>
                    <div className="flex gap-6 mb-6">
                      <div className="flex-1">
                        <label className="block font-bold mb-2 text-left">
                          {t("Supervisor Name (Print)")}
                        </label>
                        <input
                          type="text"
                          placeholder="Supervisor Name"
                          value={formData.supervisornameprint}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              supervisornameprint: e.target.value,
                            }))
                          }
                          className="w-full p-2 border border-gray-300 rounded-md"
                        />
                      </div>
                      <div className="flex-1">
                        <label className="block font-bold mb-2 text-left">
                          {t("Signature")}
                        </label>
                        <input
                          type="text"
                          placeholder="Signature"
                          value={formData.supervisorprintsignature}
                          // onChange={(e) =>
                          //   setFormData((prev) => ({
                          //     ...prev,
                          //  supervisorprintsignature: e.target.value,
                          //   }))
                          // }
                          onClick={() => {
                            type.current = "supervisor";
                            setSignatureModal(true);
                          }}
                          className="w-full p-2 border border-gray-300 rounded-md"
                        />
                      </div>

                      <div className="flex-1">
                        <label className="block font-bold mb-2 text-left">
                          {t("Date")}:
                        </label>
                        <DatePicker
                          selected={
                            formData.supervisorprintsignaturedate
                              ? new Date(
                                  formData.supervisorprintsignaturedate +
                                    "T00:00:00",
                                )
                              : null
                          } // Ensure local date parsing
                          onChange={(date) =>
                            setFormData((prev) => {
                              const formattedDate = date
                                ? `${date.getFullYear()}-${String(
                                    date.getMonth() + 1,
                                  ).padStart(2, "0")}-${String(
                                    date.getDate(),
                                  ).padStart(2, "0")}`
                                : "";

                              return {
                                ...prev,
                                supervisorprintsignaturedate: formattedDate, // Store as yyyy-MM-dd in local time
                              };
                            })
                          }
                          className="w-full p-2 border border-gray-300 rounded-md"
                          wrapperClassName="w-full"
                          dateFormat="MM-dd-yyyy" // Display format as MM-dd-yyyy
                          maxDate={new Date()} // Disables future dates
                          placeholderText="MM-DD-YYYY" // Improves UX
                        />
                      </div>
                    </div>
                    <div className="flex gap-4">
                      <div className="flex flex-col items-center p-4 border border-gray-300 rounded-md bg-white shadow-sm w-48">
                        <span className="text-sm font-medium text-gray-700 mb-3">
                          employee Signature
                        </span>
                        {employeesignimg ? (
                          <img
                            className="w-40 h-24 object-contain border border-gray-200 rounded-md bg-white"
                            src={
                              employeesignimg instanceof File
                                ? URL.createObjectURL(employeesignimg)
                                : employeesignimg
                            }
                            alt="Supervisor Signature"
                            onLoad={(e) => {
                              if (employeesignimg instanceof File) {
                                URL.revokeObjectURL(e.target.src);
                              }
                            }}
                          />
                        ) : formData?.employeeSignImg ? (
                          <>
                            {" "}
                            <img
                              className="w-40 h-24 object-contain border border-gray-200 rounded-md bg-white"
                              src={`https://hub2.ntactops.com/ntact/files/forms_files/${formData?.employeeSignImg?.file_name}`}
                              alt="Supervisor Signature"
                            />
                          </>
                        ) : (
                          <div className="w-40 h-24 flex items-center justify-center border border-gray-200 rounded-md bg-gray-100 text-gray-400 text-xs">
                            No signature
                          </div>
                        )}
                      </div>
                      <div className="flex flex-col items-center p-4 border border-gray-300 rounded-md bg-white shadow-sm w-48">
                        <span className="text-sm font-medium text-gray-700 mb-3">
                          supervisor Signature
                        </span>
                        {supervisorsignimg ? (
                          <img
                            className="w-40 h-24 object-contain border border-gray-200 rounded-md bg-white"
                            src={
                              supervisorsignimg instanceof File
                                ? URL.createObjectURL(supervisorsignimg)
                                : supervisorsignimg
                            }
                            alt="Supervisor Signature"
                            onLoad={(e) => {
                              if (supervisorsignimg instanceof File) {
                                URL.revokeObjectURL(e.target.src);
                              }
                            }}
                          />
                        ) : formData?.supervisorSignImg ? (
                          <>
                            {" "}
                            <img
                              className="w-40 h-24 object-contain border border-gray-200 rounded-md bg-white"
                              src={`https://hub2.ntactops.com/ntact/files/forms_files/${formData?.supervisorSignImg?.file_name}`}
                              alt="Supervisor Signature"
                            />
                          </>
                        ) : (
                          <div className="w-40 h-24 flex items-center justify-center border border-gray-200 rounded-md bg-gray-100 text-gray-400 text-xs">
                            No signature
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
                {/* end of suppressed sign-off block */}
              </>
            )}
            {/* Step 3 — Details (was Step 4 / Incident & Injury). Includes accident
      description, incident cause, attachments, and witness information. */}
            {currentStep === 3 && (
              <>
                <div className="text-start font-semibold text-base mb-4">
                  {t("Incident Details")}
                </div>
                <div className="flex flex-col gap-6">
                  {/* <div className="flex-1">
  <label className="flex items-center gap-2 cursor-pointer">
    <input
      type="checkbox"
      checked={formData.enterManually || false}
      onChange={(e) => {
        setFormData({
          ...formData,
          enterManually: e.target.checked,
        });
      }}
      className="accent-[rgba(24,24,27,1)] w-4 h-4"
    />
    <span className="text-[15px] font-inter text-gray-900">
      {t("Enter Manually")}
    </span>
  </label>
</div> */}
                  <div className="flex-1">
                    <div className="bg-[#E4E4E7] text-start rounded-xl px-4 py-4">
                      <label className="block text-sm font-medium text-black mb-4">
                        {t("Accident Description")}
                      </label>
                      <div className="text-sm font-semibold text-[#0A0A0A] mb-1">
                        {t("Detailed description of what happened")}
                      </div>
                      <textarea
                        value={formData.descriptionofincident}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            descriptionofincident: e.target.value,
                          })
                        }
                        rows={3}
                        placeholder={t(
                          "Provide a detailed description of the accident/incident...",
                        )}
                        className="w-full bg-[#F3F3F5] text-sm text-gray-700 font-inter p-3 rounded-md resize-none focus:outline-none"
                      />
                    </div>
                  </div>
                  <div className="flex-1">
                    <div className="bg-[#E4E4E7] text-start rounded-xl px-4 py-4">
                      <label className="block text-sm font-medium text-black mb-4">
                        {t("Incident Cause")}
                      </label>
                      {/* <div className="text-sm font-semibold text-[#0A0A0A] mb-1">
    {t("What caused this incident?")}
  </div> */}
                      {/* <textarea
    value={formData.incidentDescription}
    onChange={(e) =>
      setFormData({
        ...formData,
        incidentDescription: e.target.value,
      })
    }
    rows={3}
    placeholder={t("Describe the root causes and contributing factors...")}
    className="w-full bg-[#F3F3F5] text-sm text-gray-700 font-inter p-3 rounded-md resize-none focus:outline-none"
  /> */}
                      {/* <div className="text-sm font-semibold text-[#0A0A0A] mt-3 mb-1">
    {t("Incident Cause")}
  </div> */}
                      <select
                        value={formData.incidentcause.selectedvalue}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            incidentcause: {
                              ...formData.incidentcause,
                              selectedvalue: e.target.value,
                            },
                          })
                        }
                        className="w-full bg-[#F3F3F5] text-sm text-gray-700 font-inter p-3 rounded-md focus:outline-none"
                      >
                        <option value="">
                          {t("Select an incident cause")}
                        </option>
                        {formData.incidentcause.options.map((option) => (
                          <option key={option} value={option}>
                            {t(option)}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Additional Note */}
                  <div className="flex-1 mb-2">
                    <div className="bg-[#E4E4E7] text-start rounded-xl px-4 py-4">
                      <label className="block text-sm font-medium text-black mb-4">
                        {t("Additional Note")}
                      </label>
                      <textarea
                        value={formData.additionalNote}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            additionalNote: e.target.value,
                          })
                        }
                        rows={4}
                        placeholder={t("Enter any additional notes...")}
                        className="w-full bg-[#F3F3F5] text-sm text-gray-700 font-inter p-3 rounded-md resize-none focus:outline-none"
                      />
                    </div>
                  </div>

                  {/* <div className="flex-1">
                    <div className="bg-[#E4E4E7] text-start rounded-xl px-4 py-4">
                      <label className="block text-sm font-medium text-black mb-4">
                        {t("Incident Summary")}
                      </label>
                      <div className="text-sm font-semibold text-[#0A0A0A] mb-1">
                        {t("Summary of incident")}
                      </div>
                      <textarea
                        value={formData.incidentsummary}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            incidentsummary: e.target.value,
                          })
                        }
                        rows={3}
                        placeholder={t(
                          "Provide a brief summary of the incident...",
                        )}
                        className="w-full bg-[#F3F3F5] text-sm text-gray-700 font-inter p-3 rounded-md resize-none focus:outline-none"
                      />
                    </div>
                  </div> */}
                  {/* Attachments moved to Step 5 (mobile parity). */}
                  {/* Witness Information moved to Step 10 (mobile parity). */}
                </div>

                {/* <div className="flex-1">
                  <div className="flex flex-col gap-2 px-4 py-3">
                    <label className="block font-bold mb-2 text-left">
                      {t("Type of Injury")}
                    </label>
                    <select
                      value={formData.injurytype.selectedvalue}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          injurytype: {
                            ...formData.injurytype,
                            selectedvalue: e.target.value,
                          },
                        })
                      }
                      className="w-full p-2 border border-gray-300 rounded-md text-[15px] font-inter text-gray-900"
                    >
                      <option value="" disabled>
                        {t("Select an injury type")}
                      </option>
                      {formData.injurytype.options.map((option) => (
                        <option key={option} value={option}>
                          {t(option)}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="flex-1">
                  <div className="flex flex-col gap-2 border-t border-gray-200 px-4 py-3">
                    <label className="block font-bold mb-2 text-left">
                      {t("Incident Cause")}
                    </label>
                    <select
                      value={formData.incidentcause.selectedvalue}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          incidentcause: {
                            ...formData.incidentcause,
                            selectedvalue: e.target.value,
                          },
                        })
                      }
                      className="w-full p-2 border border-gray-300 rounded-md text-[15px] font-inter text-gray-900"
                    >
                      <option value="" disabled>
                        {t("Select an incident cause")}
                      </option>
                      {formData.incidentcause.options.map((option) => (
                        <option key={option} value={option}>
                          {t(option)}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
       
                <div className="flex-1">
                  <div className="flex flex-col gap-2 border-t border-gray-200 px-4 py-3">
                    <label className="block font-bold mb-2 text-left">
                      {t("Witness Statement")}
                    </label>
                    <textarea
                      value={formData.witnessstatement}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          witnessstatement: e.target.value,
                        })
                      }
                      rows={5}
                      placeholder={t("Enter the witness statement")}
                      className="w-full p-2 border border-gray-300 rounded-md text-[15px] font-inter text-gray-900 resize-none"
                    />
                  </div>
                </div> */}
              </>
            )}
            {/* Step 10 — Witness/Statements. Holds Witness, Employee, and
      Supervisor Statements. */}
            {currentStep === 10 && (
              <>
                <div className="text-start font-semibold text-base mb-4 mt-4">
                  {t("Witness Information")}
                </div>
                <div className="flex flex-col gap-6">
                  <div className="bg-white border border-gray-200 rounded-xl px-4 py-4">
                    <div className="text-sm text-start font-semibold text-gray-800 mb-2">
                      {t("Were there any witnesses?")}
                    </div>
                    <div className="flex flex-col gap-4">
                      {["Yes", "No"].map((option) => (
                        <label
                          key={option}
                          className="flex items-center gap-2 cursor-pointer"
                        >
                          <input
                            type="radio"
                            name="anyWitness"
                            value={option}
                            checked={formData?.anyWitness === option}
                            onChange={(e) => {
                              const next = e.target.value;
                              setFormData((prev) => ({
                                ...prev,
                                anyWitness: next,
                                witnessCards:
                                  next === "Yes"
                                    ? [{ name: "", phone: "" }]
                                    : [],
                              }));
                            }}
                            className="accent-[rgba(24,24,27,1)]"
                          />
                          <span className="text-sm text-gray-900 font-inter">
                            {t(option)}
                          </span>
                        </label>
                      ))}
                    </div>
                  </div>
                  {formData?.anyWitness === "Yes" && (
                  <div className="flex flex-col text-start gap-4">
                    {formData?.witnessCards?.map((witness, index) => (
                      <div
                        key={index}
                        className="relative bg-white border border-gray-200 rounded-xl px-4 py-4"
                      >
                        {formData.witnessCards.length > 1 && (
                          <button
                            type="button"
                            onClick={() => {
                              const updated = formData.witnessCards.filter(
                                (_, i) => i !== index,
                              );
                              setFormData({
                                ...formData,
                                witnessCards: updated,
                              });
                            }}
                            className="absolute top-2 right-2 text-gray-400 hover:text-red-500 text-lg font-bold"
                          >
                            ×
                          </button>
                        )}

                        <div className="text-sm font-semibold text-gray-800 mb-3">
                          {t(`Witness ${index + 1}`)}
                        </div>

                        <div className="mb-3">
                          <label className="block text-sm text-gray-700 mb-1">
                            {t("Name")}
                          </label>
                          <input
                            type="text"
                            value={witness.name}
                            onChange={(e) => {
                              const updated = [...formData.witnessCards];
                              updated[index].name = e.target.value;
                              setFormData({
                                ...formData,
                                witnessCards: updated,
                              });
                            }}
                            placeholder={t("Enter witness name")}
                            className="w-full bg-gray-100 text-sm text-gray-700 font-inter p-3 rounded-md"
                          />
                        </div>

                        <div>
                          <label className="block text-sm text-gray-700 mb-1">
                            {t("Phone Number")}
                          </label>
                          <input
                            type="text"
                            value={witness.phone}
                            onChange={(e) => {
                              const updated = [...formData.witnessCards];
                              updated[index].phone = e.target.value;
                              setFormData({
                                ...formData,
                                witnessCards: updated,
                              });
                            }}
                            placeholder={t("Enter witness phone number")}
                            className="w-full bg-gray-100 text-sm text-gray-700 font-inter p-3 rounded-md"
                          />
                        </div>
                      </div>
                    ))}

                    <button
                      type="button"
                      onClick={() =>
                        setFormData({
                          ...formData,
                          witnessCards: [
                            ...(formData.witnessCards || []),
                            { name: "", phone: "" },
                          ],
                        })
                      }
                      className="self-center mt-2 w-8 h-8 rounded bg-gray-800 text-white flex items-center justify-center text-sm"
                    >
                      +
                    </button>
                  </div>
                  )}
                </div>

                {/* ===== Witness Statement section (moved before Employee
                    Statement to match mobile app order). ===== */}
                <div className="flex justify-end mb-2">
                  <button
                    onClick={handleAddWitnessStatement}
                    disabled={!checkwitnessLastStatementFilled()}
                    className={`flex items-center gap-2 px-4 py-2 text-sm font-medium rounded bg-gray-800 text-white transition duration-200 ${
                      checkwitnessLastStatementFilled()
                        ? "hover:bg-gray-700 cursor-pointer"
                        : "opacity-50 cursor-not-allowed"
                    }`}
                  >
                    <span className="text-lg font-bold">+</span>
                  </button>
                </div>

                {formData.witnessStatements.map((statement, index) => (
                  <div
                    key={index}
                    className="p-6 mb-6"
                    style={{
                      borderRadius: "8px",
                      border: "1px solid #E4E4E7",
                      background: "#FFF",
                      boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
                    }}
                  >
                    {formData.witnessStatements.length > 1 ? (
                      <div className="flex justify-end mb-2">
                        <button
                          onClick={() => handlewitnessRemoveStatement(index)}
                          className="text-red-600 font-medium text-sm hover:underline"
                        >
                          {t("Delete")}
                        </button>
                      </div>
                    ) : (
                      <></>
                    )}
                    <div className="text-[15px] text-start font-semibold mb-4">
                      {t("Witness Statement")} {index + 1}
                    </div>
                    {/* Image Upload */}
                    <div className="mt-4">
                      <div className="w-full flex justify-start">
                        <label className="inline-flex items-center px-4 py-2 bg-gray-100 text-gray-800 text-sm font-medium rounded cursor-pointer border border-gray-300 hover:bg-gray-200">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1M12 12V4m0 0L8 8m4-4l4 4"
                            />
                          </svg>
                          {t("Upload Image")}
                          <input
                            type="file"
                            accept="image/*"
                            multiple
                            className="hidden"
                            onChange={(e) => handleWitnessImageUpload(e, index)}
                          />
                        </label>
                      </div>

                      {/* Previews */}
                      <div className="flex flex-wrap gap-4 mt-4">
                        <div className="flex flex-wrap gap-4 mt-2">
                          {/* LOCAL IMAGES */}
                          {(witnessStatementImgs[index] || []).map(
                            (imgObj, fileIdx) => {
                              const src =
                                imgObj instanceof File
                                  ? URL.createObjectURL(imgObj)
                                  : imgObj.preview || imgObj;

                              return (
                                <div
                                  key={"local-" + fileIdx}
                                  className="relative h-20 w-20 border rounded overflow-hidden"
                                >
                                  <img
                                    src={src}
                                    alt={`witness-local-${index}`}
                                    className="h-full w-full object-cover"
                                    onLoad={(e) => {
                                      if (imgObj instanceof File)
                                        URL.revokeObjectURL(e.target.src);
                                    }}
                                  />
                                  <button
                                    type="button"
                                    className="absolute -top-2 -right-2 bg-white text-red-600 rounded-full border border-red-600 p-1 hover:bg-red-600 hover:text-white"
                                    onClick={() =>
                                      handleWitnessImageRemove(index, fileIdx)
                                    }
                                  >
                                    ×
                                  </button>
                                </div>
                              );
                            },
                          )}

                          {/* SERVER IMAGES (EDIT MODE) */}
                          {(formData.witnessStatementImgs?.[index] || []).map(
                            (serverImg, sIdx) => (
                              <div
                                key={"server-" + sIdx}
                                className="relative h-20 w-20 border rounded overflow-hidden"
                              >
                                <img
                                  src={`https://hub2.ntactops.com/ntact/files/forms_files/${serverImg.file_name}`}
                                  alt={`witness-server-${index}`}
                                  className="h-full w-full object-cover"
                                />
                                <button
                                  type="button"
                                  className="absolute -top-2 -right-2 bg-white text-red-600 rounded-full border border-red-600 p-1 hover:bg-red-600 hover:text-white"
                                  onClick={() => {
                                    setFormData((prev) => {
                                      const updatedImages =
                                        prev.witnessStatementImgs?.[
                                          index
                                        ]?.filter(
                                          (img) =>
                                            img.file_name !==
                                            serverImg.file_name,
                                        ) || [];

                                      return {
                                        ...prev,
                                        witnessStatementImgs: {
                                          ...prev.witnessStatementImgs,
                                          [index]: updatedImages,
                                        },
                                      };
                                    });
                                  }}
                                >
                                  ×
                                </button>
                              </div>
                            ),
                          )}

                          {/* NO IMAGE PLACEHOLDER */}
                          {(!witnessStatementImgs[index] ||
                            witnessStatementImgs[index].length === 0) &&
                            (!formData.witnessStatementImgs?.[index] ||
                              formData.witnessStatementImgs[index].length ===
                                0) && (
                              <div className="h-20 w-20 flex items-center justify-center border rounded bg-gray-100 text-gray-400 text-xs">
                                No Images
                              </div>
                            )}
                        </div>
                      </div>
                    </div>

                    {/* Row 1 */}
                    <div className="flex gap-6 mb-6">
                      <div className="flex-1">
                        <label className="block font-bold mb-2 text-left">
                          {t("Job Title")}
                        </label>
                        <input
                          type="text"
                          value={statement.jobTitle}
                          onChange={(e) =>
                            handlewitnessStatementChange(
                              index,
                              "jobTitle",
                              e.target.value,
                            )
                          }
                          className="w-full p-2 border border-gray-300 rounded-md"
                          placeholder="Job Title"
                        />
                      </div>
                      <div className="flex-1">
                        <label className="block font-bold mb-2 text-left">
                          {t("Time in Craft")}
                        </label>
                        <input
                          type="text"
                          value={statement.timeInCraft}
                          onChange={(e) =>
                            handlewitnessStatementChange(
                              index,
                              "timeInCraft",
                              e.target.value,
                            )
                          }
                          className="w-full p-2 border border-gray-300 rounded-md"
                          placeholder="e.g. 2 years 3 months"
                        />
                      </div>
                      <div className="flex-1">
                        <label className="block font-bold mb-2 text-left">
                          {t("Time on Jobsite")}
                        </label>
                        <input
                          type="text"
                          value={statement.timeOnJobsite}
                          onChange={(e) =>
                            handlewitnessStatementChange(
                              index,
                              "timeOnJobsite",
                              e.target.value,
                            )
                          }
                          className="w-full p-2 border border-gray-300 rounded-md"
                          placeholder="e.g. 2 months"
                        />
                      </div>
                      <div className="flex-1">
                        <label className="block font-bold mb-2 text-left">
                          {t("Name")}
                        </label>
                        <input
                          type="text"
                          value={statement.name}
                          onChange={(e) =>
                            handlewitnessStatementChange(
                              index,
                              "name",
                              e.target.value,
                            )
                          }
                          className="w-full p-2 border border-gray-300 rounded-md"
                          placeholder="Name"
                        />
                      </div>
                    </div>

                    {/* Row 2 */}
                    <div className="mb-6">
                      <label className="block font-bold mb-2 text-left">
                        {t("Witness Statement")}
                      </label>
                      <textarea
                        value={statement.description}
                        onChange={(e) =>
                          handlewitnessStatementChange(
                            index,
                            "description",
                            e.target.value,
                          )
                        }
                        className="w-full p-2 border border-gray-300 rounded-md"
                        placeholder="Enter details here..."
                        rows={4}
                      />
                    </div>
                    {/* Row 3 */}
                    <div className="flex gap-6">
                      <div className="flex-1">
                        <label className="block font-bold mb-2 text-left">
                          {t("Signature")}
                        </label>
                        <input
                          type="text"
                          value={statement.signature}
                          onClick={() => {
                            type.current = "witnessStatement" + index;
                            setSignatureModal(true);
                          }}
                          className="w-full p-2 border border-gray-300 rounded-md"
                          placeholder="Signature"
                        />
                      </div>
                      <div className="flex-1">
                        <div className="flex flex-col">
                          <label className="block font-bold mb-2 text-left">
                            {t("Date")}
                          </label>
                          <DatePicker
                            selected={
                              statement.date
                                ? new Date(statement.date + "T00:00:00")
                                : null
                            }
                            onChange={(date) => {
                              const formattedDate = date
                                ? `${date.getFullYear()}-${String(
                                    date.getMonth() + 1,
                                  ).padStart(2, "0")}-${String(
                                    date.getDate(),
                                  ).padStart(2, "0")}`
                                : "";
                              handlewitnessStatementChange(
                                index,
                                "date",
                                formattedDate,
                              );
                            }}
                            dateFormat="MM-dd-yyyy"
                            maxDate={new Date()}
                            className="w-full p-2 border border-gray-300 rounded-md box-border pl-0"
                            placeholderText="MM-DD-YYYY"
                          />
                        </div>
                      </div>
                    </div>
                    {/* Signature preview */}
                    <div className="flex flex-col items-center p-4 border border-gray-300 rounded-md bg-white shadow-sm w-48 m-2">
                      <span className="text-sm font-medium text-gray-700 mb-3">
                        Witness Statement Signature {index + 1}
                      </span>

                      {witnessStatementsigns[index] &&
                      witnessStatementsigns[index].length > 0 ? (
                        <img
                          key={witnessStatementsigns[index][0].uniqueKey}
                          className="w-40 h-24 object-contain border border-gray-200 rounded-md bg-white mb-2"
                          src={
                            witnessStatementsigns[index][0].file instanceof File
                              ? URL.createObjectURL(
                                  witnessStatementsigns[index][0].file,
                                )
                              : witnessStatementsigns[index][0].preview
                          }
                          alt={`Witness Signature ${index}`}
                          onLoad={(e) => {
                            if (
                              witnessStatementsigns[index][0].file instanceof
                              File
                            ) {
                              URL.revokeObjectURL(e.target.src);
                            }
                          }}
                        />
                      ) : formData?.witnessStatementSigs?.[index]?.file_name ? (
                        <img
                          className="w-40 h-24 object-contain border border-gray-200 rounded-md bg-white mb-2"
                          src={`https://hub2.ntactops.com/ntact/files/forms_files/${formData.witnessStatementSigs[index].file_name}`}
                          alt={`Witness Signature ${index}`}
                        />
                      ) : (
                        <div className="w-40 h-24 flex items-center justify-center border border-gray-200 rounded-md bg-gray-100 text-gray-400 text-xs">
                          No signature
                        </div>
                      )}
                    </div>
                  </div>
                ))}

                {/* ===== Statement of Employee section ===== */}
                <div className="text-[15px] text-start font-semibold mt-8 mb-2">
                  {t("Statement of Employee")}
                </div>
                <div className="flex justify-end mb-2">
                  <button
                    onClick={handleAddEmployeeStatement}
                    disabled={!checkLastStatementFilled()}
                    className={`flex items-center gap-2 px-4 py-2 text-sm font-medium rounded bg-gray-800 text-white transition duration-200 ${
                      checkLastStatementFilled()
                        ? "hover:bg-gray-700 cursor-pointer"
                        : "opacity-50 cursor-not-allowed"
                    }`}
                  >
                    <span className="text-lg font-bold">+</span>
                  </button>
                </div>

                {formData.employeeStatements.map((statement, index) => (
                  <div
                    key={index}
                    className="p-6 mb-6"
                    style={{
                      borderRadius: "8px",
                      border: "1px solid #E4E4E7",
                      background: "#FFF",
                      boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
                    }}
                  >
                    {formData.employeeStatements.length > 1 && (
                      <div className="flex justify-end mb-2">
                        <button
                          onClick={() => handleRemoveStatement(index)}
                          className="text-red-600 font-medium text-sm hover:underline"
                        >
                          {t("Delete")}
                        </button>
                      </div>
                    )}

                    <div className="text-[15px] text-start font-semibold mb-4">
                      {t("Statement of Employee")} {index + 1}
                    </div>
                    {/* Row 4: Multiple image upload */}
                    <div className="mt-6">
                      <label className="block font-bold mb-2 text-left">
                        {t("Upload Images")}
                      </label>
                      <div className="relative inline-block flex justify-start">
                        <input
                          type="file"
                          id={`image-upload-${index}`}
                          accept="image/*"
                          multiple
                          onChange={(e) => handleMultipleImageUpload(e, index)}
                          className="hidden"
                        />
                        <label
                          htmlFor={`image-upload-${index}`}
                          className="inline-flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium text-gray-900 bg-gray-100 border border-gray-300 cursor-pointer hover:bg-gray-200"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1M12 12V4m0 0L8 8m4-4l4 4"
                            />
                          </svg>
                          Upload Image
                        </label>
                      </div>

                      <div className="flex flex-wrap gap-4 mt-4">
                        {/* 1️⃣ LOCAL IMAGES (from state) */}
                        {(employeeStatementImgs[index] || []).map(
                          (imgObj, imgIndex) => (
                            <div
                              key={imgObj.uniqueKey}
                              className="relative w-28 h-28 border rounded overflow-hidden"
                            >
                              <img
                                src={
                                  imgObj.file instanceof File
                                    ? URL.createObjectURL(imgObj.file)
                                    : imgObj.preview
                                }
                                className="w-full h-full object-cover"
                                alt={`local-${imgIndex}`}
                                onLoad={(e) => {
                                  if (imgObj.file instanceof File) {
                                    URL.revokeObjectURL(e.target.src);
                                  }
                                }}
                              />
                              <button
                                type="button"
                                onClick={() =>
                                  handleDeleteUploadedImage(
                                    index,
                                    imgObj.uniqueKey,
                                  )
                                }
                                className="absolute top-0 right-0 bg-red-600 text-white rounded-full w-6 h-6 text-sm flex items-center justify-center"
                              >
                                ×
                              </button>
                            </div>
                          ),
                        )}

                        {/* 2️⃣ SERVER IMAGES (edit mode) */}
                        {(formData.employeeStatementImgs?.[index] || []).map(
                          (serverImg, i) => (
                            <div
                              key={`server-${i}`}
                              className="relative w-28 h-28 border rounded overflow-hidden"
                            >
                              <img
                                src={`https://hub2.ntactops.com/ntact/files/forms_files/${serverImg.file_name}`}
                                alt={`server-${i}`}
                                className="w-full h-full object-cover"
                              />

                              {/* Delete button optional: only if you want server image removal */}

                              <button
                                type="button"
                                onClick={() => {
                                  setFormData((prev) => {
                                    const updatedList =
                                      prev.employeeStatementImgs?.[
                                        index
                                      ]?.filter(
                                        (img) =>
                                          img.file_name !== serverImg.file_name,
                                      ) || [];

                                    return {
                                      ...prev,
                                      employeeStatementImgs: {
                                        ...prev.employeeStatementImgs,
                                        [index]: updatedList,
                                      },
                                    };
                                  });
                                }}
                                className="absolute top-0 right-0 bg-red-600 text-white rounded-full w-6 h-6 text-sm flex items-center justify-center"
                              >
                                ×
                              </button>
                            </div>
                          ),
                        )}

                        {/* 3️⃣ NO IMAGE PLACEHOLDER (only if BOTH empty) */}
                        {(!employeeStatementImgs[index] ||
                          employeeStatementImgs[index].length === 0) &&
                          (!formData.employeeStatementImgs?.[index] ||
                            formData.employeeStatementImgs[index].length ===
                              0) && (
                            <div className="w-28 h-28 flex items-center justify-center border border-gray-200 rounded-md bg-gray-100 text-gray-400 text-xs">
                              No Images
                            </div>
                          )}
                      </div>
                    </div>
                    {/* Row 1 */}
                    <div className="flex gap-6 mb-6">
                      {/* Job Title */}
                      <div className="flex-1">
                        <label className="block font-bold mb-2 text-left">
                          {t("Job Title")}
                        </label>
                        <input
                          type="text"
                          value={statement.jobTitle}
                          onChange={(e) =>
                            handleStatementChange(
                              index,
                              "jobTitle",
                              e.target.value,
                            )
                          }
                          className="w-full p-2 border border-gray-300 rounded-md"
                          placeholder="Job Title"
                        />
                      </div>
                      {/* Time in Craft — free text (e.g. "2 years 3 months") */}
                      <div className="flex-1">
                        <label className="block font-bold mb-2 text-left">
                          {t("Time in Craft")}
                        </label>
                        <input
                          type="text"
                          value={statement.timeInCraft}
                          onChange={(e) =>
                            handleStatementChange(
                              index,
                              "timeInCraft",
                              e.target.value,
                            )
                          }
                          className="w-full p-2 border border-gray-300 rounded-md"
                          placeholder="e.g. 2 years 3 months"
                        />
                      </div>
                      {/* Time on Jobsite — free text */}
                      <div className="flex-1">
                        <label className="block font-bold mb-2 text-left">
                          {t("Time on Jobsite")}
                        </label>
                        <input
                          type="text"
                          value={statement.timeOnJobsite}
                          onChange={(e) =>
                            handleStatementChange(
                              index,
                              "timeOnJobsite",
                              e.target.value,
                            )
                          }
                          className="w-full p-2 border border-gray-300 rounded-md"
                          placeholder="e.g. 2 months"
                        />
                      </div>
                    </div>

                    {/* Row 2 */}
                    <div className="mb-6">
                      <label className="block font-bold mb-2 text-left">
                        {t("Employee Statement")}
                      </label>
                      <textarea
                        value={statement.description}
                        onChange={(e) =>
                          handleStatementChange(
                            index,
                            "description",
                            e.target.value,
                          )
                        }
                        className="w-full p-2 border border-gray-300 rounded-md"
                        placeholder="Enter details here..."
                        rows={4}
                      />
                    </div>

                    {/* Row 3 */}
                    <div className="flex gap-6">
                      <div className="flex-1">
                        <label className="block font-bold mb-2 text-left">
                          {t("Name")}
                        </label>
                        <input
                          type="text"
                          value={statement.name}
                          onChange={(e) =>
                            handleStatementChange(index, "name", e.target.value)
                          }
                          className="w-full p-2 border border-gray-300 rounded-md"
                          placeholder="Name"
                        />
                      </div>
                      <div className="flex-1">
                        <label className="block font-bold mb-2 text-left">
                          {t("Signature")}
                        </label>
                        <input
                          type="text"
                          value={statement.signature}
                          // onChange={(e) => handleStatementChange(index, 'signature', e.target.value)}
                          onClick={() => {
                            type.current = "employeeStatement" + index;
                            setSignatureModal(true);
                          }}
                          className="w-full p-2 border border-gray-300 rounded-md"
                          placeholder="Signature"
                        />
                      </div>
                      <div className="flex-1">
                        <div className="flex flex-col">
                          <label className="block font-bold mb-2 text-left">
                            {t("Date")}
                          </label>
                          <DatePicker
                            selected={
                              statement.date
                                ? new Date(statement.date + "T00:00:00")
                                : null
                            }
                            onChange={(date) => {
                              const formattedDate = date
                                ? `${date.getFullYear()}-${String(
                                    date.getMonth() + 1,
                                  ).padStart(2, "0")}-${String(
                                    date.getDate(),
                                  ).padStart(2, "0")}`
                                : "";
                              handleStatementChange(
                                index,
                                "date",
                                formattedDate,
                              );
                            }}
                            dateFormat="MM-dd-yyyy"
                            maxDate={new Date()}
                            className="w-full p-2 border border-gray-300 rounded-md box-border pl-0"
                            placeholderText="MM-DD-YYYY"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Signature preview for this specific card */}
                    <div className="flex flex-col items-center p-4 border border-gray-300 rounded-md bg-white shadow-sm w-48 m-2">
                      <span className="text-sm font-medium text-gray-700 mb-3">
                        Employee Statement Signature {index + 1}
                      </span>

                      {/* 1️⃣ CASE: Local uploaded signature exists */}
                      {employeeStatementsigns[index] &&
                      employeeStatementsigns[index].length > 0 ? (
                        <img
                          key={employeeStatementsigns[index][0].uniqueKey}
                          className="w-40 h-24 object-contain border border-gray-200 rounded-md bg-white mb-2"
                          src={
                            employeeStatementsigns[index][0].file instanceof
                            File
                              ? URL.createObjectURL(
                                  employeeStatementsigns[index][0].file,
                                )
                              : employeeStatementsigns[index][0].preview
                          }
                          alt={`Employee Statement Signature ${index}`}
                          onLoad={(e) => {
                            if (
                              employeeStatementsigns[index][0].file instanceof
                              File
                            ) {
                              URL.revokeObjectURL(e.target.src);
                            }
                          }}
                        />
                      ) : /* 2️⃣ CASE: Server image exists (EDIT MODE) */
                      formData?.employeeStatementSigs?.[index]?.file_name ? (
                        <img
                          className="w-40 h-24 object-contain border border-gray-200 rounded-md bg-white mb-2"
                          src={`https://hub2.ntactops.com/ntact/files/forms_files/${formData.employeeStatementSigs[index].file_name}`}
                          alt="Employee Statement Signature"
                        />
                      ) : (
                        /* 3️⃣ CASE: Nothing to show */
                        <div className="w-40 h-24 flex items-center justify-center border border-gray-200 rounded-md bg-gray-100 text-gray-400 text-xs">
                          No signature
                        </div>
                      )}
                    </div>
                  </div>
                ))}

                {/* ===== Supervisor Statement — its own repeatable section
                    (mirrors Witness Statement; mobile parity). ===== */}
                <div className="text-[15px] text-start font-semibold mt-8 mb-2">
                  {t("Supervisor Statement")}
                </div>
                <div className="flex justify-end mb-2">
                  <button
                    onClick={handleAddSupervisorStatement}
                    disabled={!checksupervisorLastStatementFilled()}
                    className={`flex items-center gap-2 px-4 py-2 text-sm font-medium rounded bg-gray-800 text-white transition duration-200 ${
                      checksupervisorLastStatementFilled()
                        ? "hover:bg-gray-700 cursor-pointer"
                        : "opacity-50 cursor-not-allowed"
                    }`}
                  >
                    <span className="text-lg font-bold">+</span>
                  </button>
                </div>

                {formData.supervisorStatements.map((statement, index) => (
                  <div
                    key={index}
                    className="p-6 mb-6"
                    style={{
                      borderRadius: "8px",
                      border: "1px solid #E4E4E7",
                      background: "#FFF",
                      boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
                    }}
                  >
                    {formData.supervisorStatements.length > 1 ? (
                      <div className="flex justify-end mb-2">
                        <button
                          onClick={() => handlesupervisorRemoveStatement(index)}
                          className="text-red-600 font-medium text-sm hover:underline"
                        >
                          {t("Delete")}
                        </button>
                      </div>
                    ) : (
                      <></>
                    )}
                    <div className="text-[15px] text-start font-semibold mb-4">
                      {t("Supervisor Statement")} {index + 1}
                    </div>

                    {/* Image Upload */}
                    <div className="mt-4">
                      <div className="w-full flex justify-start">
                        <label className="inline-flex items-center px-4 py-2 bg-gray-100 text-gray-800 text-sm font-medium rounded cursor-pointer border border-gray-300 hover:bg-gray-200">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1M12 12V4m0 0L8 8m4-4l4 4"
                            />
                          </svg>
                          {t("Upload Image")}
                          <input
                            type="file"
                            accept="image/*"
                            multiple
                            className="hidden"
                            onChange={(e) =>
                              handleSupervisorImageUpload(e, index)
                            }
                          />
                        </label>
                      </div>

                      <div className="flex flex-wrap gap-4 mt-4">
                        <div className="flex flex-wrap gap-4 mt-2">
                          {/* LOCAL IMAGES */}
                          {(supervisorStatementImgs[index] || []).map(
                            (imgObj, fileIdx) => {
                              const src =
                                imgObj instanceof File
                                  ? URL.createObjectURL(imgObj)
                                  : imgObj.preview || imgObj;
                              return (
                                <div
                                  key={"local-" + fileIdx}
                                  className="relative h-20 w-20 border rounded overflow-hidden"
                                >
                                  <img
                                    src={src}
                                    alt={`supervisor-local-${index}`}
                                    className="h-full w-full object-cover"
                                    onLoad={(e) => {
                                      if (imgObj instanceof File)
                                        URL.revokeObjectURL(e.target.src);
                                    }}
                                  />
                                  <button
                                    type="button"
                                    className="absolute -top-2 -right-2 bg-white text-red-600 rounded-full border border-red-600 p-1 hover:bg-red-600 hover:text-white"
                                    onClick={() =>
                                      handleSupervisorImageRemove(index, fileIdx)
                                    }
                                  >
                                    ×
                                  </button>
                                </div>
                              );
                            },
                          )}

                          {/* SERVER IMAGES (EDIT MODE) */}
                          {(formData.supervisorStatementImgs?.[index] || []).map(
                            (serverImg, sIdx) => (
                              <div
                                key={"server-" + sIdx}
                                className="relative h-20 w-20 border rounded overflow-hidden"
                              >
                                <img
                                  src={`https://hub2.ntactops.com/ntact/files/forms_files/${serverImg.file_name}`}
                                  alt={`supervisor-server-${index}`}
                                  className="h-full w-full object-cover"
                                />
                                <button
                                  type="button"
                                  className="absolute -top-2 -right-2 bg-white text-red-600 rounded-full border border-red-600 p-1 hover:bg-red-600 hover:text-white"
                                  onClick={() => {
                                    setFormData((prev) => {
                                      const updatedImages =
                                        prev.supervisorStatementImgs?.[
                                          index
                                        ]?.filter(
                                          (img) =>
                                            img.file_name !==
                                            serverImg.file_name,
                                        ) || [];
                                      return {
                                        ...prev,
                                        supervisorStatementImgs: {
                                          ...prev.supervisorStatementImgs,
                                          [index]: updatedImages,
                                        },
                                      };
                                    });
                                  }}
                                >
                                  ×
                                </button>
                              </div>
                            ),
                          )}

                          {/* NO IMAGE PLACEHOLDER */}
                          {(!supervisorStatementImgs[index] ||
                            supervisorStatementImgs[index].length === 0) &&
                            (!formData.supervisorStatementImgs?.[index] ||
                              formData.supervisorStatementImgs[index].length ===
                                0) && (
                              <div className="h-20 w-20 flex items-center justify-center border rounded bg-gray-100 text-gray-400 text-xs">
                                No Images
                              </div>
                            )}
                        </div>
                      </div>
                    </div>

                    {/* Row 1 */}
                    <div className="flex gap-6 mb-6">
                      <div className="flex-1">
                        <label className="block font-bold mb-2 text-left">
                          {t("Job Title")}
                        </label>
                        <input
                          type="text"
                          value={statement.jobTitle}
                          onChange={(e) =>
                            handlesupervisorStatementChange(
                              index,
                              "jobTitle",
                              e.target.value,
                            )
                          }
                          className="w-full p-2 border border-gray-300 rounded-md"
                          placeholder="Job Title"
                        />
                      </div>
                      <div className="flex-1">
                        <label className="block font-bold mb-2 text-left">
                          {t("Time in Craft")}
                        </label>
                        <input
                          type="text"
                          value={statement.timeInCraft}
                          onChange={(e) =>
                            handlesupervisorStatementChange(
                              index,
                              "timeInCraft",
                              e.target.value,
                            )
                          }
                          className="w-full p-2 border border-gray-300 rounded-md"
                          placeholder="e.g. 2 years 3 months"
                        />
                      </div>
                      <div className="flex-1">
                        <label className="block font-bold mb-2 text-left">
                          {t("Time on Jobsite")}
                        </label>
                        <input
                          type="text"
                          value={statement.timeOnJobsite}
                          onChange={(e) =>
                            handlesupervisorStatementChange(
                              index,
                              "timeOnJobsite",
                              e.target.value,
                            )
                          }
                          className="w-full p-2 border border-gray-300 rounded-md"
                          placeholder="e.g. 2 months"
                        />
                      </div>
                      <div className="flex-1">
                        <label className="block font-bold mb-2 text-left">
                          {t("Name")}
                        </label>
                        <input
                          type="text"
                          value={statement.name}
                          onChange={(e) =>
                            handlesupervisorStatementChange(
                              index,
                              "name",
                              e.target.value,
                            )
                          }
                          className="w-full p-2 border border-gray-300 rounded-md"
                          placeholder="Name"
                        />
                      </div>
                    </div>

                    {/* Row 2 */}
                    <div className="mb-6">
                      <label className="block font-bold mb-2 text-left">
                        {t("Supervisor Statement")}
                      </label>
                      <textarea
                        value={statement.description}
                        onChange={(e) =>
                          handlesupervisorStatementChange(
                            index,
                            "description",
                            e.target.value,
                          )
                        }
                        className="w-full p-2 border border-gray-300 rounded-md"
                        placeholder="Enter details here..."
                        rows={4}
                      />
                    </div>

                    {/* Row 3 */}
                    <div className="flex gap-6">
                      <div className="flex-1">
                        <label className="block font-bold mb-2 text-left">
                          {t("Signature")}
                        </label>
                        <input
                          type="text"
                          value={statement.signature}
                          onClick={() => {
                            type.current = "supervisorStatement" + index;
                            setSignatureModal(true);
                          }}
                          className="w-full p-2 border border-gray-300 rounded-md"
                          placeholder="Signature"
                        />
                      </div>
                      <div className="flex-1">
                        <div className="flex flex-col">
                          <label className="block font-bold mb-2 text-left">
                            {t("Date")}
                          </label>
                          <DatePicker
                            selected={
                              statement.date
                                ? new Date(statement.date + "T00:00:00")
                                : null
                            }
                            onChange={(date) => {
                              const formattedDate = date
                                ? `${date.getFullYear()}-${String(
                                    date.getMonth() + 1,
                                  ).padStart(2, "0")}-${String(
                                    date.getDate(),
                                  ).padStart(2, "0")}`
                                : "";
                              handlesupervisorStatementChange(
                                index,
                                "date",
                                formattedDate,
                              );
                            }}
                            dateFormat="MM-dd-yyyy"
                            maxDate={new Date()}
                            className="w-full p-2 border border-gray-300 rounded-md box-border pl-0"
                            placeholderText="MM-DD-YYYY"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Signature preview */}
                    <div className="flex flex-col items-center p-4 border border-gray-300 rounded-md bg-white shadow-sm w-48 m-2">
                      <span className="text-sm font-medium text-gray-700 mb-3">
                        Supervisor Statement Signature {index + 1}
                      </span>
                      {supervisorStatementsigns[index] &&
                      supervisorStatementsigns[index].length > 0 ? (
                        <img
                          key={supervisorStatementsigns[index][0].uniqueKey}
                          className="w-40 h-24 object-contain border border-gray-200 rounded-md bg-white mb-2"
                          src={
                            supervisorStatementsigns[index][0].file instanceof
                            File
                              ? URL.createObjectURL(
                                  supervisorStatementsigns[index][0].file,
                                )
                              : supervisorStatementsigns[index][0].preview
                          }
                          alt={`Supervisor Signature ${index}`}
                          onLoad={(e) => {
                            if (
                              supervisorStatementsigns[index][0].file instanceof
                              File
                            ) {
                              URL.revokeObjectURL(e.target.src);
                            }
                          }}
                        />
                      ) : formData?.supervisorStatementSigs?.[index]
                          ?.file_name ? (
                        <img
                          className="w-40 h-24 object-contain border border-gray-200 rounded-md bg-white mb-2"
                          src={`https://hub2.ntactops.com/ntact/files/forms_files/${formData.supervisorStatementSigs[index].file_name}`}
                          alt={`Supervisor Signature ${index}`}
                        />
                      ) : (
                        <div className="w-40 h-24 flex items-center justify-center border border-gray-200 rounded-md bg-gray-100 text-gray-400 text-xs">
                          No signature
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </>
            )}

            {/* Step 11 — Photos. */}
            {currentStep === 11 && (
              <>
                {/* Attachments — moved here from Step 3 (mobile parity). */}
                {renderAttachmentsSection()}

                <div className="flex justify-end mb-4 mt-6">
                  <button
                    onClick={handleAddPhotoStatement}
                    className="self-center w-8 h-8 rounded bg-gray-800 text-white flex items-center justify-center text-sm"
                  >
                    +
                  </button>
                </div>
                {formData.photoStatements.map((photo, index) => (
                  <div
                    key={index}
                    className="p-6 mb-6"
                    style={{
                      borderRadius: "8px",
                      border: "1px solid #E4E4E7",
                      background: "#FFF",
                      boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
                    }}
                  >
                    {/* Delete Card Button if more than 1 */}
                    <div className="flex justify-between">
                                    <div className="text-[15px] text-start font-semibold mb-4">
                  {t("Photo Information Sheet")} {index + 1}
                </div>
                    {formData.photoStatements.length > 1 && (
                      <div className="flex">
                        <button
                          className="self-center w-8 h-8 rounded bg-gray-800 text-white flex items-center justify-center text-sm"
                          onClick={() => handleDeletePhotoStatement(index)}
                        >
                          ×
                        </button>
                      </div>
                    )}
                    </div>
                    {/* Row 6 - Image Upload */}
                    {/* Row 6 - Image Upload */}
                    <div className="mt-4">
                      <div className="w-full flex justify-start">
                        {/* Upload Button Styled */}
                        <label className="inline-flex items-center px-4 py-2 bg-gray-100 text-gray-800 text-sm font-medium rounded cursor-pointer border border-gray-300 hover:bg-gray-200">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4 mr-2"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1M12 12V4m0 0L8 8m4-4l4 4"
                            />
                          </svg>
                          {t("Upload Image")}
                          <input
                            type="file"
                            accept="image/*"
                            multiple
                            className="hidden"
                            onChange={(e) =>
                              handlePhotoStatementImageUpload(e, index)
                            }
                          />
                        </label>
                      </div>

                      <div className="flex flex-wrap gap-4 mt-4">
                        <div className="flex flex-wrap gap-4 mt-4">
                          {/* 1️⃣ LOCAL IMAGES */}
                          {(photoStatementImgs[index] || []).map(
                            (imgObj, imgIndex) => (
                              <div
                                key={imgObj.uniqueKey}
                                className="relative w-28 h-28 border rounded overflow-hidden"
                              >
                                <img
                                  src={
                                    imgObj.file instanceof File
                                      ? URL.createObjectURL(imgObj.file)
                                      : imgObj.preview
                                  }
                                  alt={`photo-local-${imgIndex}`}
                                  className="w-full h-full object-cover"
                                  onLoad={(e) => {
                                    if (imgObj.file instanceof File) {
                                      URL.revokeObjectURL(e.target.src);
                                    }
                                  }}
                                />
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleDeleteImage(index, imgIndex)
                                  }
                                  className="absolute top-0 right-0 bg-red-600 text-white rounded-full w-6 h-6 text-sm flex items-center justify-center"
                                >
                                  ×
                                </button>
                              </div>
                            ),
                          )}

                          {/* 2️⃣ SERVER IMAGES (edit mode) */}
                          {(formData.photoStatementImgs?.[index] || []).map(
                            (serverImg, serverIdx) => (
                              <div
                                key={`server-${serverIdx}`}
                                className="relative w-28 h-28 border rounded overflow-hidden"
                              >
                                <img
                                  src={`https://hub2.ntactops.com/ntact/files/forms_files/${serverImg.file_name}`}
                                  alt={`photo-server-${serverIdx}`}
                                  className="w-full h-full object-cover"
                                />

                                {/* Optional delete for server images */}

                                <button
                                  type="button"
                                  onClick={() => {
                                    setFormData((prev) => {
                                      const updatedPhotos =
                                        prev.photoStatementImgs?.[
                                          index
                                        ]?.filter(
                                          (img) =>
                                            img.file_name !==
                                            serverImg.file_name,
                                        ) || [];

                                      return {
                                        ...prev,
                                        photoStatementImgs: {
                                          ...prev.photoStatementImgs,
                                          [index]: updatedPhotos,
                                        },
                                      };
                                    });
                                  }}
                                  className="absolute top-0 right-0 bg-red-600 text-white rounded-full w-6 h-6 text-sm flex items-center justify-center"
                                >
                                  ×
                                </button>
                              </div>
                            ),
                          )}

                          {/* 3️⃣ NO IMAGES PLACEHOLDER */}
                          {(!photoStatementImgs[index] ||
                            photoStatementImgs[index].length === 0) &&
                            (!formData.photoStatementImgs?.[index] ||
                              formData.photoStatementImgs[index].length ===
                                0) && (
                              <div className="w-28 h-28 flex items-center justify-center border border-gray-200 rounded-md bg-gray-100 text-gray-400 text-xs">
                                No Images
                              </div>
                            )}
                        </div>
                      </div>
                    </div>

                    {/* Row 1 */}
                    <div className="flex gap-6 mb-6">
                      <div className="flex-1">
                        <label className="block font-bold mb-2 text-left">
                          {t("Photo No")}
                        </label>
                        <input
                          type="text"
                          value={photo.photoNo}
                          onChange={(e) =>
                            updatePhotoField(index, "photoNo", e.target.value)
                          }
                          className="w-full p-2 border border-gray-300 rounded-md"
                          placeholder="Photo No"
                        />
                      </div>

                      <div className="flex-1 item-start">
                        <label className="block font-bold mb-2 text-left">
                          {t("Photo Date")}
                        </label>
                        <DatePicker
                          selected={
                            photo.photoDate
                              ? new Date(photo.photoDate + "T00:00:00")
                              : null
                          }
                          onChange={(date) => {
                            const formattedDate = date
                              ? `${date.getFullYear()}-${String(
                                  date.getMonth() + 1,
                                ).padStart(2, "0")}-${String(
                                  date.getDate(),
                                ).padStart(2, "0")}`
                              : "";
                            updatePhotoField(index, "photoDate", formattedDate);
                          }}
                          dateFormat="MM-dd-yyyy"
                          maxDate={new Date()}
                          placeholderText="MM-DD-YYYY"
                          className="w-full sm:min-w-[400px] p-2 border border-gray-300 rounded-md box-border pl-0"
                        />
                      </div>
                    </div>

                    {/* Row 2 */}
                    <div className="flex gap-6 mb-6">
                      <div className="flex-1">
                        <label className="block font-bold mb-2 text-left">
                          {t("Time of Day")}
                        </label>
                        <TimePicker
                          format="hh:mm aa"
                          showMeridiem
                          cleanable={false}
                          value={
                            photo.timeOfDay
                              ? new Date(`1970-01-01T${photo.timeOfDay}`)
                              : null
                          }
                          onChange={(value) => {
                            const timeStr = value
                              ? value.toTimeString().substring(0, 5)
                              : "";
                            updatePhotoField(index, "timeOfDay", timeStr);
                          }}
                          className="w-full rs-picker-cleanable"
                          placeholder="Select time"
                        />
                      </div>
                      <div className="flex-1">
                        <label className="block font-bold mb-2 text-left">
                          {t("Location")}
                        </label>
                        <input
                          type="text"
                          value={photo.location}
                          onChange={(e) =>
                            updatePhotoField(index, "location", e.target.value)
                          }
                          className="w-full p-2 border border-gray-300 rounded-md"
                          placeholder="Location"
                        />
                      </div>
                    </div>

                    {/* Row 3 - Description */}
                    <div className="mb-6">
                      <label className="block font-bold mb-2 text-left">
                        {t("Brief Description")} (
                        {t("Provide directions of photo")})
                      </label>
                      <textarea
                        value={photo.description}
                        onChange={(e) =>
                          updatePhotoField(index, "description", e.target.value)
                        }
                        className="w-full p-2 border border-gray-300 rounded-md"
                        placeholder="Enter description..."
                        rows={4}
                      />
                    </div>

                    {/* Row 4 - Notes */}
                    <div className="mb-6">
                      <label className="block font-bold mb-2 text-left">
                        {t("Notes")}
                      </label>
                      <textarea
                        value={photo.notes}
                        onChange={(e) =>
                          updatePhotoField(index, "notes", e.target.value)
                        }
                        className="w-full p-2 border border-gray-300 rounded-md"
                        placeholder="Enter notes..."
                        rows={2}
                      />
                    </div>

                    {/* Row 5 - Photographer */}
                    <div className="mb-6">
                      <label className="block font-bold mb-2 text-left">
                        {t("Photographer")}
                      </label>
                      <input
                        type="text"
                        value={photo.photographer}
                        onChange={(e) =>
                          updatePhotoField(
                            index,
                            "photographer",
                            e.target.value,
                          )
                        }
                        className="w-full p-2 border border-gray-300 rounded-md"
                        placeholder="Photographer Name"
                      />
                    </div>
                  </div>
                ))}

                {/* Add Button */}
              </>
            )}
            {currentStep === 12 && (
              <>
                {/* Step 12 — Motor Vehicle Accident Report. */}
                <div className="border p-6 text-start rounded-lg shadow-sm bg-white mb-4">
                  <div className="text-md font-bold mb-4">
                    {t("Do you want to fill Motor Vehicle Accident Report?")}
                  </div>
                  <div className="flex items-center gap-6">
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="fillMotorVehicle"
                        value="yes"
                        checked={!formData.isSkipVechileAccident}
                        onChange={() => setFormData(prev => ({ ...prev, isSkipVechileAccident: false }))}
                        className="accent-green-600 w-4 h-4"
                      />
                      <span className="text-sm font-semibold">{t("Yes")}</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="fillMotorVehicle"
                        value="no"
                        checked={formData.isSkipVechileAccident}
                        onChange={() => {
                          setFormData(prev => ({
                            ...prev,
                            isSkipVechileAccident: true,
                            motorVehicleReport: {
                              driverName: "",
                              isDriverApproved: "",
                              diagramimg: "",
                              licenseNumber: "",
                              issuingState: "",
                              licenseExpiration: "",
                              vehicleType: { ntactVehicle: false, ntactLeased: false, mobileEquipment: false },
                              vehicleDetails: { make: "", model: "", unitNumber: "", serialNumber: "", damageEstimate: "", additionalInfo: "" },
                              incidentDetails: { weatherConditions: "", speed: { employee: "", other: "", posted: "" }, nonEmployeeInjuries: "", propertyDamage: "", incidentDescription: "" },
                            },
                          }));
                        }}
                        className="accent-red-600 w-4 h-4"
                      />
                      <span className="text-sm font-semibold">{t("No")}</span>
                    </label>
                  </div>
                </div>

                {!formData.isSkipVechileAccident && (
                <>
                <div className="border p-6 text-start rounded-lg shadow-sm bg-white mb-4">
                  <div className="text-md font-bold mb-4">
                    {t("Company & Employee")}
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block font-semibold mb-1">
                        {t("Select Company")}
                      </label>
                      <select
                        className="w-full p-2 border border-gray-300 rounded-md text-sm font-inter"
                        value={formData.companyId || ""}
                        onChange={(e) => {
                          const selectedId = e.target.value
                            ? parseInt(e.target.value, 10)
                            : null;
                          setSelectedCompanyId(selectedId);
                          setFormData((prev) => ({
                            ...prev,
                            companyId: selectedId,
                          }));
                        }}
                      >
                        <option value="">{t("Select a Company")}</option>
                        {companyTabs.map((company) => (
                          <option key={company.id} value={company.id}>
                            {t(company.name)}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label className="block font-semibold mb-1">
                        {t("Employee ID")}
                      </label>
                      <input
                        type="text"
                        className="border p-2 rounded w-full text-sm"
                        placeholder={t("Enter Employee Id")}
                        value={formData.emp_Id || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            emp_Id: e.target.value,
                          }))
                        }
                      />
                    </div>
                  </div>
                </div>

                {/* DRIVER INFO */}

                <div className="border p-6 text-start rounded-lg shadow-sm bg-white my-4">
                  <div className="text-md font-bold mb-4">
                    {t("Driver Information")}
                  </div>
                  <div className="grid grid-cols-3 gap-4 mb-4">
                    <div>
                      <label className="block font-semibold mb-1">
                        {t("Driver Name")}
                      </label>
                      <input
                        type="text"
                        className="border p-2 rounded w-full"
                        value={formData.motorVehicleReport.driverName}
                        onChange={(e) =>
                          handleMotorReportChange("driverName", e.target.value)
                        }
                        placeholder={t("Enter driver name")}
                      />
                    </div>

                    <div className="col-span-2 flex items-center gap-4">
                      <span className="font-medium">
                        {t("Is Driver on NTACT Approved Driver List")}:
                      </span>
                      <label className="flex items-center gap-1">
                        <input
                          type="radio"
                          name="approved"
                          value="YES"
                          checked={
                            formData.motorVehicleReport.isDriverApproved ===
                            "YES"
                          }
                          onChange={() =>
                            handleMotorReportChange("isDriverApproved", "YES")
                          }
                        />
                        {t("YES")}
                      </label>
                      <label className="flex items-center gap-1">
                        <input
                          type="radio"
                          name="approved"
                          value="NO"
                          checked={
                            formData.motorVehicleReport.isDriverApproved ===
                            "NO"
                          }
                          onChange={() =>
                            handleMotorReportChange("isDriverApproved", "NO")
                          }
                        />
                        {t("NO")}
                      </label>
                    </div>

                    <div>
                      <label className="block font-semibold mb-1">
                        {t("Driver License Number")}
                      </label>
                      <input
                        type="text"
                        className="border p-2 rounded w-full"
                        value={formData.motorVehicleReport.licenseNumber}
                        placeholder={t("Enter license number")}
                        onChange={(e) =>
                          handleMotorReportChange(
                            "licenseNumber",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    <div>
                      <label className="block font-semibold mb-1">
                        {t("Issuing State")}
                      </label>
                      <input
                        type="text"
                        className="border p-2 rounded w-full"
                        placeholder={t("Enter issuing state")}
                        value={formData.motorVehicleReport.issuingState}
                        onChange={(e) =>
                          handleMotorReportChange(
                            "issuingState",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    <div>
                      <label className="block font-semibold mb-1">
                        {t("License Expiration")}
                      </label>
                      <DatePicker
                        selected={
                          formData.motorVehicleReport.licenseExpiration
                            ? new Date(
                                formData.motorVehicleReport.licenseExpiration,
                              )
                            : null
                        }
                        onChange={(date) =>
                          handleMotorReportChange(
                            "licenseExpiration",
                            date?.toISOString() ?? "",
                          )
                        }
                        dateFormat="MM-dd-yyyy"
                        className="w-full p-2 border border-gray-300 rounded-md"
                        placeholderText="MM-DD-YYYY"
                      />
                    </div>
                  </div>
                </div>

                {/* VEHICLE INFO */}
                <div className="border p-6 rounded-lg text-start shadow-sm bg-white my-4">
                  <div className="text-md font-bold mb-4">
                    {t("Vehicle Information")}
                  </div>

                  <label className="block font-semibold mb-1">
                    {t("Vehicle Type")}
                  </label>
                  <div className="flex gap-4 mb-4">
                    <label className="flex items-center gap-1">
                      <input
                        type="checkbox"
                        checked={
                          formData.motorVehicleReport.vehicleType.ntactVehicle
                        }
                        onChange={(e) =>
                          handleMotorReportChange(
                            "vehicleType.ntactVehicle",
                            e.target.checked,
                          )
                        }
                      />
                      {t("NTACT Vehicle")}
                    </label>
                    <label className="flex items-center gap-1">
                      <input
                        type="checkbox"
                        checked={
                          formData.motorVehicleReport.vehicleType.ntactLeased
                        }
                        onChange={(e) =>
                          handleMotorReportChange(
                            "vehicleType.ntactLeased",
                            e.target.checked,
                          )
                        }
                      />
                      {t("NTACT Leased Vehicle")}
                    </label>
                    <label className="flex items-center gap-1">
                      <input
                        type="checkbox"
                        checked={
                          formData.motorVehicleReport.vehicleType
                            .mobileEquipment
                        }
                        onChange={(e) =>
                          handleMotorReportChange(
                            "vehicleType.mobileEquipment",
                            e.target.checked,
                          )
                        }
                      />
                      {t("Mobile Equipment")}
                    </label>
                  </div>

                  <div className="grid grid-cols-3 gap-4">
                    <div>
                      <label className="block font-semibold mb-1">
                        {t("Make")}
                      </label>
                      <input
                        type="text"
                        placeholder={t("Enter make")}
                        className="border p-2 rounded w-full"
                        value={formData.motorVehicleReport.vehicleDetails.make}
                        onChange={(e) =>
                          handleMotorReportChange(
                            "vehicleDetails.make",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div>
                      <label className="block font-semibold mb-1">
                        {t("Model")}
                      </label>
                      <input
                        type="text"
                        placeholder={t("Enter model")}
                        className="border p-2 rounded w-full"
                        value={formData.motorVehicleReport.vehicleDetails.model}
                        onChange={(e) =>
                          handleMotorReportChange(
                            "vehicleDetails.model",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div>
                      <label className="block font-semibold mb-1">
                        {t("Unit Number")}
                      </label>
                      <input
                        type="text"
                        className="border p-2 rounded w-full"
                        placeholder={t("Enter unit number")}
                        value={
                          formData.motorVehicleReport.vehicleDetails.unitNumber
                        }
                        onChange={(e) =>
                          handleMotorReportChange(
                            "vehicleDetails.unitNumber",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div>
                      <label className="block font-semibold mb-1">
                        {t("Serial Number")}
                      </label>
                      <input
                        type="text"
                        className="border p-2 rounded w-full"
                        placeholder={t("Enter serial number")}
                        value={
                          formData.motorVehicleReport.vehicleDetails
                            .serialNumber
                        }
                        onChange={(e) =>
                          handleMotorReportChange(
                            "vehicleDetails.serialNumber",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div>
                      <label className="block font-semibold mb-1">
                        {t("Damage Estimate")}
                      </label>
                      <input
                        type="text"
                        className="border p-2 rounded w-full"
                        placeholder={t("Enter estimated damage cost")}
                        value={
                          formData.motorVehicleReport.vehicleDetails
                            .damageEstimate
                        }
                        onChange={(e) =>
                          handleMotorReportChange(
                            "vehicleDetails.damageEstimate",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                  </div>
                </div>

                {/* INCIDENT DETAILS */}
                <div className="border p-6 rounded-lg shadow-sm text-start bg-white my-4">
                  <div className="text-md font-bold mb-4">
                    {t("Speed Information")}
                  </div>

                  {/* Weather Conditions input removed — already captured on Step 1
          (Employee) under `formData.wheathercondition`. The mobile app
          doesn't duplicate it here. */}

                  <div className="mb-4">
                    {/* <label className="block font-semibold mb-1">{t("Approximate Vehicle Speed")}</label> */}
                    <div className="flex flex-col gap-2">
                      <div className="flex items-center gap-2">
                        <label className="font-medium">
                          {t("Employee Speed")}
                        </label>
                        <input
                          type="number"
                          className="border p-2 rounded w-20"
                          value={
                            formData.motorVehicleReport.incidentDetails.speed
                              .employee
                          }
                          onChange={(e) =>
                            handleMotorReportChange(
                              "incidentDetails.speed.employee",
                              e.target.value,
                            )
                          }
                          placeholder="MPH"
                        />
                        <span className="text-sm">MPH</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <label className="font-medium">
                          {t("Other Vehicle Speed")}
                        </label>
                        <input
                          type="number"
                          className="border p-2 rounded w-20"
                          value={
                            formData.motorVehicleReport.incidentDetails.speed
                              .other
                          }
                          onChange={(e) =>
                            handleMotorReportChange(
                              "incidentDetails.speed.other",
                              e.target.value,
                            )
                          }
                          placeholder="MPH"
                        />
                        <span className="text-sm">MPH</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <label className="font-medium">
                          {t("Post Speed Limit")}
                        </label>
                        <input
                          type="number"
                          className="border p-2 rounded w-20"
                          value={
                            formData.motorVehicleReport.incidentDetails.speed
                              .posted
                          }
                          onChange={(e) =>
                            handleMotorReportChange(
                              "incidentDetails.speed.posted",
                              e.target.value,
                            )
                          }
                          placeholder="MPH"
                        />
                        <span className="text-sm">MPH</span>
                      </div>
                    </div>
                  </div>
                  <label className="block font-semibold mb-4">
                    {t("Damage Information")}
                  </label>
                  <div className="grid grid-cols-2 gap-4 mb-4">
                    <div>
                      <label className="block font-semibold mb-1">
                        {t("Non-Employee Injuries / Damage")}
                      </label>
                      <textarea
                        className="border p-2 rounded w-full"
                        placeholder={t("Describe any non-employee injuries...")}
                        rows={2}
                        value={
                          formData.motorVehicleReport.incidentDetails
                            .nonEmployeeInjuries
                        }
                        onChange={(e) =>
                          handleMotorReportChange(
                            "incidentDetails.nonEmployeeInjuries",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                    <div>
                      <label className="block font-semibold mb-1">
                        {t("Non-Employee's Property Damage")}
                      </label>
                      <textarea
                        className="border p-2 rounded w-full"
                        placeholder={t("Describe property damage...")}
                        rows={2}
                        value={
                          formData.motorVehicleReport.incidentDetails
                            .propertyDamage
                        }
                        onChange={(e) =>
                          handleMotorReportChange(
                            "incidentDetails.propertyDamage",
                            e.target.value,
                          )
                        }
                      />
                    </div>
                  </div>
                  <label className="block font-semibold mb-4">
                    {t("Incident Description")}
                  </label>

                  <div className="flex gap-4 mb-4">
                    {/* Description of Incident */}

                    <div className="flex-1">
                      <label className="block font-semibold mb-1">
                        {t("Description of Incident")}
                      </label>
                      <textarea
                        className="border p-2 rounded w-full"
                        placeholder={t(
                          "Provide detailed description of the incident...",
                        )}
                        rows={6}
                        value={
                          formData.motorVehicleReport.incidentDetails
                            .incidentDescription
                        }
                        onChange={(e) =>
                          handleMotorReportChange(
                            "incidentDetails.incidentDescription",
                            e.target.value,
                          )
                        }
                      />
                    </div>

                    {/* Upload Incident Diagram */}
                    <div className="flex-1">
                      <label className="block font-semibold mb-1">
                        Diagram/Illustration
                      </label>

                      {/* 1️⃣ SHOW UPLOAD AREA ONLY IF NO LOCAL + NO SERVER IMAGE */}
                      {uploadedDiagram.length === 0 &&
                      !formData?.motorVehicleReport?.diagramimg?.file_name ? (
                        <label
                          htmlFor="imageUpload"
                          className="border-2 border-dashed border-gray-300 rounded-md h-full min-h-[150px] flex flex-col items-center justify-center text-gray-400 cursor-pointer hover:border-gray-400"
                        >
                          <FontAwesomeIcon
                            icon={faUpload}
                            className="text-2xl mb-2"
                          />
                          <span>Upload incident diagram</span>
                        </label>
                      ) : (
                        <div className="relative w-full max-w-md">
                          {/* 2️⃣ LOCAL IMAGE HAS PRIORITY */}
                          {uploadedDiagram.length > 0 ? (
                            <div className="relative">
                              <img
                                src={
                                  uploadedDiagram[0].file instanceof File
                                    ? URL.createObjectURL(
                                        uploadedDiagram[0].file,
                                      )
                                    : uploadedDiagram[0].previewUrl
                                }
                                alt="Diagram Preview"
                                className="rounded-md w-full max-h-[200px] object-contain"
                                onLoad={(e) => {
                                  if (uploadedDiagram[0].file instanceof File) {
                                    URL.revokeObjectURL(e.target.src);
                                  }
                                }}
                              />

                              {/* Delete Local Image */}
                              <button
                                onClick={removeUploadedDiagram}
                                className="absolute top-2 right-2 bg-red-500 text-white p-1 rounded-full text-xs opacity-80 hover:opacity-100"
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </button>
                            </div>
                          ) : formData.motorVehicleReport?.diagramimg
                              ?.file_name ? (
                            /* 3️⃣ SHOW SERVER IMAGE IF EXISTS */
                            <div className="relative">
                              <img
                                src={`https://hub2.ntactops.com/ntact/files/forms_files/${formData.motorVehicleReport.diagramimg.file_name}`}
                                alt="Diagram Preview"
                                className="rounded-md w-full max-h-[200px] object-contain"
                              />

                              {/* ❌ DELETE SERVER DIAGRAM */}
                              <button
                                onClick={() => {
                                  setFormData((prev) => ({
                                    ...prev,
                                    motorVehicleReport: {
                                      ...prev.motorVehicleReport,
                                      diagramimg: "", // REMOVE SERVER IMAGE
                                    },
                                  }));
                                }}
                                className="absolute top-2 right-2 bg-red-500 text-white p-1 rounded-full text-xs opacity-80 hover:opacity-100"
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </button>
                            </div>
                          ) : (
                            /* 4️⃣ NOTHING THERE → SHOW PLACEHOLDER */
                            <div className="w-full h-[160px] max-h-[200px] flex items-center justify-center border border-gray-300 bg-gray-100 text-gray-400 text-xs rounded-md">
                              No Diagram Uploaded
                            </div>
                          )}
                        </div>
                      )}

                      {/* Hidden file input */}
                      <input
                        type="file"
                        id="imageUpload"
                        accept="image/*"
                        onChange={handleDiagramUpload}
                        className="hidden"
                      />
                    </div>
                  </div>
                </div>
                </>
                )}
              </>
            )}

            {/* Step 4: Procedures, Programs & Management Systems */}
            {currentStep === 4 && (
              <div className="space-y-6">
                {/* <div className=" rounded-xl overflow-hidden"> */}
                  {/* <div className="bg-gray-900 px-4 py-3">
                    <h3 className="text-white font-semibold text-sm uppercase tracking-wider">1. Procedures, Programs & Management Systems</h3>
                  </div> */}
                  <div className="p-5">
                    <p className="text-sm text-start text-gray-500 mb-3">Select all that apply:</p>
                    <div className="space-y-2">
                      {formData.causalFactorsForm.proceduresProgramsManagement.options.map((option) => (
                        <label key={option} className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 cursor-pointer">
                          <input type="checkbox" className="mt-0.5 h-4 w-4 rounded border-gray-300 text-gray-900 accent-gray-900"
                            checked={formData.causalFactorsForm.proceduresProgramsManagement.selectedValues.includes(option)}
                            onChange={() => {
                              setFormData(prev => {
                                const sv = prev.causalFactorsForm.proceduresProgramsManagement.selectedValues;
                                const next = sv.includes(option) ? sv.filter(v => v !== option) : [...sv, option];
                                return {...prev, causalFactorsForm: {...prev.causalFactorsForm, proceduresProgramsManagement: {...prev.causalFactorsForm.proceduresProgramsManagement, selectedValues: next}}};
                              });
                            }}
                          />
                          <span className="text-sm text-gray-700">{option}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                {/* </div> */}
              </div>
            )}

            {/* Step 5: Human Factors */}
            {currentStep === 5 && (
              <div className="space-y-6">
                {/* <div className="border border-gray-200 rounded-xl overflow-hidden"> */}
                  {/* <div className="bg-gray-900 px-4 py-3">
                    <h3 className="text-white font-semibold text-sm uppercase tracking-wider">2. Human Factors</h3>
                  </div> */}
                  <div className="p-5">
                    <p className="text-sm text-start text-gray-500 mb-3">Select all that apply:</p>
                    <div className="space-y-2">
                      {formData.causalFactorsForm.humanFactors.options.map((option) => (
                        <label key={option} className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 cursor-pointer">
                          <input type="checkbox" className="mt-0.5 h-4 w-4 rounded border-gray-300 text-gray-900 accent-gray-900"
                            checked={formData.causalFactorsForm.humanFactors.selectedValues.includes(option)}
                            onChange={() => {
                              setFormData(prev => {
                                const sv = prev.causalFactorsForm.humanFactors.selectedValues;
                                const next = sv.includes(option) ? sv.filter(v => v !== option) : [...sv, option];
                                return {...prev, causalFactorsForm: {...prev.causalFactorsForm, humanFactors: {...prev.causalFactorsForm.humanFactors, selectedValues: next}}};
                              });
                            }}
                          />
                          <span className="text-sm text-gray-700">{option}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                {/* </div> */}
              </div>
            )}

            {/* Step 6: Work Direction & Communication */}
            {currentStep === 6 && (
              <div className="space-y-6">
                {/* <div className="border border-gray-200 rounded-xl overflow-hidden"> */}
                  {/* <div className="bg-gray-900 px-4 py-3">
                    <h3 className="text-white font-semibold text-sm uppercase tracking-wider">3. Work Direction & Communication</h3>
                  </div> */}
                  <div className="p-5">
                    <p className="text-sm text-start text-gray-500 mb-3">Select all that apply:</p>
                    <div className="space-y-2">
                      {formData.causalFactorsForm.workDirectionCommunication.options.map((option) => (
                        <label key={option} className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 cursor-pointer">
                          <input type="checkbox" className="mt-0.5 h-4 w-4 rounded border-gray-300 text-gray-900 accent-gray-900"
                            checked={formData.causalFactorsForm.workDirectionCommunication.selectedValues.includes(option)}
                            onChange={() => {
                              setFormData(prev => {
                                const sv = prev.causalFactorsForm.workDirectionCommunication.selectedValues;
                                const next = sv.includes(option) ? sv.filter(v => v !== option) : [...sv, option];
                                return {...prev, causalFactorsForm: {...prev.causalFactorsForm, workDirectionCommunication: {...prev.causalFactorsForm.workDirectionCommunication, selectedValues: next}}};
                              });
                            }}
                          />
                          <span className="text-sm text-gray-700">{option}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                {/* </div> */}
              </div>
            )}

            {/* Step 7: Work Environment */}
            {currentStep === 7 && (
              <div className="space-y-6">
                {/* <div className="border border-gray-200 rounded-xl overflow-hidden"> */}
                  {/* <div className="bg-gray-900 px-4 py-3">
                    <h3 className="text-white font-semibold text-sm uppercase tracking-wider">4. Work Environment</h3>
                  </div> */}
                  <div className="p-5">
                    <p className="text-sm text-start text-gray-500 mb-3">Select all that apply:</p>
                    <div className="space-y-2">
                      {formData.causalFactorsForm.workEnvironment.options.map((option) => (
                        <label key={option} className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 cursor-pointer">
                          <input type="checkbox" className="mt-0.5 h-4 w-4 rounded border-gray-300 text-gray-900 accent-gray-900"
                            checked={formData.causalFactorsForm.workEnvironment.selectedValues.includes(option)}
                            onChange={() => {
                              setFormData(prev => {
                                const sv = prev.causalFactorsForm.workEnvironment.selectedValues;
                                const next = sv.includes(option) ? sv.filter(v => v !== option) : [...sv, option];
                                return {...prev, causalFactorsForm: {...prev.causalFactorsForm, workEnvironment: {...prev.causalFactorsForm.workEnvironment, selectedValues: next}}};
                              });
                            }}
                          />
                          <span className="text-sm text-gray-700">{option}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                {/* </div> */}
              </div>
            )}

            {/* Step 8: Transportation */}
            {currentStep === 8 && (
              <div className="space-y-6">
                {/* <div className="border border-gray-200 rounded-xl overflow-hidden"> */}
                  {/* <div className="bg-gray-900 px-4 py-3">
                    <h3 className="text-white font-semibold text-sm uppercase tracking-wider">5. Transportation</h3>
                  </div> */}
                  <div className="p-5">
                    <p className="text-sm text-start text-gray-500 mb-3">Select all that apply:</p>
                    <div className="space-y-2">
                      {formData.causalFactorsForm.transportation.options.map((option) => (
                        <label key={option} className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 cursor-pointer">
                          <input type="checkbox" className="mt-0.5 h-4 w-4 rounded border-gray-300 text-gray-900 accent-gray-900"
                            checked={formData.causalFactorsForm.transportation.selectedValues.includes(option)}
                            onChange={() => {
                              setFormData(prev => {
                                const sv = prev.causalFactorsForm.transportation.selectedValues;
                                const next = sv.includes(option) ? sv.filter(v => v !== option) : [...sv, option];
                                return {...prev, causalFactorsForm: {...prev.causalFactorsForm, transportation: {...prev.causalFactorsForm.transportation, selectedValues: next}}};
                              });
                            }}
                          />
                          <span className="text-sm text-gray-700">{option}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                {/* </div> */}
              </div>
            )}

            {/* Step 9: Results — Lessons Learned & Corrective Actions */}
            {currentStep === 9 && (
              <div className="space-y-6">
                {/* Lessons Learned */}
                <div className="border border-gray-200 rounded-xl overflow-hidden">
                  <div className="bg-gray-900 px-4 py-3">
                    <h3 className="text-white text-start font-semibold text-sm uppercase tracking-wider">Lessons Learned</h3>
                  </div>
                  <div className="p-5 space-y-4">
                    <div>
                      <label className="block text-start text-sm font-medium text-gray-700 mb-1">Key Lessons <span className="text-red-600">*</span></label>
                      <textarea className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm" rows={4} placeholder="Summarize what was learned from this incident..."
                        value={formData.causalFactorsForm.lessonsLearned.key_lessons}
                        onChange={(e) => setFormData(prev => ({...prev, causalFactorsForm: {...prev.causalFactorsForm, lessonsLearned: {...prev.causalFactorsForm.lessonsLearned, key_lessons: e.target.value}}}))}
                      />
                    </div>
                  </div>
                </div>
                {/* Corrective Actions */}
                <div className="border border-gray-200 rounded-xl overflow-hidden">
                  <div className="bg-gray-900 px-4 py-3">
                    <h3 className="text-white text-start font-semibold text-sm uppercase tracking-wider">Corrective Actions</h3>
                  </div>
                  <div className="p-5 space-y-4">
                    <div>
                      <label className="block text-start text-sm font-medium text-gray-700 mb-1">Immediate Action Details <span className="text-red-600">*</span></label>
                      <textarea className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm" rows={4} placeholder="Describe actions taken immediately after the event..."
                        value={formData.causalFactorsForm.correctiveActions.immediate_action_details}
                        onChange={(e) => setFormData(prev => ({...prev, causalFactorsForm: {...prev.causalFactorsForm, correctiveActions: {...prev.causalFactorsForm.correctiveActions, immediate_action_details: e.target.value}}}))}
                      />
                    </div>
                    <div>
                      <label className="block text-start text-sm font-medium text-gray-700 mb-1">Target Completion Date <span className="text-red-600">*</span></label>
                      <input type="date" className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
                        value={formData.causalFactorsForm.correctiveActions.target_completion_date}
                        onChange={(e) => setFormData(prev => ({...prev, causalFactorsForm: {...prev.causalFactorsForm, correctiveActions: {...prev.causalFactorsForm.correctiveActions, target_completion_date: e.target.value}}}))}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="p-6 flex justify-between">
            {currentStep > 1 && (
              <button
                onClick={prevStep}
                className="bg-white border border-gray-300 text-black font-bold py-2 px-6 rounded hover:bg-gray-100"
              >
                ← {t("Previous")}
              </button>
            )}
            <button
              onClick={nextStep}
              className="bg-[#DC2626] text-white font-semibold py-2 px-6 rounded hover:bg-red-600 ml-auto"
            >
              {currentStep === 12 ? t("Submit") : `${t("Next")} →`}
            </button>
          </div>
        </div>
      </div>
      <ToastMessage
        message={alertMessage}
        severity={severity}
        open={open}
        handleClose={handleCloseToast}
      />
      <ConfirmModal
        type={"submit"}
        isOpen={ConfirmModalOpen}
        onClose={() => {
          setConfirmModalOpen(false);
        }}
        onSubmit={() => {
          handleSubmit();
        }}
      />
      <SignatureModal
        isModal={signaturemodal}
        setModal={setSignatureModal}
        onSave={HandleSignature}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default AccidentAndInvesticationForm;
